/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput | null | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    register(input: RegisterInput | null | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPasswordRequest(input: ResetPasswordRequestInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPasswordRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetPasswordRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAddressDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param cityId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserUnAssignedAddresses(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, cityId: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GetUserUnAssignedAddresses?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (authorizationId !== undefined)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedAddresses(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedAddresses(response: HttpResponseBase): Observable<PagedResultDtoOfAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAddressDto>(<any>null);
    }

    /**
     * @param cityId (optional) 
     * @param categoryIds (optional) 
     * @return Success
     */
    getListBy(cityId: number | null | undefined, categoryIds: number[] | null | undefined): Observable<AddressDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GetListBy?";
        if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "categoryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListBy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListBy(<any>response_);
                } catch (e) {
                    return <Observable<AddressDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetListBy(response: HttpResponseBase): Observable<AddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto[]>(<any>null);
    }

    /**
     * @param address (optional) 
     * @param cityId (optional) 
     * @return Success
     */
    checkSimilarityAddresses(address: AddressSimilarityDto | null | undefined, cityId: number | null | undefined): Observable<AddressSimilarityResultDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/CheckSimilarityAddresses?";
        if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSimilarityAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSimilarityAddresses(<any>response_);
                } catch (e) {
                    return <Observable<AddressSimilarityResultDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressSimilarityResultDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCheckSimilarityAddresses(response: HttpResponseBase): Observable<AddressSimilarityResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AddressSimilarityResultDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressSimilarityResultDto[]>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    generateCustomerAddressDraftExcel(customerId: number | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/GenerateCustomerAddressDraftExcel?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCustomerAddressDraftExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCustomerAddressDraftExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateCustomerAddressDraftExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadCustomerAddressExcel(input: CustomerAddressExcelUploadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/UploadCustomerAddressExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCustomerAddressExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCustomerAddressExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCustomerAddressExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateAddressDto | null | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: AddressDto | null | undefined): Observable<AddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Address/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AdminToolsTranspopPortalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param orderDetailId (optional) 
     * @return Success
     */
    orderQueueManualSync(orderDetailId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AdminToolsTranspopPortal/OrderQueueManualSync?";
        if (orderDetailId !== undefined)
            url_ += "orderDetailId=" + encodeURIComponent("" + orderDetailId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderQueueManualSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderQueueManualSync(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processOrderQueueManualSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    logTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AdminToolsTranspopPortal/LogTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AuthorizationTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuthorizationDomainAuthTypeDto>(<any>null);
    }

    /**
     * @param table (optional) 
     * @return Success
     */
    getAuthorizationsByTable(table: Table | null | undefined): Observable<AuthorizationDomainAuthTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/GetAuthorizationsByTable?";
        if (table !== undefined)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorizationsByTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorizationsByTable(<any>response_);
                } catch (e) {
                    return <Observable<AuthorizationDomainAuthTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationDomainAuthTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuthorizationsByTable(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AuthorizationDomainAuthTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto[]>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserUnAssignedAuthorizations(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/GetUserUnAssignedAuthorizations?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedAuthorizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedAuthorizations(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedAuthorizations(response: HttpResponseBase): Observable<PagedResultDtoOfAuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuthorizationDomainAuthTypeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<AuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AuthorizationDomainAuthTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationDomainAuthTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateAuthorizationTypeDto | null | undefined): Observable<AuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AuthorizationDomainAuthTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationDomainAuthTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: AuthorizationDomainAuthTypeDto | null | undefined): Observable<AuthorizationDomainAuthTypeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AuthorizationDomainAuthTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationDomainAuthTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AuthorizationDomainAuthTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizationDomainAuthTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDomainAuthTypeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/AuthorizationType/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param categoryType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, categoryType: CategoryType | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (categoryType !== undefined)
            url_ += "CategoryType=" + encodeURIComponent("" + categoryType) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCategoryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCategoryDto | null | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CategoryDto | null | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Category/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCityDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param authorizationId (optional) 
     * @param exceptTurkey (optional) 
     * @return Success
     */
    getUserUnAssignedCities(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, authorizationId: number | null | undefined, exceptTurkey: boolean | null | undefined): Observable<PagedResultDtoOfCityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/GetUserUnAssignedCities?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (authorizationId !== undefined)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        if (exceptTurkey !== undefined)
            url_ += "exceptTurkey=" + encodeURIComponent("" + exceptTurkey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedCities(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedCities(response: HttpResponseBase): Observable<PagedResultDtoOfCityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCityDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCityDto | null | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CityDto | null | undefined): Observable<CityDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CityDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CityDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/City/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeUiTheme(input: ChangeUiThemeInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param excludedCustomerIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, excludedCustomerIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (excludedCustomerIds !== undefined)
            excludedCustomerIds && excludedCustomerIds.forEach(item => { url_ += "ExcludedCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCustomerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCustomerDto | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CustomerDto | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getProductUsagePurposeTypesByCustomer(customerId: number | null | undefined): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetProductUsagePurposeTypesByCustomer?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductUsagePurposeTypesByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductUsagePurposeTypesByCustomer(<any>response_);
                } catch (e) {
                    return <Observable<SelectListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductUsagePurposeTypesByCustomer(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param excludedCustomerIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, excludedCustomerIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfCustomerExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetAllForExcel?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (excludedCustomerIds !== undefined)
            excludedCustomerIds && excludedCustomerIds.forEach(item => { url_ += "ExcludedCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelPagedResultDtoOfCustomerExcelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelPagedResultDtoOfCustomerExcelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfCustomerExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfCustomerExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfCustomerExcelDto>(<any>null);
    }

    /**
     * @param selectedItem (optional) 
     * @return Success
     */
    getCustomerComboboxItems(selectedItem: number | null | undefined): Observable<ListResultDtoOfComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetCustomerComboboxItems?";
        if (selectedItem !== undefined)
            url_ += "selectedItem=" + encodeURIComponent("" + selectedItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfComboboxItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfComboboxItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerComboboxItems(response: HttpResponseBase): Observable<ListResultDtoOfComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfComboboxItemDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param excludedCustomerIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserUnAssignedCustomer(keyword: string | null | undefined, sorting: string | null | undefined, excludedCustomerIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined): Observable<PagedResultDtoOfCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetUserUnAssignedCustomer?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (excludedCustomerIds !== undefined)
            excludedCustomerIds && excludedCustomerIds.forEach(item => { url_ += "ExcludedCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedCustomer(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedCustomer(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCustomerDto>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getWarehousesByCustomer(customerId: number | null | undefined): Observable<CustomerWarehouseListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetWarehousesByCustomer?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesByCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesByCustomer(<any>response_);
                } catch (e) {
                    return <Observable<CustomerWarehouseListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerWarehouseListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWarehousesByCustomer(response: HttpResponseBase): Observable<CustomerWarehouseListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerWarehouseListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerWarehouseListDto[]>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getPersonInCharges(customerId: number | null | undefined): Observable<CustomerPersonOfChargeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetPersonInCharges?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonInCharges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonInCharges(<any>response_);
                } catch (e) {
                    return <Observable<CustomerPersonOfChargeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerPersonOfChargeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonInCharges(response: HttpResponseBase): Observable<CustomerPersonOfChargeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerPersonOfChargeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPersonOfChargeDto[]>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerUsers(customerId: number | null | undefined): Observable<CustomerUserListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Customer/GetCustomerUsers?";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerUsers(<any>response_);
                } catch (e) {
                    return <Observable<CustomerUserListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerUserListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerUsers(response: HttpResponseBase): Observable<CustomerUserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerUserListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerUserListDto[]>(<any>null);
    }
}

@Injectable()
export class CustomerThemeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param customerId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, customerId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCustomerThemeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCustomerThemeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCustomerThemeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<CustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CustomerThemeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerThemeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCustomerThemeDto | null | undefined): Observable<CustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CustomerThemeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerThemeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateCustomerThemeDto | null | undefined): Observable<CustomerThemeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CustomerThemeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerThemeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerThemeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCustomerThemeLogoSizes(): Observable<CustomerThemeSizeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/CustomerTheme/GetCustomerThemeLogoSizes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerThemeLogoSizes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerThemeLogoSizes(<any>response_);
                } catch (e) {
                    return <Observable<CustomerThemeSizeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerThemeSizeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerThemeLogoSizes(response: HttpResponseBase): Observable<CustomerThemeSizeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerThemeSizeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerThemeSizeDto>(<any>null);
    }
}

@Injectable()
export class DatasetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfDatasetDto> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDatasetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfDatasetDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDatasetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDatasetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDatasetDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateDatasetDto | null | undefined): Observable<DatasetDto> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DatasetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DatasetDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DatasetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatasetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DatasetDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    generateDatasetExcelDraft(): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/GenerateDatasetExcelDraft";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateDatasetExcelDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateDatasetExcelDraft(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateDatasetExcelDraft(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param datasetGuid (optional) 
     * @return Success
     */
    generateDatasetLocationsExcel(datasetGuid: string | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/GenerateDatasetLocationsExcel?";
        if (datasetGuid !== undefined)
            url_ += "datasetGuid=" + encodeURIComponent("" + datasetGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateDatasetLocationsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateDatasetLocationsExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateDatasetLocationsExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    getVehicleTypes(): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/GetVehicleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleTypes(<any>response_);
                } catch (e) {
                    return <Observable<SelectListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleTypes(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(<any>null);
    }

    /**
     * @param vehicleId (optional) 
     * @return Success
     */
    getVehicleMaps(vehicleId: number | null | undefined): Observable<VehicleMapDto[]> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/GetVehicleMaps?";
        if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleMaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleMaps(<any>response_);
                } catch (e) {
                    return <Observable<VehicleMapDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<VehicleMapDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetVehicleMaps(response: HttpResponseBase): Observable<VehicleMapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VehicleMapDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleMapDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<DatasetDto> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DatasetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DatasetDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DatasetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatasetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DatasetDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: DatasetDto | null | undefined): Observable<DatasetDto> {
        let url_ = this.baseUrl + "/api/services/smr/Dataset/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DatasetDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DatasetDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DatasetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatasetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DatasetDto>(<any>null);
    }
}

@Injectable()
export class DeliveryConfirmServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfDeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDeliveryConfirmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfDeliveryConfirmDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDeliveryConfirmDto>(<any>null);
    }

    /**
     * @param cariHareketGuid (optional) 
     * @return Success
     */
    getDeliveryConfirmForApprove(cariHareketGuid: string | null | undefined): Observable<DeliveryConfirmDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/GetDeliveryConfirmForApprove?";
        if (cariHareketGuid !== undefined)
            url_ += "cariHareketGuid=" + encodeURIComponent("" + cariHareketGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryConfirmForApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryConfirmForApprove(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryConfirmDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryConfirmDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeliveryConfirmForApprove(response: HttpResponseBase): Observable<DeliveryConfirmDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DeliveryConfirmDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateDeliveryConfirmDto | null | undefined): Observable<DeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryConfirmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryConfirmDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: DeliveryConfirmDto | null | undefined): Observable<DeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryConfirmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryConfirmDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto>(<any>null);
    }

    /**
     * @param inputList (optional) 
     * @return Success
     */
    updateApprovedQuantity(inputList: ApprovedQuantityDataInputDto[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/UpdateApprovedQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApprovedQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApprovedQuantity(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateApprovedQuantity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<DeliveryConfirmDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/DeliveryConfirm/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DeliveryConfirmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DeliveryConfirmDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DeliveryConfirmDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeliveryConfirmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryConfirmDto>(<any>null);
    }
}

@Injectable()
export class GoogleMapsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    generateAddressConverterDraftExcel(): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/GenerateAddressConverterDraftExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAddressConverterDraftExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAddressConverterDraftExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAddressConverterDraftExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadAddressConverterExcel(input: SRGMapsAddressConverterExcelUploadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/UploadAddressConverterExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAddressConverterExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAddressConverterExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadAddressConverterExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    generateCoordinateConverterDraftExcel(): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/GenerateCoordinateConverterDraftExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCoordinateConverterDraftExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCoordinateConverterDraftExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateCoordinateConverterDraftExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadCoordinateConverterExcel(input: SRGMapsAddressConverterExcelUploadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/UploadCoordinateConverterExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCoordinateConverterExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCoordinateConverterExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadCoordinateConverterExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    generateLocationViewerDraftExcel(): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/GenerateLocationViewerDraftExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateLocationViewerDraftExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateLocationViewerDraftExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateLocationViewerDraftExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadLocationViewerExcel(input: SRLocationViewerExcelUploadDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/UploadLocationViewerExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLocationViewerExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLocationViewerExcel(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadLocationViewerExcel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param uploadedExcelId (optional) 
     * @return Success
     */
    locationViewer(uploadedExcelId: number | null | undefined): Observable<SRLocationViewerUploadDto[]> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/LocationViewer?";
        if (uploadedExcelId !== undefined)
            url_ += "uploadedExcelId=" + encodeURIComponent("" + uploadedExcelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLocationViewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationViewer(<any>response_);
                } catch (e) {
                    return <Observable<SRLocationViewerUploadDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SRLocationViewerUploadDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processLocationViewer(response: HttpResponseBase): Observable<SRLocationViewerUploadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SRLocationViewerUploadDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SRLocationViewerUploadDto[]>(<any>null);
    }

    /**
     * @param uploadedExcelId (optional) 
     * @param polygon (optional) 
     * @return Success
     */
    generateLocationsInPolygonExcel(uploadedExcelId: number | null | undefined, polygon: SRGmapsPolygon[] | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/GoogleMaps/GenerateLocationsInPolygonExcel?";
        if (uploadedExcelId !== undefined)
            url_ += "uploadedExcelId=" + encodeURIComponent("" + uploadedExcelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(polygon);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateLocationsInPolygonExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateLocationsInPolygonExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateLocationsInPolygonExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }
}

@Injectable()
export class JobScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    schedulePortalV2RequestApproveTaskJob(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/JobSchedule/SchedulePortalV2RequestApproveTaskJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulePortalV2RequestApproveTaskJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulePortalV2RequestApproveTaskJob(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSchedulePortalV2RequestApproveTaskJob(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    scheduleLoadDeliveryConfirmData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/JobSchedule/ScheduleLoadDeliveryConfirmData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleLoadDeliveryConfirmData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleLoadDeliveryConfirmData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processScheduleLoadDeliveryConfirmData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LogisticsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param transpopCariId (optional) 
     * @return Success
     */
    addCariTranspopToPlatom(transpopCariId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddCariTranspopToPlatom?";
        if (transpopCariId !== undefined)
            url_ += "transpopCariId=" + encodeURIComponent("" + transpopCariId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCariTranspopToPlatom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCariTranspopToPlatom(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddCariTranspopToPlatom(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param transpopCariId (optional) 
     * @return Success
     */
    updateCariPlatomToTranspop(transpopCariId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/UpdateCariPlatomToTranspop?";
        if (transpopCariId !== undefined)
            url_ += "transpopCariId=" + encodeURIComponent("" + transpopCariId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCariPlatomToTranspop(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCariPlatomToTranspop(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCariPlatomToTranspop(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addPersonlMasraf(input: CreateMasrafDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddPersonlMasraf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonlMasraf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonlMasraf(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddPersonlMasraf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addSatinalmaTalebi(input: CreateSatinalmaTalepDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddSatinalmaTalebi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSatinalmaTalebi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSatinalmaTalebi(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddSatinalmaTalebi(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param satialmaTalepKodu (optional) 
     * @return Success
     */
    getSatinalmaTalepFaturaBilgileri(satialmaTalepKodu: string | null | undefined): Observable<SatinalmaTalepFaturaBilgiDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/GetSatinalmaTalepFaturaBilgileri?";
        if (satialmaTalepKodu !== undefined)
            url_ += "satialmaTalepKodu=" + encodeURIComponent("" + satialmaTalepKodu) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSatinalmaTalepFaturaBilgileri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSatinalmaTalepFaturaBilgileri(<any>response_);
                } catch (e) {
                    return <Observable<SatinalmaTalepFaturaBilgiDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SatinalmaTalepFaturaBilgiDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSatinalmaTalepFaturaBilgileri(response: HttpResponseBase): Observable<SatinalmaTalepFaturaBilgiDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SatinalmaTalepFaturaBilgiDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SatinalmaTalepFaturaBilgiDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addPersonelMasraf(input: CreateMasrafDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Logistics/AddPersonelMasraf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPersonelMasraf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPersonelMasraf(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddPersonelMasraf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class MetabaseDynamicReportDesignServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param moduleId (optional) 
     * @return Success
     */
    getReports(moduleId: number | null | undefined): Observable<ReportObjectDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/GetReports?";
        if (moduleId !== undefined)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReports(<any>response_);
                } catch (e) {
                    return <Observable<ReportObjectDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportObjectDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReports(response: HttpResponseBase): Observable<ReportObjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportObjectDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportObjectDto[]>(<any>null);
    }

    /**
     * @param reportModel (optional) 
     * @return Success
     */
    updateReport(reportModel: ReportObjectDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/UpdateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reportModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReport(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFilterDataSource(id: number | null | undefined): Observable<ReportDataSourceDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/GetFilterDataSource?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterDataSource(<any>response_);
                } catch (e) {
                    return <Observable<ReportDataSourceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportDataSourceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilterDataSource(response: HttpResponseBase): Observable<ReportDataSourceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDataSourceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDataSourceDto>(<any>null);
    }

    /**
     * @param dataSourceModel (optional) 
     * @return Success
     */
    updateFilterDataSource(dataSourceModel: ReportDataSourceDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/UpdateFilterDataSource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSourceModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFilterDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFilterDataSource(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFilterDataSource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllDataSource(): Observable<ReportDataSourceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseDynamicReportDesign/GetAllDataSource";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDataSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDataSource(<any>response_);
                } catch (e) {
                    return <Observable<ReportDataSourceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportDataSourceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDataSource(response: HttpResponseBase): Observable<ReportDataSourceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReportDataSourceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDataSourceDto[]>(<any>null);
    }
}

@Injectable()
export class MetabaseTranspopPortalDynamicFilterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getReportMetadata(reportId: number | null | undefined): Observable<ReportObjectDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalDynamicFilter/GetReportMetadata?";
        if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportMetadata(<any>response_);
                } catch (e) {
                    return <Observable<ReportObjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportObjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReportMetadata(response: HttpResponseBase): Observable<ReportObjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportObjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportObjectDto>(<any>null);
    }

    /**
     * @param targetFilterInput (optional) 
     * @return Success
     */
    loadDrildownFilterData(targetFilterInput: ReportFilterDto | null | undefined): Observable<ReportFilterDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalDynamicFilter/LoadDrildownFilterData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targetFilterInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadDrildownFilterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadDrildownFilterData(<any>response_);
                } catch (e) {
                    return <Observable<ReportFilterDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportFilterDto>><any>_observableThrow(response_);
        }));
    }

    protected processLoadDrildownFilterData(response: HttpResponseBase): Observable<ReportFilterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportFilterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportFilterDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createPlatomPortalDashboardUrl(input: ReportObjectDto | null | undefined): Observable<MetabaseDashboardOutputDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalDynamicFilter/CreatePlatomPortalDashboardUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlatomPortalDashboardUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlatomPortalDashboardUrl(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseDashboardOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseDashboardOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePlatomPortalDashboardUrl(response: HttpResponseBase): Observable<MetabaseDashboardOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutputDto>(<any>null);
    }
}

@Injectable()
export class MetabaseTranspopPortalFilterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserWarehouseFilters(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserWarehouseFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWarehouseFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWarehouseFilters(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserWarehouseFilters(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDamageStatusFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetDamageStatusFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamageStatusFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamageStatusFilters(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDamageStatusFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMovementTypeFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetMovementTypeFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMovementTypeFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMovementTypeFilters(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMovementTypeFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getApprovalStatusFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetApprovalStatusFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalStatusFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalStatusFilters(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApprovalStatusFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getLastDepartureDateFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetLastDepartureDateFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastDepartureDateFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastDepartureDateFilters(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastDepartureDateFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getExpirationDateFilters(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetExpirationDateFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpirationDateFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpirationDateFilters(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExpirationDateFilters(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @param textFormat (optional) 
     * @param valueFormat (optional) 
     * @return Success
     */
    getPeriods(textFormat: string | null | undefined, valueFormat: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPeriods?";
        if (textFormat !== undefined)
            url_ += "textFormat=" + encodeURIComponent("" + textFormat) + "&";
        if (valueFormat !== undefined)
            url_ += "valueFormat=" + encodeURIComponent("" + valueFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriods(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPeriods(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserBusinessUnitsForMetabaseReports(): Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserBusinessUnitsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserBusinessUnitsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserBusinessUnitsForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserBusinessUnitsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopPortalFilterUserBusinessUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopPortalFilterUserBusinessUnitDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopPortalFilterUserBusinessUnitDto[]>(<any>null);
    }

    /**
     * @param businessUnitId (optional) 
     * @return Success
     */
    getBrandsByBusinessUnitForMetabaseReports(businessUnitId: number | null | undefined): Observable<MetabaseTranspopPortalFilterBrandDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetBrandsByBusinessUnitForMetabaseReports?";
        if (businessUnitId !== undefined)
            url_ += "businessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrandsByBusinessUnitForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandsByBusinessUnitForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopPortalFilterBrandDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopPortalFilterBrandDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrandsByBusinessUnitForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopPortalFilterBrandDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopPortalFilterBrandDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopPortalFilterBrandDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserType3AttributesForMetabaseReports(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserType3AttributesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserType3AttributesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserType3AttributesForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserType3AttributesForMetabaseReports(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserDistributorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetUserDistributorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDistributorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDistributorsForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDistributorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPmsLaunchesForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPmsLaunchesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPmsLaunchesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPmsLaunchesForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPmsLaunchesForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPmsCoordinatorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPmsCoordinatorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPmsCoordinatorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPmsCoordinatorsForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPmsCoordinatorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPmsChannelsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPmsChannelsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPmsChannelsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPmsChannelsForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPmsChannelsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsCheckinTypesForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinTypesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinTypesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinTypesForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsCheckinTypesForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsCheckinCoordinatorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinCoordinatorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinCoordinatorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinCoordinatorsForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsCheckinCoordinatorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsCheckinSupervisorsForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinSupervisorsForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinSupervisorsForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinSupervisorsForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsCheckinSupervisorsForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsCheckinPopStatusesForMetabaseReports(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsCheckinPopStatusesForMetabaseReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsCheckinPopStatusesForMetabaseReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsCheckinPopStatusesForMetabaseReports(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsCheckinPopStatusesForMetabaseReports(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPosmAvailabilityInStore(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPosmAvailabilityInStore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmAvailabilityInStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmAvailabilityInStore(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosmAvailabilityInStore(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsProductList(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsProductList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsProductList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsProductList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPosmTypeList(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetPosmTypeList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmTypeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmTypeList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosmTypeList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @param posmTypeName (optional) 
     * @return Success
     */
    getWmsStarbucksProductList(posmTypeName: string[] | null | undefined): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsStarbucksProductList?";
        if (posmTypeName !== undefined)
            posmTypeName && posmTypeName.forEach(item => { url_ += "posmTypeName=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsStarbucksProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsStarbucksProductList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsStarbucksProductList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsStarbucksProductTypwList(): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsStarbucksProductTypwList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsStarbucksProductTypwList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsStarbucksProductTypwList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsStarbucksProductTypwList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }

    /**
     * @param textFormat (optional) 
     * @param valueFormat (optional) 
     * @return Success
     */
    getLaunchStartMonths(textFormat: string | null | undefined, valueFormat: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetLaunchStartMonths?";
        if (textFormat !== undefined)
            url_ += "textFormat=" + encodeURIComponent("" + textFormat) + "&";
        if (valueFormat !== undefined)
            url_ += "valueFormat=" + encodeURIComponent("" + valueFormat) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunchStartMonths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunchStartMonths(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLaunchStartMonths(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsPgTier(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgTier";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgTier(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgTier(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsPgTier(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @param monthYear (optional) 
     * @return Success
     */
    getWmsPgMonthPeriods(monthYear: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgMonthPeriods?";
        if (monthYear !== undefined)
            url_ += "monthYear=" + encodeURIComponent("" + monthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgMonthPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgMonthPeriods(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsPgMonthPeriods(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @param startMonthYear (optional) 
     * @return Success
     */
    getWmsPgLaunchList(startMonthYear: string | null | undefined): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgLaunchList?";
        if (startMonthYear !== undefined)
            url_ += "startMonthYear=" + encodeURIComponent("" + startMonthYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgLaunchList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgLaunchList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsPgLaunchList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsPgSupervisorList(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgSupervisorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgSupervisorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgSupervisorList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsPgSupervisorList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getWmsPgKoordinatorList(): Observable<MetabaseFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetWmsPgKoordinatorList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWmsPgKoordinatorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWmsPgKoordinatorList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWmsPgKoordinatorList(response: HttpResponseBase): Observable<MetabaseFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseFilterItemDto[]>(<any>null);
    }

    /**
     * @param personelType (optional) 
     * @return Success
     */
    getLocationPersonelList(personelType: number | null | undefined): Observable<MetabaseTranspopFilterItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalFilter/GetLocationPersonelList?";
        if (personelType !== undefined)
            url_ += "personelType=" + encodeURIComponent("" + personelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocationPersonelList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocationPersonelList(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseTranspopFilterItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocationPersonelList(response: HttpResponseBase): Observable<MetabaseTranspopFilterItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MetabaseTranspopFilterItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseTranspopFilterItemDto[]>(<any>null);
    }
}

@Injectable()
export class MetabaseTranspopPortalModuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param reportId (optional) 
     * @param dashboardId (optional) 
     * @param warehouseIds (optional) 
     * @param productIds (optional) 
     * @param distributorNames (optional) 
     * @param damageStatuses (optional) 
     * @param movementType (optional) 
     * @param approvalStatuses (optional) 
     * @param lastDepartureDate (optional) 
     * @param expirationDate (optional) 
     * @param posm (optional) 
     * @param posmType (optional) 
     * @param monthPeriod (optional) 
     * @param posmIsInStore (optional) 
     * @param searchKeyword (optional) 
     * @param dateRange (optional) 
     * @param userId (optional) 
     * @param customerId (optional) 
     * @param customerCode (optional) 
     * @param businessUnitId (optional) 
     * @param businessUnitIds (optional) 
     * @param brandIds (optional) 
     * @param types (optional) 
     * @param launches (optional) 
     * @param coordinators (optional) 
     * @param channels (optional) 
     * @param specificDateRange (optional) 
     * @param supervisors (optional) 
     * @param regionManager (optional) 
     * @param companyManager (optional) 
     * @param popStatuses (optional) 
     * @param processTypes (optional) 
     * @param warehouseCodes (optional) 
     * @return Success
     */
    getDashboardFromMetabaseByFilter(reportId: number | null | undefined, dashboardId: number | null | undefined, warehouseIds: string[] | null | undefined, productIds: string[] | null | undefined, distributorNames: string[] | null | undefined, damageStatuses: string[] | null | undefined, movementType: string[] | null | undefined, approvalStatuses: string[] | null | undefined, lastDepartureDate: string | null | undefined, expirationDate: string | null | undefined, posm: string[] | null | undefined, posmType: string[] | null | undefined, monthPeriod: string | null | undefined, posmIsInStore: string[] | null | undefined, searchKeyword: string | null | undefined, dateRange: string | null | undefined, userId: number | null | undefined, customerId: number | null | undefined, customerCode: string | null | undefined, businessUnitId: number | null | undefined, businessUnitIds: number[] | null | undefined, brandIds: number[] | null | undefined, types: string[] | null | undefined, launches: string[] | null | undefined, coordinators: string[] | null | undefined, channels: string[] | null | undefined, specificDateRange: string | null | undefined, supervisors: string[] | null | undefined, regionManager: string[] | null | undefined, companyManager: string[] | null | undefined, popStatuses: string[] | null | undefined, processTypes: string[] | null | undefined, warehouseCodes: string[] | null | undefined): Observable<TranspopPortalReportResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalModule/GetDashboardFromMetabaseByFilter?";
        if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        if (warehouseIds !== undefined)
            warehouseIds && warehouseIds.forEach(item => { url_ += "WarehouseIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (distributorNames !== undefined)
            distributorNames && distributorNames.forEach(item => { url_ += "DistributorNames=" + encodeURIComponent("" + item) + "&"; });
        if (damageStatuses !== undefined)
            damageStatuses && damageStatuses.forEach(item => { url_ += "DamageStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (movementType !== undefined)
            movementType && movementType.forEach(item => { url_ += "MovementType=" + encodeURIComponent("" + item) + "&"; });
        if (approvalStatuses !== undefined)
            approvalStatuses && approvalStatuses.forEach(item => { url_ += "ApprovalStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (lastDepartureDate !== undefined)
            url_ += "LastDepartureDate=" + encodeURIComponent("" + lastDepartureDate) + "&";
        if (expirationDate !== undefined)
            url_ += "ExpirationDate=" + encodeURIComponent("" + expirationDate) + "&";
        if (posm !== undefined)
            posm && posm.forEach(item => { url_ += "Posm=" + encodeURIComponent("" + item) + "&"; });
        if (posmType !== undefined)
            posmType && posmType.forEach(item => { url_ += "PosmType=" + encodeURIComponent("" + item) + "&"; });
        if (monthPeriod !== undefined)
            url_ += "MonthPeriod=" + encodeURIComponent("" + monthPeriod) + "&";
        if (posmIsInStore !== undefined)
            posmIsInStore && posmIsInStore.forEach(item => { url_ += "PosmIsInStore=" + encodeURIComponent("" + item) + "&"; });
        if (searchKeyword !== undefined)
            url_ += "SearchKeyword=" + encodeURIComponent("" + searchKeyword) + "&";
        if (dateRange !== undefined)
            url_ += "DateRange=" + encodeURIComponent("" + dateRange) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (customerCode !== undefined)
            url_ += "CustomerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (businessUnitId !== undefined)
            url_ += "BusinessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        if (businessUnitIds !== undefined)
            businessUnitIds && businessUnitIds.forEach(item => { url_ += "BusinessUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (types !== undefined)
            types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (launches !== undefined)
            launches && launches.forEach(item => { url_ += "Launches=" + encodeURIComponent("" + item) + "&"; });
        if (coordinators !== undefined)
            coordinators && coordinators.forEach(item => { url_ += "Coordinators=" + encodeURIComponent("" + item) + "&"; });
        if (channels !== undefined)
            channels && channels.forEach(item => { url_ += "Channels=" + encodeURIComponent("" + item) + "&"; });
        if (specificDateRange !== undefined)
            url_ += "SpecificDateRange=" + encodeURIComponent("" + specificDateRange) + "&";
        if (supervisors !== undefined)
            supervisors && supervisors.forEach(item => { url_ += "Supervisors=" + encodeURIComponent("" + item) + "&"; });
        if (regionManager !== undefined)
            regionManager && regionManager.forEach(item => { url_ += "RegionManager=" + encodeURIComponent("" + item) + "&"; });
        if (companyManager !== undefined)
            companyManager && companyManager.forEach(item => { url_ += "CompanyManager=" + encodeURIComponent("" + item) + "&"; });
        if (popStatuses !== undefined)
            popStatuses && popStatuses.forEach(item => { url_ += "PopStatuses=" + encodeURIComponent("" + item) + "&"; });
        if (processTypes !== undefined)
            processTypes && processTypes.forEach(item => { url_ += "ProcessTypes=" + encodeURIComponent("" + item) + "&"; });
        if (warehouseCodes !== undefined)
            warehouseCodes && warehouseCodes.forEach(item => { url_ += "WarehouseCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardFromMetabaseByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardFromMetabaseByFilter(<any>response_);
                } catch (e) {
                    return <Observable<TranspopPortalReportResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TranspopPortalReportResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardFromMetabaseByFilter(response: HttpResponseBase): Observable<TranspopPortalReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TranspopPortalReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TranspopPortalReportResultDto>(<any>null);
    }
}

@Injectable()
export class MetabaseTranspopPortalProcessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filterInput (optional) 
     * @return Success
     */
    sendMailDownloadPhotosAsZipLink(filterInput: TranspopPortalReportParamsFiltersInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalProcess/SendMailDownloadPhotosAsZipLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterInput);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailDownloadPhotosAsZipLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailDownloadPhotosAsZipLink(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailDownloadPhotosAsZipLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param ekomLocationId (optional) 
     * @param productCode (optional) 
     * @return Success
     */
    getLastCheckinPhoto(ekomLocationId: number | null | undefined, productCode: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/MetabaseTranspopPortalProcess/GetLastCheckinPhoto?";
        if (ekomLocationId !== undefined)
            url_ += "ekomLocationId=" + encodeURIComponent("" + ekomLocationId) + "&";
        if (productCode !== undefined)
            url_ += "productCode=" + encodeURIComponent("" + productCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCheckinPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCheckinPhoto(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastCheckinPhoto(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class ModuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModuleDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfModuleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateModuleDto | null | undefined): Observable<ModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModuleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ModuleDto | null | undefined): Observable<ModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModuleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Module/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    _CreateTest(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/_CreateTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process_CreateTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process_CreateTest(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected process_CreateTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    calculateShipmentPrice(input: CreateOrderDto | null | undefined): Observable<OrderPriceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/CalculateShipmentPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateShipmentPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateShipmentPrice(<any>response_);
                } catch (e) {
                    return <Observable<OrderPriceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderPriceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateShipmentPrice(response: HttpResponseBase): Observable<OrderPriceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderPriceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderPriceDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrderProduct(input: CreateOrderDto | null | undefined): Observable<OrderStockResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/CreateOrderProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderProduct(<any>response_);
                } catch (e) {
                    return <Observable<OrderStockResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderStockResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrderProduct(response: HttpResponseBase): Observable<OrderStockResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStockResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderStockResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkUserHasProductLocationOrderHistoryView(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/CheckUserHasProductLocationOrderHistoryView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserHasProductLocationOrderHistoryView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserHasProductLocationOrderHistoryView(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckUserHasProductLocationOrderHistoryView(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getWaitingForApprovalOrders(filterDayNumber: number | null | undefined): Observable<OrderProductTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetWaitingForApprovalOrders?";
        if (filterDayNumber !== undefined)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaitingForApprovalOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaitingForApprovalOrders(<any>response_);
                } catch (e) {
                    return <Observable<OrderProductTaskDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderProductTaskDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWaitingForApprovalOrders(response: HttpResponseBase): Observable<OrderProductTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderProductTaskDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderProductTaskDto[]>(<any>null);
    }

    /**
     * @param withProductPhoto (optional) 
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getWaitingForApprovalOrdersForExcel(withProductPhoto: boolean | null | undefined, filterDayNumber: number | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetWaitingForApprovalOrdersForExcel?";
        if (withProductPhoto !== undefined)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        if (filterDayNumber !== undefined)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaitingForApprovalOrdersForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaitingForApprovalOrdersForExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWaitingForApprovalOrdersForExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getWaitingForMyApprovalOrders(filterDayNumber: number | null | undefined): Observable<OrderProductTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetWaitingForMyApprovalOrders?";
        if (filterDayNumber !== undefined)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaitingForMyApprovalOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaitingForMyApprovalOrders(<any>response_);
                } catch (e) {
                    return <Observable<OrderProductTaskDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderProductTaskDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWaitingForMyApprovalOrders(response: HttpResponseBase): Observable<OrderProductTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderProductTaskDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderProductTaskDto[]>(<any>null);
    }

    /**
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getPastOrders(filterDayNumber: number | null | undefined): Observable<OrderProductTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetPastOrders?";
        if (filterDayNumber !== undefined)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastOrders(<any>response_);
                } catch (e) {
                    return <Observable<OrderProductTaskDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderProductTaskDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPastOrders(response: HttpResponseBase): Observable<OrderProductTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderProductTaskDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderProductTaskDto[]>(<any>null);
    }

    /**
     * @param withProductPhoto (optional) 
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getPastOrdersForExcel(withProductPhoto: boolean | null | undefined, filterDayNumber: number | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetPastOrdersForExcel?";
        if (withProductPhoto !== undefined)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        if (filterDayNumber !== undefined)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastOrdersForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastOrdersForExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPastOrdersForExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param orderDetailsIds (optional) 
     * @return Success
     */
    removeOrder(orderDetailsIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/RemoveOrder?";
        if (orderDetailsIds !== undefined)
            orderDetailsIds && orderDetailsIds.forEach(item => { url_ += "orderDetailsIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param approvalTaskIds (optional) 
     * @param description (optional) 
     * @return Success
     */
    rejectOrder(approvalTaskIds: number[] | null | undefined, description: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/RejectOrder?";
        if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approvalTaskIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRejectOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param approvedOrderList (optional) 
     * @return Success
     */
    approveOrder(approvedOrderList: OrderApprovedDto[] | null | undefined): Observable<OrderApprovedDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/ApproveOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(approvedOrderList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveOrder(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovedDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovedDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processApproveOrder(response: HttpResponseBase): Observable<OrderApprovedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderApprovedDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovedDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getOrderApprovalTypes(): Observable<OrderApprovalTypesDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetOrderApprovalTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderApprovalTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderApprovalTypes(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovalTypesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovalTypesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderApprovalTypes(response: HttpResponseBase): Observable<OrderApprovalTypesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderApprovalTypesDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTypesDto[]>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @param toAddressId (optional) 
     * @return Success
     */
    getProductLocationHistories(productId: number | null | undefined, toAddressId: number | null | undefined): Observable<ProductLocationHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/GetProductLocationHistories?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (toAddressId !== undefined)
            url_ += "toAddressId=" + encodeURIComponent("" + toAddressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductLocationHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductLocationHistories(<any>response_);
                } catch (e) {
                    return <Observable<ProductLocationHistoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductLocationHistoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductLocationHistories(response: HttpResponseBase): Observable<ProductLocationHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductLocationHistoryDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductLocationHistoryDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    _TestMail(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/_TestMail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process_TestMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process_TestMail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected process_TestMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    test123(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Order/Test123";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest123(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest123(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTest123(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderApprovalRulesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param titleId (optional) 
     * @return Success
     */
    getApprovalRulesByTitleId(titleId: number | null | undefined): Observable<ApprovalRulesGroupedTitlesDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetApprovalRulesByTitleId?";
        if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovalRulesByTitleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovalRulesByTitleId(<any>response_);
                } catch (e) {
                    return <Observable<ApprovalRulesGroupedTitlesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovalRulesGroupedTitlesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApprovalRulesByTitleId(response: HttpResponseBase): Observable<ApprovalRulesGroupedTitlesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApprovalRulesGroupedTitlesDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalRulesGroupedTitlesDto[]>(<any>null);
    }

    /**
     * @param titleId (optional) 
     * @param groupId (optional) 
     * @return Success
     */
    getApproversListByGroupId(titleId: number | null | undefined, groupId: number | null | undefined): Observable<ApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetApproversListByGroupId?";
        if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApproversListByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApproversListByGroupId(<any>response_);
                } catch (e) {
                    return <Observable<ApproverDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApproverDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetApproversListByGroupId(response: HttpResponseBase): Observable<ApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApproverDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApproverDto[]>(<any>null);
    }

    /**
     * @param approvedTitleId (optional) 
     * @param groupId (optional) 
     * @param addressCategoryId (optional) 
     * @param newApprovers (optional) 
     * @return Success
     */
    addOrUpdateApprovalMechanism(approvedTitleId: number | null | undefined, groupId: number | null | undefined, addressCategoryId: number | null | undefined, newApprovers: ApproverDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/AddOrUpdateApprovalMechanism?";
        if (approvedTitleId !== undefined)
            url_ += "approvedTitleId=" + encodeURIComponent("" + approvedTitleId) + "&";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (addressCategoryId !== undefined)
            url_ += "addressCategoryId=" + encodeURIComponent("" + addressCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newApprovers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateApprovalMechanism(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateApprovalMechanism(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrUpdateApprovalMechanism(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    deleteApprovalMechanism(groupId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/DeleteApprovalMechanism?";
        if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApprovalMechanism(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApprovalMechanism(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteApprovalMechanism(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param titleId (optional) 
     * @return Success
     */
    getUnAssignedTitleCategories(titleId: number | null | undefined): Observable<ApprovalRulesCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetUnAssignedTitleCategories?";
        if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnAssignedTitleCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnAssignedTitleCategories(<any>response_);
                } catch (e) {
                    return <Observable<ApprovalRulesCategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApprovalRulesCategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnAssignedTitleCategories(response: HttpResponseBase): Observable<ApprovalRulesCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ApprovalRulesCategoryDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalRulesCategoryDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<OrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovalRulesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovalRulesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalRulesDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfOrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrderApprovalRulesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrderApprovalRulesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrderApprovalRulesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrderApprovalRulesDto | null | undefined): Observable<OrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovalRulesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovalRulesDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalRulesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: OrderApprovalRulesDto | null | undefined): Observable<OrderApprovalRulesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovalRulesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovalRulesDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderApprovalRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalRulesDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalRules/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderApprovalTaskRepairServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfOrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrderApprovalTaskRepairDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrderApprovalTaskRepairDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrderApprovalTaskRepairDto>(<any>null);
    }

    /**
     * @param taskRepairId (optional) 
     * @param addressId (optional) 
     * @param userId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    setAddressToUser(taskRepairId: number | null | undefined, addressId: number | null | undefined, userId: number | null | undefined, authorizationId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/SetAddressToUser?";
        if (taskRepairId !== undefined)
            url_ += "taskRepairId=" + encodeURIComponent("" + taskRepairId) + "&";
        if (addressId !== undefined)
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (authorizationId !== undefined)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAddressToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAddressToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAddressToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<OrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovalTaskRepairDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovalTaskRepairDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTaskRepairDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrderApprovalTaskRepairDto | null | undefined): Observable<OrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovalTaskRepairDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovalTaskRepairDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTaskRepairDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: OrderApprovalTaskRepairDto | null | undefined): Observable<OrderApprovalTaskRepairDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OrderApprovalTaskRepairDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderApprovalTaskRepairDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderApprovalTaskRepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderApprovalTaskRepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderApprovalTaskRepairDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderApprovalTaskRepair/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderCartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrderCartDto | null | undefined): Observable<OrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<OrderCartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCartDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCartDto>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    removeProductInCart(productId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/RemoveProductInCart?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveProductInCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveProductInCart(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveProductInCart(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getProductCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetProductCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getProductsInCart(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetProductsInCart";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsInCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsInCart(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductsInCart(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(<any>null);
    }

    /**
     * @param warehouseCode (optional) 
     * @return Success
     */
    getCalculatedWarehouseStockInCart(warehouseCode: string | null | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetCalculatedWarehouseStockInCart?";
        if (warehouseCode !== undefined)
            url_ += "warehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculatedWarehouseStockInCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculatedWarehouseStockInCart(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalculatedWarehouseStockInCart(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(<any>null);
    }

    /**
     * @param warehouseCode (optional) 
     * @param products (optional) 
     * @return Success
     */
    getCalculatedWarehouseStockInOrderList(warehouseCode: string | null | undefined, products: any[] | null | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetCalculatedWarehouseStockInOrderList?";
        if (warehouseCode !== undefined)
            url_ += "warehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (products !== undefined)
            products && products.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "products[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculatedWarehouseStockInOrderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculatedWarehouseStockInOrderList(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalculatedWarehouseStockInOrderList(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createOrdersByCart(input: CreateOrderDto[] | null | undefined): Observable<CreateOrderCartExceptionDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/CreateOrdersByCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrdersByCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrdersByCart(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrderCartExceptionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrderCartExceptionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrdersByCart(response: HttpResponseBase): Observable<CreateOrderCartExceptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrderCartExceptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrderCartExceptionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<OrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<OrderCartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCartDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfOrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrderCartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrderCartDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrderCartDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: OrderCartDto | null | undefined): Observable<OrderCartDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<OrderCartDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCartDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrderCartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderCartDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCartDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/OrderCart/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param moduleId (optional) 
     * @param isJustParents (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, moduleId: number | null | undefined, isJustParents: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (moduleId !== undefined)
            url_ += "ModuleId=" + encodeURIComponent("" + moduleId) + "&";
        if (isJustParents !== undefined)
            url_ += "IsJustParents=" + encodeURIComponent("" + isJustParents) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPageDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreatePageDto | null | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: PageDto | null | undefined): Observable<PageDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param moduleId (optional) 
     * @param isJustParents (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, moduleId: number | null | undefined, isJustParents: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfPageExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/GetAllForExcel?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (moduleId !== undefined)
            url_ += "ModuleId=" + encodeURIComponent("" + moduleId) + "&";
        if (isJustParents !== undefined)
            url_ += "IsJustParents=" + encodeURIComponent("" + isJustParents) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelPagedResultDtoOfPageExcelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelPagedResultDtoOfPageExcelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfPageExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfPageExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfPageExcelDto>(<any>null);
    }

    /**
     * @return Success
     */
    test(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Page/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class PlanServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param datasetId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, datasetId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPlanDto> {
        let url_ = this.baseUrl + "/api/services/smr/Plan/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (datasetId !== undefined)
            url_ += "DatasetId=" + encodeURIComponent("" + datasetId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPlanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPlanDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPlanDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<PlanDto> {
        let url_ = this.baseUrl + "/api/services/smr/Plan/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PlanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreatePlanDto | null | undefined): Observable<PlanDto> {
        let url_ = this.baseUrl + "/api/services/smr/Plan/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PlanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: PlanDto | null | undefined): Observable<PlanDto> {
        let url_ = this.baseUrl + "/api/services/smr/Plan/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PlanDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PlanDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Plan/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PosmProductionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getBrands(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrands(<any>response_);
                } catch (e) {
                    return <Observable<ListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrands(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getPosmTypes(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetPosmTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmTypes(<any>response_);
                } catch (e) {
                    return <Observable<ListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosmTypes(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSuppliers(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliers(<any>response_);
                } catch (e) {
                    return <Observable<ListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSuppliers(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addLaunch(input: CreateLaunchDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/AddLaunch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLaunch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddLaunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateLaunch(input: CreateLaunchDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/UpdateLaunch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLaunch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLaunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateLaunchSettings(input: LaunchSettingsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/UpdateLaunchSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLaunchSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLaunchSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLaunchSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    sendMailForNewLaunch(lansmanId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailForNewLaunch?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailForNewLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailForNewLaunch(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailForNewLaunch(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    createUserTitleBudgeForLaunch(lansmanId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/CreateUserTitleBudgeForLaunch?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserTitleBudgeForLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserTitleBudgeForLaunch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUserTitleBudgeForLaunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    sendMailForNewPosm(posmId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailForNewPosm?";
        if (posmId !== undefined)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailForNewPosm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailForNewPosm(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailForNewPosm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param noFilter (optional) 
     * @param isSupervisoreChipDagitiminaAcik (optional) 
     * @param isSahaTaleplerineAcik (optional) 
     * @param isAktifLansmanlar (optional) 
     * @param markaId (optional) 
     * @return Success
     */
    getLaunches(noFilter: boolean | null | undefined, isSupervisoreChipDagitiminaAcik: boolean | null | undefined, isSahaTaleplerineAcik: boolean | null | undefined, isAktifLansmanlar: boolean | null | undefined, markaId: string | null | undefined): Observable<PagedResultDtoOfLaunchDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetLaunches?";
        if (noFilter !== undefined)
            url_ += "NoFilter=" + encodeURIComponent("" + noFilter) + "&";
        if (isSupervisoreChipDagitiminaAcik !== undefined)
            url_ += "IsSupervisoreChipDagitiminaAcik=" + encodeURIComponent("" + isSupervisoreChipDagitiminaAcik) + "&";
        if (isSahaTaleplerineAcik !== undefined)
            url_ += "IsSahaTaleplerineAcik=" + encodeURIComponent("" + isSahaTaleplerineAcik) + "&";
        if (isAktifLansmanlar !== undefined)
            url_ += "IsAktifLansmanlar=" + encodeURIComponent("" + isAktifLansmanlar) + "&";
        if (markaId !== undefined)
            url_ += "MarkaId=" + encodeURIComponent("" + markaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunches(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLaunchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLaunchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLaunches(response: HttpResponseBase): Observable<PagedResultDtoOfLaunchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLaunchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLaunchDto>(<any>null);
    }

    /**
     * @param launchId (optional) 
     * @return Success
     */
    getLaunch(launchId: string | null | undefined): Observable<LaunchDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetLaunch?";
        if (launchId !== undefined)
            url_ += "launchId=" + encodeURIComponent("" + launchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunch(<any>response_);
                } catch (e) {
                    return <Observable<LaunchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LaunchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLaunch(response: HttpResponseBase): Observable<LaunchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LaunchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LaunchDto>(<any>null);
    }

    /**
     * @param launchId (optional) 
     * @return Success
     */
    getLaunchPosmList(launchId: string | null | undefined): Observable<PosmDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetLaunchPosmList?";
        if (launchId !== undefined)
            url_ += "launchId=" + encodeURIComponent("" + launchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaunchPosmList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaunchPosmList(<any>response_);
                } catch (e) {
                    return <Observable<PosmDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLaunchPosmList(response: HttpResponseBase): Observable<PosmDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmDto[]>(<any>null);
    }

    /**
     * @param posmId (optional) 
     * @param taskType (optional) 
     * @return Success
     */
    getPosmProductionTasks(posmId: string | null | undefined, taskType: TaskType | null | undefined): Observable<PosmProductionTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetPosmProductionTasks?";
        if (posmId !== undefined)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        if (taskType !== undefined)
            url_ += "taskType=" + encodeURIComponent("" + taskType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPosmProductionTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosmProductionTasks(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionTaskDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionTaskDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPosmProductionTasks(response: HttpResponseBase): Observable<PosmProductionTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserPosmProductionTasks(): Observable<PosmProductionTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionTasks(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionTaskDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionTaskDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPosmProductionTasks(response: HttpResponseBase): Observable<PosmProductionTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserPosmProductionTasksGroup(): Observable<PosmProductionTaskGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionTasksGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionTasksGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionTasksGroup(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionTaskGroupDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionTaskGroupDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPosmProductionTasksGroup(response: HttpResponseBase): Observable<PosmProductionTaskGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskGroupDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskGroupDto[]>(<any>null);
    }

    /**
     * @param posmTaskId (optional) 
     * @return Success
     */
    getUserPosmProductionTask(posmTaskId: string | null | undefined): Observable<PosmProductionTaskInput> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionTask?";
        if (posmTaskId !== undefined)
            url_ += "posmTaskId=" + encodeURIComponent("" + posmTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionTask(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionTaskInput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionTaskInput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPosmProductionTask(response: HttpResponseBase): Observable<PosmProductionTaskInput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionTaskInput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskInput>(<any>null);
    }

    /**
     * @param posmTaskId (optional) 
     * @return Success
     */
    getUserPosmProductionForAllSameTask(posmTaskId: string | null | undefined): Observable<PosmProductionTaskInput[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetUserPosmProductionForAllSameTask?";
        if (posmTaskId !== undefined)
            url_ += "posmTaskId=" + encodeURIComponent("" + posmTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPosmProductionForAllSameTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPosmProductionForAllSameTask(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionTaskInput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionTaskInput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPosmProductionForAllSameTask(response: HttpResponseBase): Observable<PosmProductionTaskInput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PosmProductionTaskInput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionTaskInput[]>(<any>null);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    createPosmProduceTasks(posmId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/CreatePosmProduceTasks?";
        if (posmId !== undefined)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePosmProduceTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePosmProduceTasks(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePosmProduceTasks(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    createPosmProduceTasksV2(posmId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/CreatePosmProduceTasksV2?";
        if (posmId !== undefined)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePosmProduceTasksV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePosmProduceTasksV2(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePosmProduceTasksV2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeProductionTaskStatus(input: PosmProductionTaskInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/ChangeProductionTaskStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeProductionTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProductionTaskStatus(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeProductionTaskStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param inputs (optional) 
     * @return Success
     */
    changeProductionTaskStatusMultiple(inputs: PosmProductionTaskInput[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/ChangeProductionTaskStatusMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputs);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeProductionTaskStatusMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProductionTaskStatusMultiple(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeProductionTaskStatusMultiple(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param posmTaskId (optional) 
     * @return Success
     */
    sendMailPosmTaskAssigned(posmTaskId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailPosmTaskAssigned?";
        if (posmTaskId !== undefined)
            url_ += "posmTaskId=" + encodeURIComponent("" + posmTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailPosmTaskAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailPosmTaskAssigned(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailPosmTaskAssigned(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeProductionTaskStatusOLD(input: PosmProductionTaskInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/ChangeProductionTaskStatusOLD";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeProductionTaskStatusOLD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeProductionTaskStatusOLD(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeProductionTaskStatusOLD(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    insertOrUpdatePosm(input: CreatePosmDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/InsertOrUpdatePosm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertOrUpdatePosm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertOrUpdatePosm(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsertOrUpdatePosm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    deletePosm(posmId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/DeletePosm?";
        if (posmId !== undefined)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePosm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePosm(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePosm(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCoordinators(): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetCoordinators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoordinators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoordinators(<any>response_);
                } catch (e) {
                    return <Observable<ListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoordinators(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(<any>null);
    }

    /**
     * @param coordinatorId (optional) 
     * @return Success
     */
    getSupervisors(coordinatorId: string | null | undefined): Observable<ListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/GetSupervisors?";
        if (coordinatorId !== undefined)
            url_ += "coordinatorId=" + encodeURIComponent("" + coordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisors(<any>response_);
                } catch (e) {
                    return <Observable<ListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupervisors(response: HttpResponseBase): Observable<ListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    testTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/TestTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    test123(lansmanId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/Test123?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest123(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest123(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTest123(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    sendMailPosmTaskAssignedV2(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/SendMailPosmTaskAssignedV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailPosmTaskAssignedV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailPosmTaskAssignedV2(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailPosmTaskAssignedV2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    testButceBilgiMailiGonder(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProduction/TestButceBilgiMailiGonder";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestButceBilgiMailiGonder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestButceBilgiMailiGonder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestButceBilgiMailiGonder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PosmProductionDemandServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPosmProductionDemandDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPosmProductionDemandDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPosmProductionDemandDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreatePosmProductionDemandDto | null | undefined): Observable<PosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionDemandDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionDemandDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionDemandDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: PosmProductionDemandDto | null | undefined): Observable<PosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionDemandDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionDemandDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionDemandDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSuppliers(): Observable<ListResultDtoOfComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/GetSuppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuppliers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuppliers(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfComboboxItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfComboboxItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSuppliers(response: HttpResponseBase): Observable<ListResultDtoOfComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfComboboxItemDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<PosmProductionDemandDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionDemand/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PosmProductionDemandDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PosmProductionDemandDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PosmProductionDemandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PosmProductionDemandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosmProductionDemandDto>(<any>null);
    }
}

@Injectable()
export class PosmProductionRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param lansmanId (optional) 
     * @param koordinatorId (optional) 
     * @return Success
     */
    downloadPopRequestDraftExcel(lansmanId: string | null | undefined, koordinatorId: string | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/DownloadPopRequestDraftExcel?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        if (koordinatorId !== undefined)
            url_ += "koordinatorId=" + encodeURIComponent("" + koordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPopRequestDraftExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPopRequestDraftExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadPopRequestDraftExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    downloadPosmOfTheLaunchExcel(lansmanId: string | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/DownloadPosmOfTheLaunchExcel?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPosmOfTheLaunchExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPosmOfTheLaunchExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadPosmOfTheLaunchExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param uploadDto (optional) 
     * @param lansmanId (optional) 
     * @param koordinatorId (optional) 
     * @return Success
     */
    uploadPopRequestExcel(uploadDto: PopRequestExcelUploadDto | null | undefined, lansmanId: string | null | undefined, koordinatorId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/UploadPopRequestExcel?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        if (koordinatorId !== undefined)
            url_ += "koordinatorId=" + encodeURIComponent("" + koordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(uploadDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPopRequestExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPopRequestExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadPopRequestExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @param userUnvanType (optional) 
     * @param koordinatorId (optional) 
     * @return Success
     */
    getUserButceByLansman(lansmanId: string | null | undefined, userUnvanType: UserUnvanType | null | undefined, koordinatorId: string | null | undefined): Observable<UserButceDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetUserButceByLansman?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        if (userUnvanType !== undefined)
            url_ += "userUnvanType=" + encodeURIComponent("" + userUnvanType) + "&";
        if (koordinatorId !== undefined)
            url_ += "koordinatorId=" + encodeURIComponent("" + koordinatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserButceByLansman(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserButceByLansman(<any>response_);
                } catch (e) {
                    return <Observable<UserButceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserButceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserButceByLansman(response: HttpResponseBase): Observable<UserButceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserButceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserButceDto>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    getKoordinatorsButce(lansmanId: string | null | undefined): Observable<UserButceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetKoordinatorsButce?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKoordinatorsButce(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKoordinatorsButce(<any>response_);
                } catch (e) {
                    return <Observable<UserButceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserButceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetKoordinatorsButce(response: HttpResponseBase): Observable<UserButceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserButceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserButceDto[]>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @return Success
     */
    getKoordinatorsSupervisorsButce(lansmanId: string | null | undefined): Observable<UserButceDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetKoordinatorsSupervisorsButce?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKoordinatorsSupervisorsButce(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKoordinatorsSupervisorsButce(<any>response_);
                } catch (e) {
                    return <Observable<UserButceDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserButceDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetKoordinatorsSupervisorsButce(response: HttpResponseBase): Observable<UserButceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserButceDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserButceDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getSupervisorsKoordinators(): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/GetSupervisorsKoordinators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisorsKoordinators(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisorsKoordinators(<any>response_);
                } catch (e) {
                    return <Observable<SelectListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSupervisorsKoordinators(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(<any>null);
    }

    /**
     * @param lansmanId (optional) 
     * @param assignedButces (optional) 
     * @return Success
     */
    assignButceToUser(lansmanId: string | null | undefined, assignedButces: UserAssignButceDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/AssignButceToUser?";
        if (lansmanId !== undefined)
            url_ += "lansmanId=" + encodeURIComponent("" + lansmanId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignedButces);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignButceToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignButceToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAssignButceToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param posmId (optional) 
     * @return Success
     */
    updatePosmToplamSahaTalebi(posmId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/UpdatePosmToplamSahaTalebi?";
        if (posmId !== undefined)
            url_ += "posmId=" + encodeURIComponent("" + posmId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePosmToplamSahaTalebi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePosmToplamSahaTalebi(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePosmToplamSahaTalebi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param posmTalepId (optional) 
     * @return Success
     */
    uptPosmToplamSahaTalebiOnTalep(posmTalepId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/PosmProductionRequest/UptPosmToplamSahaTalebiOnTalep?";
        if (posmTalepId !== undefined)
            url_ += "posmTalepId=" + encodeURIComponent("" + posmTalepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUptPosmToplamSahaTalebiOnTalep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUptPosmToplamSahaTalebiOnTalep(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUptPosmToplamSahaTalebiOnTalep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProcessTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param trackingTypeGuid (optional) 
     * @param filterDayNumber (optional) 
     * @return Success
     */
    getUserProcess(trackingTypeGuid: string | null | undefined, filterDayNumber: number | null | undefined): Observable<SRProcessTrackingDto[]> {
        let url_ = this.baseUrl + "/api/services/smr/ProcessTracking/GetUserProcess?";
        if (trackingTypeGuid !== undefined)
            url_ += "trackingTypeGuid=" + encodeURIComponent("" + trackingTypeGuid) + "&";
        if (filterDayNumber !== undefined)
            url_ += "filterDayNumber=" + encodeURIComponent("" + filterDayNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProcess(<any>response_);
                } catch (e) {
                    return <Observable<SRProcessTrackingDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SRProcessTrackingDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserProcess(response: HttpResponseBase): Observable<SRProcessTrackingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SRProcessTrackingDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SRProcessTrackingDto[]>(<any>null);
    }

    /**
     * @param trackingId (optional) 
     * @return Success
     */
    downloadTrackingExcel(trackingId: number | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/ProcessTracking/DownloadTrackingExcel?";
        if (trackingId !== undefined)
            url_ += "trackingId=" + encodeURIComponent("" + trackingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTrackingExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTrackingExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadTrackingExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param trackingGuid (optional) 
     * @return Success
     */
    getRouteShapes(trackingGuid: string | null | undefined): Observable<OptimumBasicRouteShapeDto> {
        let url_ = this.baseUrl + "/api/services/smr/ProcessTracking/GetRouteShapes?";
        if (trackingGuid !== undefined)
            url_ += "trackingGuid=" + encodeURIComponent("" + trackingGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRouteShapes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRouteShapes(<any>response_);
                } catch (e) {
                    return <Observable<OptimumBasicRouteShapeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OptimumBasicRouteShapeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRouteShapes(response: HttpResponseBase): Observable<OptimumBasicRouteShapeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptimumBasicRouteShapeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OptimumBasicRouteShapeDto>(<any>null);
    }

    /**
     * @param trackingId (optional) 
     * @return Success
     */
    deleteProcessTracking(trackingId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/ProcessTracking/DeleteProcessTracking?";
        if (trackingId !== undefined)
            url_ += "trackingId=" + encodeURIComponent("" + trackingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProcessTracking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProcessTracking(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteProcessTracking(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getProcessTrackingTypes(): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/smr/ProcessTracking/GetProcessTrackingTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessTrackingTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessTrackingTypes(<any>response_);
                } catch (e) {
                    return <Observable<SelectListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProcessTrackingTypes(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(<any>null);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param withProductPhoto (optional) 
     * @return Success
     */
    test(withProductPhoto: boolean | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Test?";
        if (withProductPhoto !== undefined)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateProductDto | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ProductDto | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfProductExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetAllForExcel?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelPagedResultDtoOfProductExcelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelPagedResultDtoOfProductExcelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfProductExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfProductExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfProductExcelDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUserWarehouseListByStockViewAuth(): Observable<ProductDomainWarehouseInput[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetUserWarehouseListByStockViewAuth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserWarehouseListByStockViewAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWarehouseListByStockViewAuth(<any>response_);
                } catch (e) {
                    return <Observable<ProductDomainWarehouseInput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDomainWarehouseInput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserWarehouseListByStockViewAuth(response: HttpResponseBase): Observable<ProductDomainWarehouseInput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDomainWarehouseInput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDomainWarehouseInput[]>(<any>null);
    }

    /**
     * @return Success
     */
    getBusinessUnitFiltersWithBrands(): Observable<SelectListItemDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetBusinessUnitFiltersWithBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessUnitFiltersWithBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessUnitFiltersWithBrands(<any>response_);
                } catch (e) {
                    return <Observable<SelectListItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SelectListItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBusinessUnitFiltersWithBrands(response: HttpResponseBase): Observable<SelectListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SelectListItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SelectListItemDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserType3Attributes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetUserType3Attributes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserType3Attributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserType3Attributes(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserType3Attributes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param brandIds (optional) 
     * @param typeNames (optional) 
     * @param businessUnits (optional) 
     * @param warehouses (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWarehousesProductStockListByUserAuths(brandIds: number[] | null | undefined, typeNames: string[] | null | undefined, businessUnits: number[] | null | undefined, warehouses: any[] | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetWarehousesProductStockListByUserAuths?";
        if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (typeNames !== undefined)
            typeNames && typeNames.forEach(item => { url_ += "TypeNames=" + encodeURIComponent("" + item) + "&"; });
        if (businessUnits !== undefined)
            businessUnits && businessUnits.forEach(item => { url_ += "BusinessUnits=" + encodeURIComponent("" + item) + "&"; });
        if (warehouses !== undefined)
            warehouses && warehouses.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Warehouses[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesProductStockListByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesProductStockListByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWarehousesProductStockListByUserAuths(response: HttpResponseBase): Observable<PagedResultDtoOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDto>(<any>null);
    }

    /**
     * @param brandIds (optional) 
     * @param typeNames (optional) 
     * @param businessUnits (optional) 
     * @param warehouses (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param withProductPhoto (optional) 
     * @param isWriteSubWarehouse (optional) 
     * @return Success
     */
    getWarehousesProductStockListByUserAuthsToExcel(brandIds: number[] | null | undefined, typeNames: string[] | null | undefined, businessUnits: number[] | null | undefined, warehouses: any[] | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, withProductPhoto: boolean | null | undefined, isWriteSubWarehouse: boolean | null | undefined): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetWarehousesProductStockListByUserAuthsToExcel?";
        if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (typeNames !== undefined)
            typeNames && typeNames.forEach(item => { url_ += "TypeNames=" + encodeURIComponent("" + item) + "&"; });
        if (businessUnits !== undefined)
            businessUnits && businessUnits.forEach(item => { url_ += "BusinessUnits=" + encodeURIComponent("" + item) + "&"; });
        if (warehouses !== undefined)
            warehouses && warehouses.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Warehouses[" + index + "]." + attr + "=" + encodeURIComponent("" + (<any>item)[attr]) + "&";
        			}
            });
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (withProductPhoto !== undefined)
            url_ += "withProductPhoto=" + encodeURIComponent("" + withProductPhoto) + "&";
        if (isWriteSubWarehouse !== undefined)
            url_ += "isWriteSubWarehouse=" + encodeURIComponent("" + isWriteSubWarehouse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesProductStockListByUserAuthsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesProductStockListByUserAuthsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWarehousesProductStockListByUserAuthsToExcel(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param forExcelList (optional) 
     * @param rootPath (optional) 
     * @param isWithPhoto (optional) 
     * @param currentUserMail (optional) 
     * @return Success
     */
    createProductExcelFileAndSendMail(forExcelList: ProductStockExcelDto[] | null | undefined, rootPath: string | null | undefined, isWithPhoto: boolean | null | undefined, currentUserMail: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/CreateProductExcelFileAndSendMail?";
        if (rootPath !== undefined)
            url_ += "rootPath=" + encodeURIComponent("" + rootPath) + "&";
        if (isWithPhoto !== undefined)
            url_ += "isWithPhoto=" + encodeURIComponent("" + isWithPhoto) + "&";
        if (currentUserMail !== undefined)
            url_ += "currentUserMail=" + encodeURIComponent("" + currentUserMail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forExcelList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProductExcelFileAndSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductExcelFileAndSendMail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateProductExcelFileAndSendMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param damageStatusType (optional) 
     * @return Success
     */
    getDistinctSpecialCodesFromWarehousesProductList(warehouseId: number | null | undefined, warehouseCode: string | null | undefined, damageStatusType: DamageStatusType | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetDistinctSpecialCodesFromWarehousesProductList?";
        if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode !== undefined)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (damageStatusType !== undefined)
            url_ += "DamageStatusType=" + encodeURIComponent("" + damageStatusType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctSpecialCodesFromWarehousesProductList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctSpecialCodesFromWarehousesProductList(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDistinctSpecialCodesFromWarehousesProductList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param specialCode (optional) 
     * @param brandIds (optional) 
     * @param damageStatusType (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param componentType (optional) 
     * @return Success
     */
    getFormWarehouseProductListByUserAuths(warehouseId: number | null | undefined, warehouseCode: string | null | undefined, specialCode: string | null | undefined, brandIds: number[] | null | undefined, damageStatusType: DamageStatusType2 | null | undefined, keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, componentType: ComponentType | null | undefined): Observable<PagedResultDtoOfProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetFormWarehouseProductListByUserAuths?";
        if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode !== undefined)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (specialCode !== undefined)
            url_ += "SpecialCode=" + encodeURIComponent("" + specialCode) + "&";
        if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (damageStatusType !== undefined)
            url_ += "DamageStatusType=" + encodeURIComponent("" + damageStatusType) + "&";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (componentType !== undefined)
            url_ += "componentType=" + encodeURIComponent("" + componentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormWarehouseProductListByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormWarehouseProductListByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormWarehouseProductListByUserAuths(response: HttpResponseBase): Observable<PagedResultDtoOfProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDto>(<any>null);
    }

    /**
     * @param warehouseId (optional) 
     * @param warehouseCode (optional) 
     * @param specialCode (optional) 
     * @param brandIds (optional) 
     * @param damageStatusType (optional) 
     * @param productId (optional) 
     * @return Success
     */
    getProductVariationStocks(warehouseId: number | null | undefined, warehouseCode: string | null | undefined, specialCode: string | null | undefined, brandIds: number[] | null | undefined, damageStatusType: DamageStatusType3 | null | undefined, productId: number | null | undefined): Observable<ProductVariationStocksOutputDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductVariationStocks?";
        if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (warehouseCode !== undefined)
            url_ += "WarehouseCode=" + encodeURIComponent("" + warehouseCode) + "&";
        if (specialCode !== undefined)
            url_ += "SpecialCode=" + encodeURIComponent("" + specialCode) + "&";
        if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (damageStatusType !== undefined)
            url_ += "DamageStatusType=" + encodeURIComponent("" + damageStatusType) + "&";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductVariationStocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductVariationStocks(<any>response_);
                } catch (e) {
                    return <Observable<ProductVariationStocksOutputDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductVariationStocksOutputDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductVariationStocks(response: HttpResponseBase): Observable<ProductVariationStocksOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductVariationStocksOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductVariationStocksOutputDto>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductDetails(productId: number | null | undefined): Observable<ProductDetailsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductDetails?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDetails(<any>response_);
                } catch (e) {
                    return <Observable<ProductDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductDetails(response: HttpResponseBase): Observable<ProductDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDetailsDto>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductInfo(productId: number | null | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductInfo?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductInfo(<any>response_);
                } catch (e) {
                    return <Observable<ProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductInfo(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductStockInWarehouses(productId: number | null | undefined): Observable<ProductDetailsWarehouseStockDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetProductStockInWarehouses?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductStockInWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductStockInWarehouses(<any>response_);
                } catch (e) {
                    return <Observable<ProductDetailsWarehouseStockDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDetailsWarehouseStockDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProductStockInWarehouses(response: HttpResponseBase): Observable<ProductDetailsWarehouseStockDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDetailsWarehouseStockDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDetailsWarehouseStockDto[]>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @param oldestDay (optional) 
     * @return Success
     */
    getDeliveredOrderQtyByUsers(productId: number | null | undefined, oldestDay: number | null | undefined): Observable<ProductDomainUserOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetDeliveredOrderQtyByUsers?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (oldestDay !== undefined)
            url_ += "oldestDay=" + encodeURIComponent("" + oldestDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveredOrderQtyByUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveredOrderQtyByUsers(<any>response_);
                } catch (e) {
                    return <Observable<ProductDomainUserOrderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDomainUserOrderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeliveredOrderQtyByUsers(response: HttpResponseBase): Observable<ProductDomainUserOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDomainUserOrderDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDomainUserOrderDto[]>(<any>null);
    }

    /**
     * @param productId (optional) 
     * @param oldestDay (optional) 
     * @return Success
     */
    getDeliveredOrderQtyByAddress(productId: number | null | undefined, oldestDay: number | null | undefined): Observable<ProductDomainAddressOrderDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Product/GetDeliveredOrderQtyByAddress?";
        if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (oldestDay !== undefined)
            url_ += "oldestDay=" + encodeURIComponent("" + oldestDay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveredOrderQtyByAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveredOrderQtyByAddress(<any>response_);
                } catch (e) {
                    return <Observable<ProductDomainAddressOrderDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDomainAddressOrderDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeliveredOrderQtyByAddress(response: HttpResponseBase): Observable<ProductDomainAddressOrderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductDomainAddressOrderDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDomainAddressOrderDto[]>(<any>null);
    }
}

@Injectable()
export class ProductAttributeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param customerId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserUnAssignedProductAttributes(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, customerId: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/GetUserUnAssignedProductAttributes?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (authorizationId !== undefined)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedProductAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedProductAttributes(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedProductAttributes(response: HttpResponseBase): Observable<PagedResultDtoOfProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductAttributeDto>(<any>null);
    }

    /**
     * @param businessUnitId (optional) 
     * @return Success
     */
    getBrandsByBusinessUnitId(businessUnitId: number | null | undefined): Observable<ProductAttributeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/GetBrandsByBusinessUnitId?";
        if (businessUnitId !== undefined)
            url_ += "businessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrandsByBusinessUnitId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrandsByBusinessUnitId(<any>response_);
                } catch (e) {
                    return <Observable<ProductAttributeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductAttributeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetBrandsByBusinessUnitId(response: HttpResponseBase): Observable<ProductAttributeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductAttributeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductAttributeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateProductAttributeDto | null | undefined): Observable<ProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ProductAttributeDto | null | undefined): Observable<ProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductAttributeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductAttribute/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ProductDamageStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProductDamageStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProductDamageStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProductDamageStatusDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ProductDamageStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDamageStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDamageStatusDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: ProductDamageStatusDto | null | undefined): Observable<ProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ProductDamageStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDamageStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDamageStatusDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ProductDamageStatusDto | null | undefined): Observable<ProductDamageStatusDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ProductDamageStatusDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductDamageStatusDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductDamageStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductDamageStatusDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDamageStatusDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/ProductDamageStatus/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RegionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param planId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, planId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRegionDto> {
        let url_ = this.baseUrl + "/api/services/smr/Region/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (planId !== undefined)
            url_ += "PlanId=" + encodeURIComponent("" + planId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRegionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRegionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRegionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<RegionDto> {
        let url_ = this.baseUrl + "/api/services/smr/Region/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RegionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateRegionDto | null | undefined): Observable<RegionDto> {
        let url_ = this.baseUrl + "/api/services/smr/Region/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RegionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateRegionDto | null | undefined): Observable<RegionDto> {
        let url_ = this.baseUrl + "/api/services/smr/Region/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RegionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegionDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Region/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserUnAssignedReports(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined): Observable<PagedResultDtoOfReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/GetUserUnAssignedReports?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedReports(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedReports(response: HttpResponseBase): Observable<PagedResultDtoOfReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReportDto>(<any>null);
    }

    /**
     * @param dashboardId (optional) 
     * @return Success
     */
    getDashboardFromMetabase(dashboardId: number | null | undefined): Observable<MetabaseDashboardOutput> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/GetDashboardFromMetabase?";
        if (dashboardId !== undefined)
            url_ += "dashboardId=" + encodeURIComponent("" + dashboardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardFromMetabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardFromMetabase(<any>response_);
                } catch (e) {
                    return <Observable<MetabaseDashboardOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<MetabaseDashboardOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardFromMetabase(response: HttpResponseBase): Observable<MetabaseDashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetabaseDashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MetabaseDashboardOutput>(<any>null);
    }

    /**
     * @return Success
     */
    mailTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/MailTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMailTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMailTest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processMailTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    smsTest(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/SmsTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSmsTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSmsTest(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSmsTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateReportDto | null | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ReportDto | null | undefined): Observable<ReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Report/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ResolveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resolveSingleLocation(input: SRRouteResolveSingleLocationInputDto | null | undefined): Observable<SRResolveLocationDto> {
        let url_ = this.baseUrl + "/api/services/smr/Resolve/ResolveSingleLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveSingleLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveSingleLocation(<any>response_);
                } catch (e) {
                    return <Observable<SRResolveLocationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SRResolveLocationDto>><any>_observableThrow(response_);
        }));
    }

    protected processResolveSingleLocation(response: HttpResponseBase): Observable<SRResolveLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SRResolveLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SRResolveLocationDto>(<any>null);
    }

    /**
     * @return Success
     */
    generateResolveExcelDraft(): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/Resolve/GenerateResolveExcelDraft";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateResolveExcelDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateResolveExcelDraft(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateResolveExcelDraft(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadResolveExcel(input: SRRouteResolveExcelUploadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Resolve/UploadResolveExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadResolveExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadResolveExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadResolveExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateRoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRolesAsync?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: RoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfPermissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPermissionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfPermissionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfPermissionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfPermissionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRoleDto>(<any>null);
    }
}

@Injectable()
export class RouteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    generateOptimumBasicExcelDraft(): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/Route/GenerateOptimumBasicExcelDraft";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateOptimumBasicExcelDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateOptimumBasicExcelDraft(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateOptimumBasicExcelDraft(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadOptimumBasicExcel(input: SRRouteOptimumBasicExcelUploadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Route/UploadOptimumBasicExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadOptimumBasicExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadOptimumBasicExcel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUploadOptimumBasicExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    generateOptimumDailyExcelDraft(): Observable<ExcelFileResultDto> {
        let url_ = this.baseUrl + "/api/services/smr/Route/GenerateOptimumDailyExcelDraft";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateOptimumDailyExcelDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateOptimumDailyExcelDraft(<any>response_);
                } catch (e) {
                    return <Observable<ExcelFileResultDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelFileResultDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateOptimumDailyExcelDraft(response: HttpResponseBase): Observable<ExcelFileResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelFileResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelFileResultDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    uploadOptimumDailyExcel(input: SRRouteOptimumDailyExcelUploadDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/smr/Route/UploadOptimumDailyExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadOptimumDailyExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadOptimumDailyExcel(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processUploadOptimumDailyExcel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param uploadedExcelId (optional) 
     * @return Success
     */
    dailyPlanner(uploadedExcelId: number | null | undefined): Observable<SRRouteOptimumDailyUploadDto[]> {
        let url_ = this.baseUrl + "/api/services/smr/Route/DailyPlanner?";
        if (uploadedExcelId !== undefined)
            url_ += "uploadedExcelId=" + encodeURIComponent("" + uploadedExcelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDailyPlanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDailyPlanner(<any>response_);
                } catch (e) {
                    return <Observable<SRRouteOptimumDailyUploadDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SRRouteOptimumDailyUploadDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processDailyPlanner(response: HttpResponseBase): Observable<SRRouteOptimumDailyUploadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SRRouteOptimumDailyUploadDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SRRouteOptimumDailyUploadDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    runDailyPlanner(input: SRRouteOptimumDailyFireDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Route/RunDailyPlanner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunDailyPlanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunDailyPlanner(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRunDailyPlanner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    runResolverDefLocation(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Route/RunResolverDefLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunResolverDefLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunResolverDefLocation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRunResolverDefLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    txtTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/Route/TxtTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTxtTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTxtTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTxtTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateTenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }
}

@Injectable()
export class TestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param url (optional) 
     * @param keyname (optional) 
     * @return Success
     */
    urlShorter(url: string | null | undefined, keyname: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/pms/Test/UrlShorter?";
        if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (keyname !== undefined)
            url_ += "keyname=" + encodeURIComponent("" + keyname) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUrlShorter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUrlShorter(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processUrlShorter(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    sendNearLaunch(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pms/Test/SendNearLaunch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNearLaunch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNearLaunch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendNearLaunch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    startPosmProduce(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/pms/Test/StartPosmProduce";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartPosmProduce(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartPosmProduce(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processStartPosmProduce(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TestHasanServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    corcialCheck(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/CorcialCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorcialCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorcialCheck(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCorcialCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    corcialStoredProcCheck(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/CorcialStoredProcCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorcialStoredProcCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorcialStoredProcCheck(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCorcialStoredProcCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getModuleSettings(): Observable<ModuleConfigPosmTakipDto> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/GetModuleSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetModuleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetModuleSettings(<any>response_);
                } catch (e) {
                    return <Observable<ModuleConfigPosmTakipDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModuleConfigPosmTakipDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetModuleSettings(response: HttpResponseBase): Observable<ModuleConfigPosmTakipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleConfigPosmTakipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModuleConfigPosmTakipDto>(<any>null);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    selamVer(name: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/SelamVer?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSelamVer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelamVer(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSelamVer(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param gondericiMailAdresi (optional) 
     * @return Success
     */
    sendMailTest(gondericiMailAdresi: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/SendMailTest?";
        if (gondericiMailAdresi !== undefined)
            url_ += "gondericiMailAdresi=" + encodeURIComponent("" + gondericiMailAdresi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    predictPhoto(): Observable<PredictHeaderModel> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/PredictPhoto";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPredictPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPredictPhoto(<any>response_);
                } catch (e) {
                    return <Observable<PredictHeaderModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<PredictHeaderModel>><any>_observableThrow(response_);
        }));
    }

    protected processPredictPhoto(response: HttpResponseBase): Observable<PredictHeaderModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PredictHeaderModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PredictHeaderModel>(<any>null);
    }

    /**
     * @return Success
     */
    nestleRutDataCek(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/NestleRutDataCek";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNestleRutDataCek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNestleRutDataCek(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNestleRutDataCek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    cityShipment(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/CityShipment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCityShipment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCityShipment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCityShipment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getTestAnlasmaGorevleri(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/GetTestAnlasmaGorevleri";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTestAnlasmaGorevleri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTestAnlasmaGorevleri(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetTestAnlasmaGorevleri(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param poiId (optional) 
     * @return Success
     */
    poiBenzesimKontrol(poiId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/PoiBenzesimKontrol?";
        if (poiId !== undefined)
            url_ += "poiId=" + encodeURIComponent("" + poiId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPoiBenzesimKontrol(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPoiBenzesimKontrol(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPoiBenzesimKontrol(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param poiId (optional) 
     * @return Success
     */
    addressToGps(poiId: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/AddressToGps?";
        if (poiId !== undefined)
            url_ += "poiId=" + encodeURIComponent("" + poiId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddressToGps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddressToGps(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAddressToGps(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    getPersonelMpoi(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/GetPersonelMpoi";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelMpoi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelMpoi(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetPersonelMpoi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param epostaBildirimId (optional) 
     * @param isTest (optional) 
     * @return Success
     */
    runDynamicInfoService(epostaBildirimId: string | null | undefined, isTest: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/RunDynamicInfoService?";
        if (epostaBildirimId !== undefined)
            url_ += "epostaBildirimId=" + encodeURIComponent("" + epostaBildirimId) + "&";
        if (isTest !== undefined)
            url_ += "isTest=" + encodeURIComponent("" + isTest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunDynamicInfoService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunDynamicInfoService(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRunDynamicInfoService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param anonimSmsId (optional) 
     * @return Success
     */
    sendAnonimSms(anonimSmsId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/SendAnonimSms?";
        if (anonimSmsId !== undefined)
            url_ += "anonimSmsId=" + encodeURIComponent("" + anonimSmsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAnonimSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAnonimSms(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendAnonimSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param kargoTakipId (optional) 
     * @return Success
     */
    kagoLogoGonder(kargoTakipId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/KagoLogoGonder?";
        if (kargoTakipId !== undefined)
            url_ += "kargoTakipId=" + encodeURIComponent("" + kargoTakipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKagoLogoGonder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKagoLogoGonder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processKagoLogoGonder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    unileverRutCek(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/testapp/TestHasan/UnileverRutCek";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnileverRutCek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnileverRutCek(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnileverRutCek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    _TestHangfire(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/_TestHangfire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process_TestHangfire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process_TestHangfire(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected process_TestHangfire(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param customerId (optional) 
     * @param excludedTitleIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, customerId: number | null | undefined, excludedTitleIds: number[] | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (excludedTitleIds !== undefined)
            excludedTitleIds && excludedTitleIds.forEach(item => { url_ += "ExcludedTitleIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTitleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTitleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTitleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateTitleDto | null | undefined): Observable<TitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TitleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TitleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TitleDto | null | undefined): Observable<TitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TitleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TitleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    getUserUnAssignedTitles(userId: number | null | undefined, customerId: number | null | undefined): Observable<TitleDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/GetUserUnAssignedTitles?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedTitles(<any>response_);
                } catch (e) {
                    return <Observable<TitleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TitleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedTitles(response: HttpResponseBase): Observable<TitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TitleDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    sendMailTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/SendMailTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMailTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMailTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendMailTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    stokManagerTestSchedule(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/StokManagerTestSchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStokManagerTestSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStokManagerTestSchedule(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processStokManagerTestSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    stokManagerTest(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/StokManagerTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStokManagerTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStokManagerTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processStokManagerTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param customerId (optional) 
     * @param customerCode (optional) 
     * @param isWriteSubWarehouse (optional) 
     * @return Success
     */
    generateStockExcel(userId: number | null | undefined, customerId: number | null | undefined, customerCode: string | null | undefined, isWriteSubWarehouse: boolean | null | undefined): Observable<ProductStockPto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/GenerateStockExcel?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (customerCode !== undefined)
            url_ += "customerCode=" + encodeURIComponent("" + customerCode) + "&";
        if (isWriteSubWarehouse !== undefined)
            url_ += "isWriteSubWarehouse=" + encodeURIComponent("" + isWriteSubWarehouse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateStockExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateStockExcel(<any>response_);
                } catch (e) {
                    return <Observable<ProductStockPto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProductStockPto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateStockExcel(response: HttpResponseBase): Observable<ProductStockPto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ProductStockPto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductStockPto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TitleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Title/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TitleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TitleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TitleDto>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }
}

@Injectable()
export class TransportBidServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param nakliyeTeklifId (optional) 
     * @return Success
     */
    getBidContent(nakliyeTeklifId: string | null | undefined): Observable<TransportBidInfoDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/GetBidContent?";
        if (nakliyeTeklifId !== undefined)
            url_ += "nakliyeTeklifId=" + encodeURIComponent("" + nakliyeTeklifId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBidContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBidContent(<any>response_);
                } catch (e) {
                    return <Observable<TransportBidInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransportBidInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetBidContent(response: HttpResponseBase): Observable<TransportBidInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransportBidInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransportBidInfoDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateBidPrice(input: UpdateTransportBidDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/UpdateBidPrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBidPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBidPrice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBidPrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateBidDriverInfo(input: UpdateTransportBidDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/UpdateBidDriverInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBidDriverInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBidDriverInfo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBidDriverInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param nakliyeTeklifId (optional) 
     * @return Success
     */
    sendSmsForBid(nakliyeTeklifId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/SendSmsForBid?";
        if (nakliyeTeklifId !== undefined)
            url_ += "nakliyeTeklifId=" + encodeURIComponent("" + nakliyeTeklifId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSmsForBid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSmsForBid(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendSmsForBid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param nakliyeTeklifId (optional) 
     * @return Success
     */
    sendSmsForBidApprove(nakliyeTeklifId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/TransportBid/SendSmsForBidApprove?";
        if (nakliyeTeklifId !== undefined)
            url_ += "nakliyeTeklifId=" + encodeURIComponent("" + nakliyeTeklifId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSmsForBidApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSmsForBidApprove(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendSmsForBidApprove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param isDeleted (optional) 
     * @param customerId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, isDeleted: boolean | null | undefined, customerId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<ListResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUsersCustomers(userId: number | null | undefined): Observable<UserCustomerInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersCustomers?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersCustomers(<any>response_);
                } catch (e) {
                    return <Observable<UserCustomerInfoDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCustomerInfoDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersCustomers(response: HttpResponseBase): Observable<UserCustomerInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserCustomerInfoDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerInfoDto[]>(<any>null);
    }

    /**
     * @param titleId (optional) 
     * @return Success
     */
    getTitleUsers(titleId: number | null | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTitleUsers?";
        if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleUsers(<any>response_);
                } catch (e) {
                    return <Observable<UserDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTitleUsers(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param password (optional) 
     * @param newUserCustomerId (optional) 
     * @return Success
     */
    changeUserCustomer(userId: number | null | undefined, password: string | null | undefined, newUserCustomerId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeUserCustomer?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (newUserCustomerId !== undefined)
            url_ += "newUserCustomerId=" + encodeURIComponent("" + newUserCustomerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUserCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUserCustomer(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUserCustomer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    setActiveToUser(userId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/SetActiveToUser?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetActiveToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetActiveToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetActiveToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    cloneUser(input: CloneUserDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/CloneUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneUser(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCloneUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    cloneUser2(input: CloneUserDto | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/CloneUser2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCloneUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCloneUser2(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCloneUser2(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @return Success
     */
    getTestUsers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetTestUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTestUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTestUsers(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTestUsers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }
}

@Injectable()
export class UserActionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param minute (optional) 
     * @return Success
     */
    getLastTenMinutesLogins(minute: number | null | undefined): Observable<LastLoggedUsersDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAction/GetLastTenMinutesLogins?";
        if (minute !== undefined)
            url_ += "minute=" + encodeURIComponent("" + minute) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastTenMinutesLogins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastTenMinutesLogins(<any>response_);
                } catch (e) {
                    return <Observable<LastLoggedUsersDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LastLoggedUsersDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastTenMinutesLogins(response: HttpResponseBase): Observable<LastLoggedUsersDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LastLoggedUsersDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LastLoggedUsersDto[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param durumId (optional) 
     * @return Success
     */
    getUserActions(userId: number | null | undefined, durumId: number | null | undefined): Observable<UserActionDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAction/GetUserActions?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (durumId !== undefined)
            url_ += "durumId=" + encodeURIComponent("" + durumId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActions(<any>response_);
                } catch (e) {
                    return <Observable<UserActionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserActionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserActions(response: HttpResponseBase): Observable<UserActionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserActionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserActionDto[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @return Success
     */
    getUserLastLoginsDetails(userId: number | null | undefined, startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined): Observable<UserLastLoginDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAction/GetUserLastLoginsDetails?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (startTime !== undefined)
            url_ += "startTime=" + encodeURIComponent(startTime ? "" + startTime.toJSON() : "") + "&";
        if (endTime !== undefined)
            url_ += "endTime=" + encodeURIComponent(endTime ? "" + endTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLastLoginsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLastLoginsDetails(<any>response_);
                } catch (e) {
                    return <Observable<UserLastLoginDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserLastLoginDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserLastLoginsDetails(response: HttpResponseBase): Observable<UserLastLoginDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserLastLoginDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLastLoginDto[]>(<any>null);
    }
}

@Injectable()
export class UserAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param cityId (optional) 
     * @param categoryName (optional) 
     * @param authorizationId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedAddresses(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, cityId: number | null | undefined, categoryName: string | null | undefined, authorizationId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/GetUserAssignedAddresses?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (cityId !== undefined)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (categoryName !== undefined)
            url_ += "CategoryName=" + encodeURIComponent("" + categoryName) + "&";
        if (authorizationId !== undefined)
            url_ += "AuthorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedAddresses(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedAddresses(response: HttpResponseBase): Observable<PagedResultDtoOfUserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAddressDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserAddressesCitiesAndCategories(userId: number | null | undefined): Observable<UserAddressCitiesAndCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/GetUserAddressesCitiesAndCategories?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAddressesCitiesAndCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAddressesCitiesAndCategories(<any>response_);
                } catch (e) {
                    return <Observable<UserAddressCitiesAndCategoriesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAddressCitiesAndCategoriesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAddressesCitiesAndCategories(response: HttpResponseBase): Observable<UserAddressCitiesAndCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressCitiesAndCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressCitiesAndCategoriesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignAddressToUser(input: CreateUserAddressDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/SetAssignAddressToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignAddressToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignAddressToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignAddressToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userAddressIds (optional) 
     * @return Success
     */
    setUnAssignAddressToUser(userAddressIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/SetUnAssignAddressToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userAddressIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignAddressToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignAddressToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignAddressToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param cityId (optional) 
     * @param categoryName (optional) 
     * @param authorizationId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, cityId: number | null | undefined, categoryName: string | null | undefined, authorizationId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (cityId !== undefined)
            url_ += "CityId=" + encodeURIComponent("" + cityId) + "&";
        if (categoryName !== undefined)
            url_ += "CategoryName=" + encodeURIComponent("" + categoryName) + "&";
        if (authorizationId !== undefined)
            url_ += "AuthorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAddressDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserAddressDto | null | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserAddressDto | null | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAddress/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserAuthorizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedAuthorizations(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/GetUserAssignedAuthorizations?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedAuthorizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedAuthorizations(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserAuthorizationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserAuthorizationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedAuthorizations(response: HttpResponseBase): Observable<PagedResultDtoOfUserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAuthorizationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignAuthorizationsToUser(input: CreateUserAuthorizationDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/SetAssignAuthorizationsToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignAuthorizationsToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignAuthorizationsToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignAuthorizationsToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userAuthorizationIds (optional) 
     * @return Success
     */
    setUnAssignAuthorizationsToUser(userAuthorizationIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/SetUnAssignAuthorizationsToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userAuthorizationIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignAuthorizationsToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignAuthorizationsToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignAuthorizationsToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserAuthorizationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAuthorizationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAuthorizationDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserAuthorizationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserAuthorizationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserAuthorizationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserAuthorizationDto | null | undefined): Observable<UserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserAuthorizationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAuthorizationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAuthorizationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserAuthorizationDto | null | undefined): Observable<UserAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserAuthorizationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserAuthorizationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAuthorizationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserAuthorization/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserCitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedCities(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/GetUserAssignedCities?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCities(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserCitiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserCitiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedCities(response: HttpResponseBase): Observable<PagedResultDtoOfUserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCitiesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateUserCities(input: UpdateUserCitiesDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/UpdateUserCities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserCities(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserCities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignCityToUser(input: CreateUserCitiesDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/SetAssignCityToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignCityToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignCityToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignCityToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userCitiesIds (optional) 
     * @return Success
     */
    setUnAssignUserCitiesToUser(userCitiesIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/SetUnAssignUserCitiesToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCitiesIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignUserCitiesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignUserCitiesToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignUserCitiesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    setUnAssignAllUserCitiesToUser(userId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/SetUnAssignAllUserCitiesToUser?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignAllUserCitiesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignAllUserCitiesToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignAllUserCitiesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserCitiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCitiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserCitiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserCitiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCitiesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserCitiesDto | null | undefined): Observable<UserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserCitiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCitiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateUserCitiesDto | null | undefined): Observable<UserCitiesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserCitiesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCitiesDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCities/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserCitiesCategoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param userCityId (optional) 
     * @return Success
     */
    getUserCityAssignedCategories(userCityId: number | null | undefined): Observable<UserCityCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/GetUserCityAssignedCategories?";
        if (userCityId !== undefined)
            url_ += "userCityId=" + encodeURIComponent("" + userCityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCityAssignedCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCityAssignedCategories(<any>response_);
                } catch (e) {
                    return <Observable<UserCityCategoryDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCityCategoryDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserCityAssignedCategories(response: HttpResponseBase): Observable<UserCityCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserCityCategoryDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCityCategoryDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserCitiesCategoriesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCitiesCategoriesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesCategoriesDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserCitiesCategoriesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserCitiesCategoriesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCitiesCategoriesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserCitiesCategoriesDto | null | undefined): Observable<UserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserCitiesCategoriesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCitiesCategoriesDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesCategoriesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserCitiesCategoriesDto | null | undefined): Observable<UserCitiesCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserCitiesCategoriesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCitiesCategoriesDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCitiesCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCitiesCategoriesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCitiesCategoriesDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCitiesCategories/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserCustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedCustomers(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/GetUserAssignedCustomers?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCustomers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedCustomers(response: HttpResponseBase): Observable<PagedResultDtoOfUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCustomerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignCustomerToUser(input: CreateUserCustomerDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/SetAssignCustomerToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignCustomerToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignCustomerToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignCustomerToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userCustomerIds (optional) 
     * @return Success
     */
    setUnAssignCustomerToUserOld(userCustomerIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/SetUnAssignCustomerToUserOld";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCustomerIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignCustomerToUserOld(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignCustomerToUserOld(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignCustomerToUserOld(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param userCustomerIds (optional) 
     * @return Success
     */
    setUnAssignCustomerToUser(userId: number | null | undefined, userCustomerIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/SetUnAssignCustomerToUser?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userCustomerIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignCustomerToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignCustomerToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignCustomerToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateUserCustomerDto | null | undefined): Observable<UserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserCustomerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserCustomerDto | null | undefined): Observable<UserCustomerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCustomerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserCustomer/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserFormsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param userCustomerId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getOrderFormAuthorizationsByUserCustomer(userCustomerId: number | null | undefined, userId: number | null | undefined): Observable<OrderFormAuthorizationDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetOrderFormAuthorizationsByUserCustomer?";
        if (userCustomerId !== undefined)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderFormAuthorizationsByUserCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderFormAuthorizationsByUserCustomer(<any>response_);
                } catch (e) {
                    return <Observable<OrderFormAuthorizationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderFormAuthorizationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderFormAuthorizationsByUserCustomer(response: HttpResponseBase): Observable<OrderFormAuthorizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderFormAuthorizationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderFormAuthorizationDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignFormsToUser(input: CreateUserFormsDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/SetAssignFormsToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignFormsToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignFormsToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignFormsToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param componentType (optional) 
     * @return Success
     */
    getUserCustomerShipmentTypeListByForm(componentType: ComponentType2 | null | undefined): Observable<ShipmentTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetUserCustomerShipmentTypeListByForm?";
        if (componentType !== undefined)
            url_ += "componentType=" + encodeURIComponent("" + componentType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCustomerShipmentTypeListByForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCustomerShipmentTypeListByForm(<any>response_);
                } catch (e) {
                    return <Observable<ShipmentTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ShipmentTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserCustomerShipmentTypeListByForm(response: HttpResponseBase): Observable<ShipmentTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ShipmentTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShipmentTypeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getMainOrderCardsByUserForms(): Observable<OrderCardDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetMainOrderCardsByUserForms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainOrderCardsByUserForms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainOrderCardsByUserForms(<any>response_);
                } catch (e) {
                    return <Observable<OrderCardDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderCardDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetMainOrderCardsByUserForms(response: HttpResponseBase): Observable<OrderCardDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderCardDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderCardDto[]>(<any>null);
    }

    /**
     * @param orderCardId (optional) 
     * @return Success
     */
    getFormCardsByOrderCardId(orderCardId: number | null | undefined): Observable<UserFormOrderFormTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetFormCardsByOrderCardId?";
        if (orderCardId !== undefined)
            url_ += "orderCardId=" + encodeURIComponent("" + orderCardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormCardsByOrderCardId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormCardsByOrderCardId(<any>response_);
                } catch (e) {
                    return <Observable<UserFormOrderFormTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFormOrderFormTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFormCardsByOrderCardId(response: HttpResponseBase): Observable<UserFormOrderFormTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserFormOrderFormTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormOrderFormTypeDto[]>(<any>null);
    }

    /**
     * @param formId (optional) 
     * @return Success
     */
    getOrderFormTypeByUserFormAuthorization(formId: number | null | undefined): Observable<UserFormOrderFormTypeAuthDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetOrderFormTypeByUserFormAuthorization?";
        if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderFormTypeByUserFormAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderFormTypeByUserFormAuthorization(<any>response_);
                } catch (e) {
                    return <Observable<UserFormOrderFormTypeAuthDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFormOrderFormTypeAuthDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderFormTypeByUserFormAuthorization(response: HttpResponseBase): Observable<UserFormOrderFormTypeAuthDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormOrderFormTypeAuthDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormOrderFormTypeAuthDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserFormsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFormsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormsDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserFormsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserFormsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserFormsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserFormsDto | null | undefined): Observable<UserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserFormsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFormsDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserFormsDto | null | undefined): Observable<UserFormsDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserFormsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserFormsDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserFormsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserFormsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserFormsDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserForms/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserManagementSummaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserManagementSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserManagementSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserManagementSummaryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserManagementSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserManagementSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserManagementSummaryDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserManagementSummaryDto | null | undefined): Observable<UserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserManagementSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserManagementSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserManagementSummaryDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserManagementSummaryDto | null | undefined): Observable<UserManagementSummaryDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserManagementSummaryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserManagementSummaryDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserManagementSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserManagementSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserManagementSummaryDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserManagementSummary/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserModuleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserModuleDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserModulesByAuthorization(userId: number | null | undefined): Observable<UserModuleDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/GetUserModulesByAuthorization?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserModulesByAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserModulesByAuthorization(<any>response_);
                } catch (e) {
                    return <Observable<UserModuleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserModuleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserModulesByAuthorization(response: HttpResponseBase): Observable<UserModuleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserModuleDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserModuleDto | null | undefined): Observable<UserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserModuleDto | null | undefined): Observable<UserModuleDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserModuleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserModuleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserModuleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModuleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModuleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserModule/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserPagesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserPagesAuthorizationsByUserModule(userId: number | null | undefined): Observable<ModulePageDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/GetUserPagesAuthorizationsByUserModule?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPagesAuthorizationsByUserModule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPagesAuthorizationsByUserModule(<any>response_);
                } catch (e) {
                    return <Observable<ModulePageDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ModulePageDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPagesAuthorizationsByUserModule(response: HttpResponseBase): Observable<ModulePageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ModulePageDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ModulePageDto[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserPagesAuthorizations(userId: number | null | undefined): Observable<PageAuthorizationDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/GetUserPagesAuthorizations?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPagesAuthorizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPagesAuthorizations(<any>response_);
                } catch (e) {
                    return <Observable<PageAuthorizationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PageAuthorizationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPagesAuthorizations(response: HttpResponseBase): Observable<PageAuthorizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PageAuthorizationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageAuthorizationDto[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param defaultUserPageId (optional) 
     * @return Success
     */
    setPageAsDefault(userId: number | null | undefined, defaultUserPageId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/SetPageAsDefault?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (defaultUserPageId !== undefined)
            url_ += "defaultUserPageId=" + encodeURIComponent("" + defaultUserPageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPageAsDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPageAsDefault(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetPageAsDefault(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserPagesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPagesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPagesDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserPagesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserPagesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserPagesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserPagesDto | null | undefined): Observable<UserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserPagesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPagesDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPagesDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserPagesDto | null | undefined): Observable<UserPagesDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserPagesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPagesDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserPagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPagesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPagesDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPages/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserPermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param formId (optional) 
     * @return Success
     */
    getFromRequestWarehouseByUserAuths(formId: number | null | undefined): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetFromRequestWarehouseByUserAuths?";
        if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromRequestWarehouseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromRequestWarehouseByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFromRequestWarehouseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getFromReceiveWarehoseByUserAuths(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetFromReceiveWarehoseByUserAuths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromReceiveWarehoseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromReceiveWarehoseByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFromReceiveWarehoseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @param code (optional) 
     * @param addressId (optional) 
     * @param isSelected (optional) 
     * @return Success
     */
    getToReceiveWarehoseByUserAuths(id: number | null | undefined, name: string | null | undefined, code: string | null | undefined, addressId: number | null | undefined, isSelected: boolean | null | undefined): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetToReceiveWarehoseByUserAuths?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        if (addressId !== undefined)
            url_ += "AddressId=" + encodeURIComponent("" + addressId) + "&";
        if (isSelected !== undefined)
            url_ += "IsSelected=" + encodeURIComponent("" + isSelected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToReceiveWarehoseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToReceiveWarehoseByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetToReceiveWarehoseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getFromReceiveMobileWarehoseByUserAuths(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetFromReceiveMobileWarehoseByUserAuths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFromReceiveMobileWarehoseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFromReceiveMobileWarehoseByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFromReceiveMobileWarehoseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getToRequestWarehouseByUserAuths(): Observable<WarehouseSelectListDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetToRequestWarehouseByUserAuths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToRequestWarehouseByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToRequestWarehouseByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseSelectListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetToRequestWarehouseByUserAuths(response: HttpResponseBase): Observable<WarehouseSelectListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseSelectListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseSelectListDto[]>(<any>null);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getToRequestDistributorByUserAuths(searchTerm: string | null | undefined): Observable<PagedUserPermissionAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetToRequestDistributorByUserAuths?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToRequestDistributorByUserAuths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToRequestDistributorByUserAuths(<any>response_);
                } catch (e) {
                    return <Observable<PagedUserPermissionAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedUserPermissionAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetToRequestDistributorByUserAuths(response: HttpResponseBase): Observable<PagedUserPermissionAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedUserPermissionAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedUserPermissionAddressDto>(<any>null);
    }

    /**
     * @param selectedAddressTypeIds (optional) 
     * @return Success
     */
    getUserAssignedCityList(selectedAddressTypeIds: number[] | null | undefined): Observable<ToRequestCityDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserAssignedCityList?";
        if (selectedAddressTypeIds !== undefined)
            selectedAddressTypeIds && selectedAddressTypeIds.forEach(item => { url_ += "selectedAddressTypeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCityList(<any>response_);
                } catch (e) {
                    return <Observable<ToRequestCityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ToRequestCityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedCityList(response: HttpResponseBase): Observable<ToRequestCityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ToRequestCityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ToRequestCityDto[]>(<any>null);
    }

    /**
     * @param selectedAddressTypeIds (optional) 
     * @param cityId (optional) 
     * @param searchTerm (optional) 
     * @return Success
     */
    getUserCitiesAddressWithUserAssignedAddresses(selectedAddressTypeIds: number[] | null | undefined, cityId: number | null | undefined, searchTerm: string | null | undefined): Observable<PagedUserPermissionAddressDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserCitiesAddressWithUserAssignedAddresses?";
        if (selectedAddressTypeIds !== undefined)
            selectedAddressTypeIds && selectedAddressTypeIds.forEach(item => { url_ += "selectedAddressTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCitiesAddressWithUserAssignedAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCitiesAddressWithUserAssignedAddresses(<any>response_);
                } catch (e) {
                    return <Observable<PagedUserPermissionAddressDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedUserPermissionAddressDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserCitiesAddressWithUserAssignedAddresses(response: HttpResponseBase): Observable<PagedUserPermissionAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedUserPermissionAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedUserPermissionAddressDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUserAssignedCityAndDistrictListForAddAddress(): Observable<UserPermissionCityDistrictDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserAssignedCityAndDistrictListForAddAddress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedCityAndDistrictListForAddAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedCityAndDistrictListForAddAddress(<any>response_);
                } catch (e) {
                    return <Observable<UserPermissionCityDistrictDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPermissionCityDistrictDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedCityAndDistrictListForAddAddress(response: HttpResponseBase): Observable<UserPermissionCityDistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionCityDistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPermissionCityDistrictDto>(<any>null);
    }

    /**
     * @param cityId (optional) 
     * @param districtId (optional) 
     * @return Success
     */
    getUserAddAddressToCityAuthCitiesAddresses(cityId: number | null | undefined, districtId: number | null | undefined): Observable<UserPermissionAddressDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserAddAddressToCityAuthCitiesAddresses?";
        if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAddAddressToCityAuthCitiesAddresses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAddAddressToCityAuthCitiesAddresses(<any>response_);
                } catch (e) {
                    return <Observable<UserPermissionAddressDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPermissionAddressDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAddAddressToCityAuthCitiesAddresses(response: HttpResponseBase): Observable<UserPermissionAddressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserPermissionAddressDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPermissionAddressDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getUserStokViewInformation(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserStokViewInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserStokViewInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserStokViewInformation(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserStokViewInformation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param componentType (optional) 
     * @return Success
     */
    checkUserAuthorizationByForm(componentType: ComponentType3 | null | undefined): Observable<UserPermissionFormAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/CheckUserAuthorizationByForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(componentType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserAuthorizationByForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserAuthorizationByForm(<any>response_);
                } catch (e) {
                    return <Observable<UserPermissionFormAuthorizationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPermissionFormAuthorizationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckUserAuthorizationByForm(response: HttpResponseBase): Observable<UserPermissionFormAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPermissionFormAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPermissionFormAuthorizationDto>(<any>null);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    checkUserReportAuthorization(reportId: number | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/CheckUserReportAuthorization?";
        if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserReportAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserReportAuthorization(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckUserReportAuthorization(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserCustomerOtherSettings(userId: number | null | undefined): Observable<UserOtherSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/GetUserCustomerOtherSettings?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserCustomerOtherSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCustomerOtherSettings(<any>response_);
                } catch (e) {
                    return <Observable<UserOtherSettingsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserOtherSettingsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserCustomerOtherSettings(response: HttpResponseBase): Observable<UserOtherSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserOtherSettingsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOtherSettingsDto[]>(<any>null);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateStockView(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateStockView?";
        if (userCustomerId !== undefined)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStockView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStockView(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateStockView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateProductLocationOrderHistoryView(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateProductLocationOrderHistoryView?";
        if (userCustomerId !== undefined)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductLocationOrderHistoryView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductLocationOrderHistoryView(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProductLocationOrderHistoryView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateOnlyWmsProducts(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateOnlyWmsProducts?";
        if (userCustomerId !== undefined)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOnlyWmsProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOnlyWmsProducts(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOnlyWmsProducts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateRequestListStockView(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateRequestListStockView?";
        if (userCustomerId !== undefined)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequestListStockView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequestListStockView(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRequestListStockView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateShowPalletQuantity(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateShowPalletQuantity?";
        if (userCustomerId !== undefined)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShowPalletQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShowPalletQuantity(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateShowPalletQuantity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userCustomerId (optional) 
     * @param data (optional) 
     * @return Success
     */
    updateShowTotalShipmentPrice(userCustomerId: number | null | undefined, data: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserPermission/UpdateShowTotalShipmentPrice?";
        if (userCustomerId !== undefined)
            url_ += "userCustomerId=" + encodeURIComponent("" + userCustomerId) + "&";
        if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShowTotalShipmentPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShowTotalShipmentPrice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateShowTotalShipmentPrice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserProductAttributeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedProductAttributes(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/GetUserAssignedProductAttributes?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedProductAttributes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedProductAttributes(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedProductAttributes(response: HttpResponseBase): Observable<PagedResultDtoOfUserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserProductAttributeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUserAssignedProductAttributesByGlobalFilters(): Observable<UserProductAttributeDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/GetUserAssignedProductAttributesByGlobalFilters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedProductAttributesByGlobalFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedProductAttributesByGlobalFilters(<any>response_);
                } catch (e) {
                    return <Observable<UserProductAttributeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProductAttributeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedProductAttributesByGlobalFilters(response: HttpResponseBase): Observable<UserProductAttributeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserProductAttributeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignProductAttributesToUser(input: CreateUserProductAttributeDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/SetAssignProductAttributesToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignProductAttributesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignProductAttributesToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignProductAttributesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userProductAttributeIds (optional) 
     * @return Success
     */
    setUnAssigProductAttributesToUser(userProductAttributeIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/SetUnAssigProductAttributesToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userProductAttributeIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssigProductAttributesToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssigProductAttributesToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssigProductAttributesToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserProductAttributeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserProductAttributeDto | null | undefined): Observable<UserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserProductAttributeDto | null | undefined): Observable<UserProductAttributeDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserProductAttributeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserProductAttributeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserProductAttributeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProductAttributeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProductAttributeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserProductAttribute/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getUserAssignedReports(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/GetUserAssignedReports?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedReports(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedReports(response: HttpResponseBase): Observable<PagedResultDtoOfUserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserReportDto>(<any>null);
    }

    /**
     * @param moduleId (optional) 
     * @return Success
     */
    getAssignedReports(moduleId: number | null | undefined): Observable<UserReportDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/GetAssignedReports?";
        if (moduleId !== undefined)
            url_ += "moduleId=" + encodeURIComponent("" + moduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedReports(<any>response_);
                } catch (e) {
                    return <Observable<UserReportDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserReportDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAssignedReports(response: HttpResponseBase): Observable<UserReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserReportDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignReportToUser(input: CreateUserReportDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/SetAssignReportToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignReportToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignReportToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignReportToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userReportIds (optional) 
     * @return Success
     */
    setUnAssignReportToUser(userReportIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/SetUnAssignReportToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userReportIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignReportToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignReportToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignReportToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setIsOpenNewScreen(input: UserReportOpenNewScreenDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/SetIsOpenNewScreen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIsOpenNewScreen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIsOpenNewScreen(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetIsOpenNewScreen(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserReportDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserReportDto | null | undefined): Observable<UserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserReportDto | null | undefined): Observable<UserReportDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserReportDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserReportDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserReport/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserRoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserRolesByAuthorization(userId: number | null | undefined): Observable<UserRoleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/GetUserRolesByAuthorization?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRolesByAuthorization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRolesByAuthorization(<any>response_);
                } catch (e) {
                    return <Observable<UserRoleDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRoleDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserRolesByAuthorization(response: HttpResponseBase): Observable<UserRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserRoleDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserRoleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserRoleDto | null | undefined): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserRoleDto | null | undefined): Observable<UserRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserRoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRole/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserRouteStartLocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserRouteStartLocationDto> {
        let url_ = this.baseUrl + "/api/services/smr/UserRouteStartLocation/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserRouteStartLocationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserRouteStartLocationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserRouteStartLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserRouteStartLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserRouteStartLocationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserRouteStartLocationDto | null | undefined): Observable<UserRouteStartLocationDto> {
        let url_ = this.baseUrl + "/api/services/smr/UserRouteStartLocation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserRouteStartLocationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRouteStartLocationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserRouteStartLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRouteStartLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRouteStartLocationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserRouteStartLocationDto | null | undefined): Observable<UserRouteStartLocationDto> {
        let url_ = this.baseUrl + "/api/services/smr/UserRouteStartLocation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserRouteStartLocationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRouteStartLocationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserRouteStartLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRouteStartLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRouteStartLocationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserRouteStartLocationDto> {
        let url_ = this.baseUrl + "/api/services/smr/UserRouteStartLocation/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserRouteStartLocationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRouteStartLocationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserRouteStartLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRouteStartLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRouteStartLocationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/smr/UserRouteStartLocation/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserWarehouseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param warehouseList (optional) 
     * @param userId (optional) 
     * @return Success
     */
    updateWarehousesWithPermission(warehouseList: CustomerWarehouseDto[] | null | undefined, userId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/UpdateWarehousesWithPermission?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(warehouseList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWarehousesWithPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWarehousesWithPermission(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateWarehousesWithPermission(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getWarehousesWithPermission(userId: number | null | undefined): Observable<CustomerWarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/GetWarehousesWithPermission?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehousesWithPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehousesWithPermission(<any>response_);
                } catch (e) {
                    return <Observable<CustomerWarehouseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerWarehouseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWarehousesWithPermission(response: HttpResponseBase): Observable<CustomerWarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerWarehouseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerWarehouseDto[]>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserAssignedWarehouses(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfUserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/GetUserAssignedWarehouses?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (authorizationId !== undefined)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAssignedWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAssignedWarehouses(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserAssignedWarehouses(response: HttpResponseBase): Observable<PagedResultDtoOfUserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserWarehouseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setAssignWarehouseToUser(input: CreateUserWarehouseDto | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/SetAssignWarehouseToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignWarehouseToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignWarehouseToUser(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignWarehouseToUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param userWarehouseIds (optional) 
     * @return Success
     */
    setUnAssignWarehouseToUser(userWarehouseIds: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/SetUnAssignWarehouseToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userWarehouseIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUnAssignWarehouseToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUnAssignWarehouseToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUnAssignWarehouseToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    setUserWarehouseUnAssignAll(userId: number | null | undefined, warehouseId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/SetUserWarehouseUnAssignAll?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUserWarehouseUnAssignAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUserWarehouseUnAssignAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetUserWarehouseUnAssignAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserWarehouseDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, userId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserWarehouseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateUserWarehouseDto | null | undefined): Observable<UserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserWarehouseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserWarehouseDto | null | undefined): Observable<UserWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserWarehouseDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/UserWarehouse/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class WarehouseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMainWarehouses(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetMainWarehouses?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMainWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMainWarehouses(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMainWarehouses(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseDto>(<any>null);
    }

    /**
     * @param excludedMainWarehouseId (optional) 
     * @return Success
     */
    getUnAssignedDependWarehouses(excludedMainWarehouseId: number | null | undefined): Observable<DependWarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetUnAssignedDependWarehouses?";
        if (excludedMainWarehouseId !== undefined)
            url_ += "excludedMainWarehouseId=" + encodeURIComponent("" + excludedMainWarehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnAssignedDependWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnAssignedDependWarehouses(<any>response_);
                } catch (e) {
                    return <Observable<DependWarehouseDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DependWarehouseDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUnAssignedDependWarehouses(response: HttpResponseBase): Observable<DependWarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DependWarehouseDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DependWarehouseDto[]>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param userId (optional) 
     * @param authorizationId (optional) 
     * @return Success
     */
    getUserUnAssignedWarehouses(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, userId: number | null | undefined, authorizationId: number | null | undefined): Observable<PagedResultDtoOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetUserUnAssignedWarehouses?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (authorizationId !== undefined)
            url_ += "authorizationId=" + encodeURIComponent("" + authorizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserUnAssignedWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserUnAssignedWarehouses(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserUnAssignedWarehouses(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateWarehouseDto | null | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(<any>null);
    }

    /**
     * @param warehouseId (optional) 
     * @param customerId (optional) 
     * @param ownerId (optional) 
     * @return Success
     */
    setAssignedOwnerToWarehouse(warehouseId: number | null | undefined, customerId: number | null | undefined, ownerId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/SetAssignedOwnerToWarehouse?";
        if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (ownerId !== undefined)
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignedOwnerToWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedOwnerToWarehouse(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAssignedOwnerToWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param remoteWarehouseId (optional) 
     * @param mainWarehouseId (optional) 
     * @return Success
     */
    addDependToWarehouse(remoteWarehouseId: number | null | undefined, mainWarehouseId: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/AddDependToWarehouse?";
        if (remoteWarehouseId !== undefined)
            url_ += "remoteWarehouseId=" + encodeURIComponent("" + remoteWarehouseId) + "&";
        if (mainWarehouseId !== undefined)
            url_ += "mainWarehouseId=" + encodeURIComponent("" + mainWarehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDependToWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDependToWarehouse(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddDependToWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateWarehouseDto | null | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<WarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseDto>(<any>null);
    }

    /**
     * @param selectedItem (optional) 
     * @return Success
     */
    getCustomerComboboxItems(selectedItem: number | null | undefined): Observable<ListResultDtoOfComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetCustomerComboboxItems?";
        if (selectedItem !== undefined)
            url_ += "selectedItem=" + encodeURIComponent("" + selectedItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfComboboxItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfComboboxItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerComboboxItems(response: HttpResponseBase): Observable<ListResultDtoOfComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfComboboxItemDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllForExcel(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<ExcelPagedResultDtoOfWarehouseExcelDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetAllForExcel?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForExcel(<any>response_);
                } catch (e) {
                    return <Observable<ExcelPagedResultDtoOfWarehouseExcelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExcelPagedResultDtoOfWarehouseExcelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllForExcel(response: HttpResponseBase): Observable<ExcelPagedResultDtoOfWarehouseExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcelPagedResultDtoOfWarehouseExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExcelPagedResultDtoOfWarehouseExcelDto>(<any>null);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getWarehouseCustomers(warehouseId: number | null | undefined): Observable<WarehouseCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetWarehouseCustomers?";
        if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehouseCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseCustomers(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseCustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseCustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetWarehouseCustomers(response: HttpResponseBase): Observable<WarehouseCustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseCustomerDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseCustomerDto[]>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/Warehouse/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfWarehouseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfWarehouseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseDto>(<any>null);
    }
}

@Injectable()
export class WarehouseOwnerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param warehouseId (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerWarehouseOwners(warehouseId: number | null | undefined, customerId: number | null | undefined): Observable<WarehouseOwnerUserDto[]> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/GetCustomerWarehouseOwners?";
        if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerWarehouseOwners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerWarehouseOwners(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseOwnerUserDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseOwnerUserDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCustomerWarehouseOwners(response: HttpResponseBase): Observable<WarehouseOwnerUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(WarehouseOwnerUserDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerUserDto[]>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param ownerId (optional) 
     * @param warehouseId (optional) 
     * @param customerId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, sorting: string | null | undefined, ownerId: number | null | undefined, warehouseId: number | null | undefined, customerId: number | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfWarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (ownerId !== undefined)
            url_ += "OwnerId=" + encodeURIComponent("" + ownerId) + "&";
        if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfWarehouseOwnerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfWarehouseOwnerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfWarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfWarehouseOwnerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateWarehouseOwnerDto | null | undefined): Observable<WarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseOwnerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseOwnerDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateWarehouseOwnerDto | null | undefined): Observable<WarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseOwnerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseOwnerDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<WarehouseOwnerDto> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<WarehouseOwnerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WarehouseOwnerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WarehouseOwnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseOwnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WarehouseOwnerDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/transpop/portal/admin/WarehouseOwner/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean | undefined;
}

export class ResetPasswordRequestInput implements IResetPasswordRequestInput {
    emailAddress: string | undefined;
    returnUrl: string | undefined;
    module: ResetPasswordRequestInputModule | undefined;

    constructor(data?: IResetPasswordRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.returnUrl = _data["returnUrl"];
            this.module = _data["module"];
        }
    }

    static fromJS(data: any): ResetPasswordRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["returnUrl"] = this.returnUrl;
        data["module"] = this.module;
        return data; 
    }

    clone(): ResetPasswordRequestInput {
        const json = this.toJSON();
        let result = new ResetPasswordRequestInput();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordRequestInput {
    emailAddress: string | undefined;
    returnUrl: string | undefined;
    module: ResetPasswordRequestInputModule | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
    token: string | undefined;
    newPassword: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ResetPasswordInput {
        const json = this.toJSON();
        let result = new ResetPasswordInput();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordInput {
    token: string | undefined;
    newPassword: string | undefined;
}

export class PagedResultDtoOfAddressDto implements IPagedResultDtoOfAddressDto {
    totalCount: number | undefined;
    items: AddressDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfAddressDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAddressDto {
    totalCount: number | undefined;
    items: AddressDto[] | undefined;
}

export class AddressDto implements IAddressDto {
    poiId: string | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    phone1: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    categoryName: string | undefined;
    id: number | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poiId = _data["poiId"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            this.phone1 = _data["phone1"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.categoryName = _data["categoryName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poiId"] = this.poiId;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["phone1"] = this.phone1;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["categoryName"] = this.categoryName;
        data["id"] = this.id;
        return data; 
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    poiId: string | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    phone1: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    categoryName: string | undefined;
    id: number | undefined;
}

export class AddressSimilarityDto implements IAddressSimilarityDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    readonly searchedAddress: string | undefined;

    constructor(data?: IAddressSimilarityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            (<any>this).searchedAddress = _data["searchedAddress"];
        }
    }

    static fromJS(data: any): AddressSimilarityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSimilarityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["searchedAddress"] = this.searchedAddress;
        return data; 
    }

    clone(): AddressSimilarityDto {
        const json = this.toJSON();
        let result = new AddressSimilarityDto();
        result.init(json);
        return result;
    }
}

export interface IAddressSimilarityDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    searchedAddress: string | undefined;
}

export class AddressSimilarityResultDto implements IAddressSimilarityResultDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    percent: number | undefined;
    isCriticalSimilarity: boolean | undefined;

    constructor(data?: IAddressSimilarityResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            this.percent = _data["percent"];
            this.isCriticalSimilarity = _data["isCriticalSimilarity"];
        }
    }

    static fromJS(data: any): AddressSimilarityResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSimilarityResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["percent"] = this.percent;
        data["isCriticalSimilarity"] = this.isCriticalSimilarity;
        return data; 
    }

    clone(): AddressSimilarityResultDto {
        const json = this.toJSON();
        let result = new AddressSimilarityResultDto();
        result.init(json);
        return result;
    }
}

export interface IAddressSimilarityResultDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    percent: number | undefined;
    isCriticalSimilarity: boolean | undefined;
}

export class ExcelFileResultDto implements IExcelFileResultDto {
    base64: string | undefined;
    fileType: string | undefined;
    fileName: string | undefined;

    constructor(data?: IExcelFileResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ExcelFileResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelFileResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        return data; 
    }

    clone(): ExcelFileResultDto {
        const json = this.toJSON();
        let result = new ExcelFileResultDto();
        result.init(json);
        return result;
    }
}

export interface IExcelFileResultDto {
    base64: string | undefined;
    fileType: string | undefined;
    fileName: string | undefined;
}

export class CustomerAddressExcelUploadDto implements ICustomerAddressExcelUploadDto {
    customerId: number;
    base64: string | undefined;

    constructor(data?: ICustomerAddressExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): CustomerAddressExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["base64"] = this.base64;
        return data; 
    }

    clone(): CustomerAddressExcelUploadDto {
        const json = this.toJSON();
        let result = new CustomerAddressExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerAddressExcelUploadDto {
    customerId: number;
    base64: string | undefined;
}

export class CreateAddressDto implements ICreateAddressDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateAddressDto {
        const json = this.toJSON();
        let result = new CreateAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressDto {
    name: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfAuthorizationDomainAuthTypeDto implements IPagedResultDtoOfAuthorizationDomainAuthTypeDto {
    totalCount: number | undefined;
    items: AuthorizationDomainAuthTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuthorizationDomainAuthTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AuthorizationDomainAuthTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuthorizationDomainAuthTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuthorizationDomainAuthTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfAuthorizationDomainAuthTypeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAuthorizationDomainAuthTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAuthorizationDomainAuthTypeDto {
    totalCount: number | undefined;
    items: AuthorizationDomainAuthTypeDto[] | undefined;
}

export class AuthorizationDomainAuthTypeDto implements IAuthorizationDomainAuthTypeDto {
    name: string | undefined;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    id: number | undefined;

    constructor(data?: IAuthorizationDomainAuthTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.databaseName = _data["databaseName"];
            this.databaseTableName = _data["databaseTableName"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.userFriendlyDescription = _data["userFriendlyDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuthorizationDomainAuthTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationDomainAuthTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["databaseName"] = this.databaseName;
        data["databaseTableName"] = this.databaseTableName;
        data["userFriendlyName"] = this.userFriendlyName;
        data["userFriendlyDescription"] = this.userFriendlyDescription;
        data["id"] = this.id;
        return data; 
    }

    clone(): AuthorizationDomainAuthTypeDto {
        const json = this.toJSON();
        let result = new AuthorizationDomainAuthTypeDto();
        result.init(json);
        return result;
    }
}

export interface IAuthorizationDomainAuthTypeDto {
    name: string | undefined;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    id: number | undefined;
}

export class CreateAuthorizationTypeDto implements ICreateAuthorizationTypeDto {
    name: string;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    objectRelationTypeId: number | undefined;
    isViewOnClient: boolean;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    sortIndex: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateAuthorizationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.databaseName = _data["databaseName"];
            this.databaseTableName = _data["databaseTableName"];
            this.objectRelationTypeId = _data["objectRelationTypeId"];
            this.isViewOnClient = _data["isViewOnClient"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.userFriendlyDescription = _data["userFriendlyDescription"];
            this.sortIndex = _data["sortIndex"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateAuthorizationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuthorizationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["databaseName"] = this.databaseName;
        data["databaseTableName"] = this.databaseTableName;
        data["objectRelationTypeId"] = this.objectRelationTypeId;
        data["isViewOnClient"] = this.isViewOnClient;
        data["userFriendlyName"] = this.userFriendlyName;
        data["userFriendlyDescription"] = this.userFriendlyDescription;
        data["sortIndex"] = this.sortIndex;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateAuthorizationTypeDto {
        const json = this.toJSON();
        let result = new CreateAuthorizationTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAuthorizationTypeDto {
    name: string;
    comment: string | undefined;
    databaseName: string | undefined;
    databaseTableName: string | undefined;
    objectRelationTypeId: number | undefined;
    isViewOnClient: boolean;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    sortIndex: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfCategoryDto implements IPagedResultDtoOfCategoryDto {
    totalCount: number | undefined;
    items: CategoryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCategoryDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCategoryDto {
    totalCount: number | undefined;
    items: CategoryDto[] | undefined;
}

export class CategoryDto implements ICategoryDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): CategoryDto {
        const json = this.toJSON();
        let result = new CategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDto {
    name: string | undefined;
    id: number | undefined;
}

export class CreateCategoryDto implements ICreateCategoryDto {
    id: number | undefined;

    constructor(data?: ICreateCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateCategoryDto {
        const json = this.toJSON();
        let result = new CreateCategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCategoryDto {
    id: number | undefined;
}

export class PagedResultDtoOfCityDto implements IPagedResultDtoOfCityDto {
    totalCount: number | undefined;
    items: CityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCityDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCityDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCityDto {
    totalCount: number | undefined;
    items: CityDto[] | undefined;
}

export class CityDto implements ICityDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): CityDto {
        const json = this.toJSON();
        let result = new CityDto();
        result.init(json);
        return result;
    }
}

export interface ICityDto {
    name: string | undefined;
    id: number | undefined;
}

export class CreateCityDto implements ICreateCityDto {
    id: number;
    name: string;

    constructor(data?: ICreateCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): CreateCityDto {
        const json = this.toJSON();
        let result = new CreateCityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCityDto {
    id: number;
    name: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data; 
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class PagedResultDtoOfCustomerDto implements IPagedResultDtoOfCustomerDto {
    totalCount: number | undefined;
    items: CustomerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCustomerDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCustomerDto {
    totalCount: number | undefined;
    items: CustomerDto[] | undefined;
}

export class CustomerDto implements ICustomerDto {
    name: string | undefined;
    code: string | undefined;
    comment: string | undefined;
    approvalMinute: number | undefined;
    productSizeApprovalMinute: number | undefined;
    isCheckOrderProductSize: boolean | undefined;
    personInChargeUserId: number | undefined;
    assignedWarehouses: CustomerWarehouseAssignedDto[] | undefined;
    assignedProductUsagePurposes: CustomerProductUsagePurposeAssignedDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.comment = _data["comment"];
            this.approvalMinute = _data["approvalMinute"];
            this.productSizeApprovalMinute = _data["productSizeApprovalMinute"];
            this.isCheckOrderProductSize = _data["isCheckOrderProductSize"];
            this.personInChargeUserId = _data["personInChargeUserId"];
            if (Array.isArray(_data["assignedWarehouses"])) {
                this.assignedWarehouses = [] as any;
                for (let item of _data["assignedWarehouses"])
                    this.assignedWarehouses.push(CustomerWarehouseAssignedDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedProductUsagePurposes"])) {
                this.assignedProductUsagePurposes = [] as any;
                for (let item of _data["assignedProductUsagePurposes"])
                    this.assignedProductUsagePurposes.push(CustomerProductUsagePurposeAssignedDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["comment"] = this.comment;
        data["approvalMinute"] = this.approvalMinute;
        data["productSizeApprovalMinute"] = this.productSizeApprovalMinute;
        data["isCheckOrderProductSize"] = this.isCheckOrderProductSize;
        data["personInChargeUserId"] = this.personInChargeUserId;
        if (Array.isArray(this.assignedWarehouses)) {
            data["assignedWarehouses"] = [];
            for (let item of this.assignedWarehouses)
                data["assignedWarehouses"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedProductUsagePurposes)) {
            data["assignedProductUsagePurposes"] = [];
            for (let item of this.assignedProductUsagePurposes)
                data["assignedProductUsagePurposes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    name: string | undefined;
    code: string | undefined;
    comment: string | undefined;
    approvalMinute: number | undefined;
    productSizeApprovalMinute: number | undefined;
    isCheckOrderProductSize: boolean | undefined;
    personInChargeUserId: number | undefined;
    assignedWarehouses: CustomerWarehouseAssignedDto[] | undefined;
    assignedProductUsagePurposes: CustomerProductUsagePurposeAssignedDto[] | undefined;
    id: number | undefined;
}

export class CustomerWarehouseAssignedDto implements ICustomerWarehouseAssignedDto {
    warehouseId: number | undefined;
    warehouseOwnerId: number | undefined;

    constructor(data?: ICustomerWarehouseAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.warehouseOwnerId = _data["warehouseOwnerId"];
        }
    }

    static fromJS(data: any): CustomerWarehouseAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWarehouseAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["warehouseOwnerId"] = this.warehouseOwnerId;
        return data; 
    }

    clone(): CustomerWarehouseAssignedDto {
        const json = this.toJSON();
        let result = new CustomerWarehouseAssignedDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerWarehouseAssignedDto {
    warehouseId: number | undefined;
    warehouseOwnerId: number | undefined;
}

export class CustomerProductUsagePurposeAssignedDto implements ICustomerProductUsagePurposeAssignedDto {
    productUsagePurposeTypeId: number | undefined;

    constructor(data?: ICustomerProductUsagePurposeAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productUsagePurposeTypeId = _data["productUsagePurposeTypeId"];
        }
    }

    static fromJS(data: any): CustomerProductUsagePurposeAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProductUsagePurposeAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productUsagePurposeTypeId"] = this.productUsagePurposeTypeId;
        return data; 
    }

    clone(): CustomerProductUsagePurposeAssignedDto {
        const json = this.toJSON();
        let result = new CustomerProductUsagePurposeAssignedDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerProductUsagePurposeAssignedDto {
    productUsagePurposeTypeId: number | undefined;
}

export class CreateCustomerDto implements ICreateCustomerDto {
    name: string;
    code: string;
    approvalMinute: number;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.approvalMinute = _data["approvalMinute"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["approvalMinute"] = this.approvalMinute;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateCustomerDto {
        const json = this.toJSON();
        let result = new CreateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerDto {
    name: string;
    code: string;
    approvalMinute: number;
    comment: string | undefined;
    id: number | undefined;
}

export class SelectListItemDto implements ISelectListItemDto {
    disabled: boolean | undefined;
    selected: boolean | undefined;
    text: string | undefined;
    value: any | undefined;
    subSelectList: SelectListItemDto[] | undefined;

    constructor(data?: ISelectListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"];
            this.selected = _data["selected"];
            this.text = _data["text"];
            this.value = _data["value"];
            if (Array.isArray(_data["subSelectList"])) {
                this.subSelectList = [] as any;
                for (let item of _data["subSelectList"])
                    this.subSelectList.push(SelectListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled;
        data["selected"] = this.selected;
        data["text"] = this.text;
        data["value"] = this.value;
        if (Array.isArray(this.subSelectList)) {
            data["subSelectList"] = [];
            for (let item of this.subSelectList)
                data["subSelectList"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SelectListItemDto {
        const json = this.toJSON();
        let result = new SelectListItemDto();
        result.init(json);
        return result;
    }
}

export interface ISelectListItemDto {
    disabled: boolean | undefined;
    selected: boolean | undefined;
    text: string | undefined;
    value: any | undefined;
    subSelectList: SelectListItemDto[] | undefined;
}

export class ExcelPagedResultDtoOfCustomerExcelDto implements IExcelPagedResultDtoOfCustomerExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: CustomerExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfCustomerExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfCustomerExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfCustomerExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ExcelPagedResultDtoOfCustomerExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfCustomerExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfCustomerExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: CustomerExcelDto[] | undefined;
}

export class ExcelColumn implements IExcelColumn {
    name: string | undefined;
    asName: string | undefined;

    constructor(data?: IExcelColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.asName = _data["asName"];
        }
    }

    static fromJS(data: any): ExcelColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["asName"] = this.asName;
        return data; 
    }

    clone(): ExcelColumn {
        const json = this.toJSON();
        let result = new ExcelColumn();
        result.init(json);
        return result;
    }
}

export interface IExcelColumn {
    name: string | undefined;
    asName: string | undefined;
}

export class CustomerExcelDto implements ICustomerExcelDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;

    constructor(data?: ICustomerExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }

    clone(): CustomerExcelDto {
        const json = this.toJSON();
        let result = new CustomerExcelDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerExcelDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfComboboxItemDto implements IListResultDtoOfComboboxItemDto {
    items: ComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfComboboxItemDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfComboboxItemDto {
    items: ComboboxItemDto[] | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }

    clone(): ComboboxItemDto {
        const json = this.toJSON();
        let result = new ComboboxItemDto();
        result.init(json);
        return result;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean | undefined;
}

export class CustomerWarehouseListDto implements ICustomerWarehouseListDto {
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    isChecked: boolean | undefined;
    isDisable: boolean | undefined;
    assignedCustomerName: string | undefined;
    readonly disabledVirtualWarehouseName: string | undefined;
    warehouseOwnerId: number | undefined;

    constructor(data?: ICustomerWarehouseListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.isChecked = _data["isChecked"];
            this.isDisable = _data["isDisable"];
            this.assignedCustomerName = _data["assignedCustomerName"];
            (<any>this).disabledVirtualWarehouseName = _data["disabledVirtualWarehouseName"];
            this.warehouseOwnerId = _data["warehouseOwnerId"];
        }
    }

    static fromJS(data: any): CustomerWarehouseListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWarehouseListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["isChecked"] = this.isChecked;
        data["isDisable"] = this.isDisable;
        data["assignedCustomerName"] = this.assignedCustomerName;
        data["disabledVirtualWarehouseName"] = this.disabledVirtualWarehouseName;
        data["warehouseOwnerId"] = this.warehouseOwnerId;
        return data; 
    }

    clone(): CustomerWarehouseListDto {
        const json = this.toJSON();
        let result = new CustomerWarehouseListDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerWarehouseListDto {
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    isChecked: boolean | undefined;
    isDisable: boolean | undefined;
    assignedCustomerName: string | undefined;
    disabledVirtualWarehouseName: string | undefined;
    warehouseOwnerId: number | undefined;
}

export class CustomerPersonOfChargeDto implements ICustomerPersonOfChargeDto {
    userId: number | undefined;
    userName: string | undefined;
    isChecked: boolean | undefined;

    constructor(data?: ICustomerPersonOfChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.isChecked = _data["isChecked"];
        }
    }

    static fromJS(data: any): CustomerPersonOfChargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPersonOfChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["isChecked"] = this.isChecked;
        return data; 
    }

    clone(): CustomerPersonOfChargeDto {
        const json = this.toJSON();
        let result = new CustomerPersonOfChargeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerPersonOfChargeDto {
    userId: number | undefined;
    userName: string | undefined;
    isChecked: boolean | undefined;
}

export class CustomerUserListDto implements ICustomerUserListDto {
    userId: number | undefined;
    userName: string | undefined;

    constructor(data?: ICustomerUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CustomerUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }

    clone(): CustomerUserListDto {
        const json = this.toJSON();
        let result = new CustomerUserListDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerUserListDto {
    userId: number | undefined;
    userName: string | undefined;
}

export class PagedResultDtoOfCustomerThemeDto implements IPagedResultDtoOfCustomerThemeDto {
    totalCount: number | undefined;
    items: CustomerThemeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerThemeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCustomerThemeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCustomerThemeDto {
    totalCount: number | undefined;
    items: CustomerThemeDto[] | undefined;
}

export class CustomerThemeDto implements ICustomerThemeDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    portalLogoPath: string | undefined;
    negativePortalLogoPath: string | undefined;
    customerLogoPath: string | undefined;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: ICustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.portalLogoPath = _data["portalLogoPath"];
            this.negativePortalLogoPath = _data["negativePortalLogoPath"];
            this.customerLogoPath = _data["customerLogoPath"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["portalLogoPath"] = this.portalLogoPath;
        data["negativePortalLogoPath"] = this.negativePortalLogoPath;
        data["customerLogoPath"] = this.customerLogoPath;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data; 
    }

    clone(): CustomerThemeDto {
        const json = this.toJSON();
        let result = new CustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerThemeDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    portalLogoPath: string | undefined;
    negativePortalLogoPath: string | undefined;
    customerLogoPath: string | undefined;
    comment: string | undefined;
    id: number | undefined;
}

export class CreateCustomerThemeDto implements ICreateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string;
    negativePortalLogoBase64: string;
    customerLogoBase64: string;
    comment: string | undefined;

    constructor(data?: ICreateCustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.portalLogoBase64 = _data["portalLogoBase64"];
            this.negativePortalLogoBase64 = _data["negativePortalLogoBase64"];
            this.customerLogoBase64 = _data["customerLogoBase64"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateCustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["portalLogoBase64"] = this.portalLogoBase64;
        data["negativePortalLogoBase64"] = this.negativePortalLogoBase64;
        data["customerLogoBase64"] = this.customerLogoBase64;
        data["comment"] = this.comment;
        return data; 
    }

    clone(): CreateCustomerThemeDto {
        const json = this.toJSON();
        let result = new CreateCustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string;
    negativePortalLogoBase64: string;
    customerLogoBase64: string;
    comment: string | undefined;
}

export class UpdateCustomerThemeDto implements IUpdateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string | undefined;
    negativePortalLogoBase64: string | undefined;
    customerLogoBase64: string | undefined;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: IUpdateCustomerThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.portalLogoBase64 = _data["portalLogoBase64"];
            this.negativePortalLogoBase64 = _data["negativePortalLogoBase64"];
            this.customerLogoBase64 = _data["customerLogoBase64"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCustomerThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["portalLogoBase64"] = this.portalLogoBase64;
        data["negativePortalLogoBase64"] = this.negativePortalLogoBase64;
        data["customerLogoBase64"] = this.customerLogoBase64;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateCustomerThemeDto {
        const json = this.toJSON();
        let result = new UpdateCustomerThemeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerThemeDto {
    name: string;
    customerId: number;
    portalLogoBase64: string | undefined;
    negativePortalLogoBase64: string | undefined;
    customerLogoBase64: string | undefined;
    comment: string | undefined;
    id: number | undefined;
}

export class CustomerThemeSizeDto implements ICustomerThemeSizeDto {
    portalHeight: number | undefined;
    portalWidth: number | undefined;
    negativePortalHeight: number | undefined;
    negativePortalWidth: number | undefined;
    customerHeight: number | undefined;
    customerWidth: number | undefined;

    constructor(data?: ICustomerThemeSizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalHeight = _data["portalHeight"];
            this.portalWidth = _data["portalWidth"];
            this.negativePortalHeight = _data["negativePortalHeight"];
            this.negativePortalWidth = _data["negativePortalWidth"];
            this.customerHeight = _data["customerHeight"];
            this.customerWidth = _data["customerWidth"];
        }
    }

    static fromJS(data: any): CustomerThemeSizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerThemeSizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalHeight"] = this.portalHeight;
        data["portalWidth"] = this.portalWidth;
        data["negativePortalHeight"] = this.negativePortalHeight;
        data["negativePortalWidth"] = this.negativePortalWidth;
        data["customerHeight"] = this.customerHeight;
        data["customerWidth"] = this.customerWidth;
        return data; 
    }

    clone(): CustomerThemeSizeDto {
        const json = this.toJSON();
        let result = new CustomerThemeSizeDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerThemeSizeDto {
    portalHeight: number | undefined;
    portalWidth: number | undefined;
    negativePortalHeight: number | undefined;
    negativePortalWidth: number | undefined;
    customerHeight: number | undefined;
    customerWidth: number | undefined;
}

export class PagedResultDtoOfDatasetDto implements IPagedResultDtoOfDatasetDto {
    totalCount: number | undefined;
    items: DatasetDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DatasetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfDatasetDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDatasetDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDatasetDto {
    totalCount: number | undefined;
    items: DatasetDto[] | undefined;
}

export class DatasetDto implements IDatasetDto {
    name: string | undefined;
    platomUserId: string | undefined;
    relatedLocationCount: number | undefined;
    relatedPlanCount: number | undefined;
    id: number | undefined;

    constructor(data?: IDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.platomUserId = _data["platomUserId"];
            this.relatedLocationCount = _data["relatedLocationCount"];
            this.relatedPlanCount = _data["relatedPlanCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["platomUserId"] = this.platomUserId;
        data["relatedLocationCount"] = this.relatedLocationCount;
        data["relatedPlanCount"] = this.relatedPlanCount;
        data["id"] = this.id;
        return data; 
    }

    clone(): DatasetDto {
        const json = this.toJSON();
        let result = new DatasetDto();
        result.init(json);
        return result;
    }
}

export interface IDatasetDto {
    name: string | undefined;
    platomUserId: string | undefined;
    relatedLocationCount: number | undefined;
    relatedPlanCount: number | undefined;
    id: number | undefined;
}

export class CreateDatasetDto implements ICreateDatasetDto {
    name: string;
    platomUserId: string | undefined;
    base64: string | undefined;
    vehicleMapId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateDatasetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.platomUserId = _data["platomUserId"];
            this.base64 = _data["base64"];
            this.vehicleMapId = _data["vehicleMapId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateDatasetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDatasetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["platomUserId"] = this.platomUserId;
        data["base64"] = this.base64;
        data["vehicleMapId"] = this.vehicleMapId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateDatasetDto {
        const json = this.toJSON();
        let result = new CreateDatasetDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDatasetDto {
    name: string;
    platomUserId: string | undefined;
    base64: string | undefined;
    vehicleMapId: number | undefined;
    id: number | undefined;
}

export class VehicleMapDto implements IVehicleMapDto {
    vehicleMapId: number | undefined;
    vehicleId: number | undefined;
    mapId: number | undefined;
    isOpenEurasianTunnel: boolean | undefined;
    isOpenBogaziciBridge: boolean | undefined;
    isOpenFsmBridge: boolean | undefined;
    isOpenYssBridge: boolean | undefined;
    isOpenOsmangaziBridge: boolean | undefined;

    constructor(data?: IVehicleMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleMapId = _data["vehicleMapId"];
            this.vehicleId = _data["vehicleId"];
            this.mapId = _data["mapId"];
            this.isOpenEurasianTunnel = _data["isOpenEurasianTunnel"];
            this.isOpenBogaziciBridge = _data["isOpenBogaziciBridge"];
            this.isOpenFsmBridge = _data["isOpenFsmBridge"];
            this.isOpenYssBridge = _data["isOpenYssBridge"];
            this.isOpenOsmangaziBridge = _data["isOpenOsmangaziBridge"];
        }
    }

    static fromJS(data: any): VehicleMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleMapId"] = this.vehicleMapId;
        data["vehicleId"] = this.vehicleId;
        data["mapId"] = this.mapId;
        data["isOpenEurasianTunnel"] = this.isOpenEurasianTunnel;
        data["isOpenBogaziciBridge"] = this.isOpenBogaziciBridge;
        data["isOpenFsmBridge"] = this.isOpenFsmBridge;
        data["isOpenYssBridge"] = this.isOpenYssBridge;
        data["isOpenOsmangaziBridge"] = this.isOpenOsmangaziBridge;
        return data; 
    }

    clone(): VehicleMapDto {
        const json = this.toJSON();
        let result = new VehicleMapDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleMapDto {
    vehicleMapId: number | undefined;
    vehicleId: number | undefined;
    mapId: number | undefined;
    isOpenEurasianTunnel: boolean | undefined;
    isOpenBogaziciBridge: boolean | undefined;
    isOpenFsmBridge: boolean | undefined;
    isOpenYssBridge: boolean | undefined;
    isOpenOsmangaziBridge: boolean | undefined;
}

export class PagedResultDtoOfDeliveryConfirmDto implements IPagedResultDtoOfDeliveryConfirmDto {
    totalCount: number | undefined;
    items: DeliveryConfirmDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDeliveryConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DeliveryConfirmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDeliveryConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDeliveryConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfDeliveryConfirmDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDeliveryConfirmDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDeliveryConfirmDto {
    totalCount: number | undefined;
    items: DeliveryConfirmDto[] | undefined;
}

export class DeliveryConfirmDto implements IDeliveryConfirmDto {
    id: number | undefined;
    name: string | undefined;
    rowGuid: string | undefined;
    cariHareketId: number | undefined;
    cariHareketGuid: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    targetAddressName: string | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    shipmentDate: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;

    constructor(data?: IDeliveryConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rowGuid = _data["rowGuid"];
            this.cariHareketId = _data["cariHareketId"];
            this.cariHareketGuid = _data["cariHareketGuid"];
            this.productId = _data["productId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.requestOwnerName = _data["requestOwnerName"];
            this.targetAddressId = _data["targetAddressId"];
            this.targetAddressName = _data["targetAddressName"];
            this.approverName = _data["approverName"];
            this.approverMail = _data["approverMail"];
            this.approveStatus = _data["approveStatus"];
            this.productQuantity = _data["productQuantity"];
            this.shipmentDate = _data["shipmentDate"] ? moment(_data["shipmentDate"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeliveryConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rowGuid"] = this.rowGuid;
        data["cariHareketId"] = this.cariHareketId;
        data["cariHareketGuid"] = this.cariHareketGuid;
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["requestOwnerName"] = this.requestOwnerName;
        data["targetAddressId"] = this.targetAddressId;
        data["targetAddressName"] = this.targetAddressName;
        data["approverName"] = this.approverName;
        data["approverMail"] = this.approverMail;
        data["approveStatus"] = this.approveStatus;
        data["productQuantity"] = this.productQuantity;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }

    clone(): DeliveryConfirmDto {
        const json = this.toJSON();
        let result = new DeliveryConfirmDto();
        result.init(json);
        return result;
    }
}

export interface IDeliveryConfirmDto {
    id: number | undefined;
    name: string | undefined;
    rowGuid: string | undefined;
    cariHareketId: number | undefined;
    cariHareketGuid: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    targetAddressName: string | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    shipmentDate: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
}

export class CreateDeliveryConfirmDto implements ICreateDeliveryConfirmDto {
    name: string | undefined;
    cariHareketId: number | undefined;
    productId: number | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;

    constructor(data?: ICreateDeliveryConfirmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cariHareketId = _data["cariHareketId"];
            this.productId = _data["productId"];
            this.requestOwnerName = _data["requestOwnerName"];
            this.targetAddressId = _data["targetAddressId"];
            this.approverName = _data["approverName"];
            this.approverMail = _data["approverMail"];
            this.approveStatus = _data["approveStatus"];
            this.productQuantity = _data["productQuantity"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
        }
    }

    static fromJS(data: any): CreateDeliveryConfirmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDeliveryConfirmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cariHareketId"] = this.cariHareketId;
        data["productId"] = this.productId;
        data["requestOwnerName"] = this.requestOwnerName;
        data["targetAddressId"] = this.targetAddressId;
        data["approverName"] = this.approverName;
        data["approverMail"] = this.approverMail;
        data["approveStatus"] = this.approveStatus;
        data["productQuantity"] = this.productQuantity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        return data; 
    }

    clone(): CreateDeliveryConfirmDto {
        const json = this.toJSON();
        let result = new CreateDeliveryConfirmDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDeliveryConfirmDto {
    name: string | undefined;
    cariHareketId: number | undefined;
    productId: number | undefined;
    requestOwnerName: string | undefined;
    targetAddressId: number | undefined;
    approverName: string | undefined;
    approverMail: string | undefined;
    approveStatus: string | undefined;
    productQuantity: number | undefined;
    creationTime: moment.Moment | undefined;
    creatorUserId: number | undefined;
}

export class ApprovedQuantityDataInputDto implements IApprovedQuantityDataInputDto {
    rowGuid: string | undefined;
    approvedQuantity: number | undefined;

    constructor(data?: IApprovedQuantityDataInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowGuid = _data["rowGuid"];
            this.approvedQuantity = _data["approvedQuantity"];
        }
    }

    static fromJS(data: any): ApprovedQuantityDataInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovedQuantityDataInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowGuid"] = this.rowGuid;
        data["approvedQuantity"] = this.approvedQuantity;
        return data; 
    }

    clone(): ApprovedQuantityDataInputDto {
        const json = this.toJSON();
        let result = new ApprovedQuantityDataInputDto();
        result.init(json);
        return result;
    }
}

export interface IApprovedQuantityDataInputDto {
    rowGuid: string | undefined;
    approvedQuantity: number | undefined;
}

export class SRGMapsAddressConverterExcelUploadDto implements ISRGMapsAddressConverterExcelUploadDto {
    name: string | undefined;
    base64: string | undefined;

    constructor(data?: ISRGMapsAddressConverterExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): SRGMapsAddressConverterExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRGMapsAddressConverterExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["base64"] = this.base64;
        return data; 
    }

    clone(): SRGMapsAddressConverterExcelUploadDto {
        const json = this.toJSON();
        let result = new SRGMapsAddressConverterExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRGMapsAddressConverterExcelUploadDto {
    name: string | undefined;
    base64: string | undefined;
}

export class SRLocationViewerExcelUploadDto implements ISRLocationViewerExcelUploadDto {
    base64: string | undefined;

    constructor(data?: ISRLocationViewerExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): SRLocationViewerExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRLocationViewerExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data; 
    }

    clone(): SRLocationViewerExcelUploadDto {
        const json = this.toJSON();
        let result = new SRLocationViewerExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRLocationViewerExcelUploadDto {
    base64: string | undefined;
}

export class SRLocationViewerUploadDto implements ISRLocationViewerUploadDto {
    name: string | undefined;
    rowCount: number | undefined;
    hasExcelCellError: boolean | undefined;
    lat: number | undefined;
    lng: number | undefined;

    constructor(data?: ISRLocationViewerUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rowCount = _data["rowCount"];
            this.hasExcelCellError = _data["hasExcelCellError"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): SRLocationViewerUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRLocationViewerUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rowCount"] = this.rowCount;
        data["hasExcelCellError"] = this.hasExcelCellError;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data; 
    }

    clone(): SRLocationViewerUploadDto {
        const json = this.toJSON();
        let result = new SRLocationViewerUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRLocationViewerUploadDto {
    name: string | undefined;
    rowCount: number | undefined;
    hasExcelCellError: boolean | undefined;
    lat: number | undefined;
    lng: number | undefined;
}

export class SRGmapsPolygon implements ISRGmapsPolygon {
    lat: number | undefined;
    lng: number | undefined;

    constructor(data?: ISRGmapsPolygon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): SRGmapsPolygon {
        data = typeof data === 'object' ? data : {};
        let result = new SRGmapsPolygon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data; 
    }

    clone(): SRGmapsPolygon {
        const json = this.toJSON();
        let result = new SRGmapsPolygon();
        result.init(json);
        return result;
    }
}

export interface ISRGmapsPolygon {
    lat: number | undefined;
    lng: number | undefined;
}

export class CreateMasrafDto implements ICreateMasrafDto {
    personelLogoRefNo: number;
    masrafDonemi: string;
    aciklama: string;
    masrafTipi: CreateMasrafDtoMasrafTipi;
    masrafKalemList: MasrafKalemDto[] | undefined;

    constructor(data?: ICreateMasrafDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personelLogoRefNo = _data["personelLogoRefNo"];
            this.masrafDonemi = _data["masrafDonemi"];
            this.aciklama = _data["aciklama"];
            this.masrafTipi = _data["masrafTipi"];
            if (Array.isArray(_data["masrafKalemList"])) {
                this.masrafKalemList = [] as any;
                for (let item of _data["masrafKalemList"])
                    this.masrafKalemList.push(MasrafKalemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMasrafDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMasrafDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personelLogoRefNo"] = this.personelLogoRefNo;
        data["masrafDonemi"] = this.masrafDonemi;
        data["aciklama"] = this.aciklama;
        data["masrafTipi"] = this.masrafTipi;
        if (Array.isArray(this.masrafKalemList)) {
            data["masrafKalemList"] = [];
            for (let item of this.masrafKalemList)
                data["masrafKalemList"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreateMasrafDto {
        const json = this.toJSON();
        let result = new CreateMasrafDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMasrafDto {
    personelLogoRefNo: number;
    masrafDonemi: string;
    aciklama: string;
    masrafTipi: CreateMasrafDtoMasrafTipi;
    masrafKalemList: MasrafKalemDto[] | undefined;
}

export class MasrafKalemDto implements IMasrafKalemDto {
    fisTarihi: moment.Moment;
    fisNo: string;
    tutar: number;
    kdvOrani: MasrafKalemDtoKdvOrani;
    masrafAciklama: string;
    masrafKetegoriId: string;
    tutar2: number;

    constructor(data?: IMasrafKalemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fisTarihi = _data["fisTarihi"] ? moment(_data["fisTarihi"].toString()) : <any>undefined;
            this.fisNo = _data["fisNo"];
            this.tutar = _data["tutar"];
            this.kdvOrani = _data["kdvOrani"];
            this.masrafAciklama = _data["masrafAciklama"];
            this.masrafKetegoriId = _data["masrafKetegoriId"];
            this.tutar2 = _data["tutar2"];
        }
    }

    static fromJS(data: any): MasrafKalemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasrafKalemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fisTarihi"] = this.fisTarihi ? this.fisTarihi.toISOString() : <any>undefined;
        data["fisNo"] = this.fisNo;
        data["tutar"] = this.tutar;
        data["kdvOrani"] = this.kdvOrani;
        data["masrafAciklama"] = this.masrafAciklama;
        data["masrafKetegoriId"] = this.masrafKetegoriId;
        data["tutar2"] = this.tutar2;
        return data; 
    }

    clone(): MasrafKalemDto {
        const json = this.toJSON();
        let result = new MasrafKalemDto();
        result.init(json);
        return result;
    }
}

export interface IMasrafKalemDto {
    fisTarihi: moment.Moment;
    fisNo: string;
    tutar: number;
    kdvOrani: MasrafKalemDtoKdvOrani;
    masrafAciklama: string;
    masrafKetegoriId: string;
    tutar2: number;
}

export class CreateSatinalmaTalepDto implements ICreateSatinalmaTalepDto {
    satinalmaKonusu: string;
    satinalmaTipi: CreateSatinalmaTalepDtoSatinalmaTipi;
    tutar: number;
    paraBirimi: CreateSatinalmaTalepDtoParaBirimi;
    vade: CreateSatinalmaTalepDtoVade;
    logoCariKod: string;

    constructor(data?: ICreateSatinalmaTalepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.satinalmaKonusu = _data["satinalmaKonusu"];
            this.satinalmaTipi = _data["satinalmaTipi"];
            this.tutar = _data["tutar"];
            this.paraBirimi = _data["paraBirimi"];
            this.vade = _data["vade"];
            this.logoCariKod = _data["logoCariKod"];
        }
    }

    static fromJS(data: any): CreateSatinalmaTalepDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSatinalmaTalepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["satinalmaKonusu"] = this.satinalmaKonusu;
        data["satinalmaTipi"] = this.satinalmaTipi;
        data["tutar"] = this.tutar;
        data["paraBirimi"] = this.paraBirimi;
        data["vade"] = this.vade;
        data["logoCariKod"] = this.logoCariKod;
        return data; 
    }

    clone(): CreateSatinalmaTalepDto {
        const json = this.toJSON();
        let result = new CreateSatinalmaTalepDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSatinalmaTalepDto {
    satinalmaKonusu: string;
    satinalmaTipi: CreateSatinalmaTalepDtoSatinalmaTipi;
    tutar: number;
    paraBirimi: CreateSatinalmaTalepDtoParaBirimi;
    vade: CreateSatinalmaTalepDtoVade;
    logoCariKod: string;
}

export class SatinalmaTalepFaturaBilgiDto implements ISatinalmaTalepFaturaBilgiDto {
    talepNo: string | undefined;
    olusturulmaTarihi: moment.Moment | undefined;
    talepDurum: SatinalmaTalepFaturaBilgiDtoTalepDurum | undefined;
    faturaDonemi: string | undefined;

    constructor(data?: ISatinalmaTalepFaturaBilgiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.talepNo = _data["talepNo"];
            this.olusturulmaTarihi = _data["olusturulmaTarihi"] ? moment(_data["olusturulmaTarihi"].toString()) : <any>undefined;
            this.talepDurum = _data["talepDurum"];
            this.faturaDonemi = _data["faturaDonemi"];
        }
    }

    static fromJS(data: any): SatinalmaTalepFaturaBilgiDto {
        data = typeof data === 'object' ? data : {};
        let result = new SatinalmaTalepFaturaBilgiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["talepNo"] = this.talepNo;
        data["olusturulmaTarihi"] = this.olusturulmaTarihi ? this.olusturulmaTarihi.toISOString() : <any>undefined;
        data["talepDurum"] = this.talepDurum;
        data["faturaDonemi"] = this.faturaDonemi;
        return data; 
    }

    clone(): SatinalmaTalepFaturaBilgiDto {
        const json = this.toJSON();
        let result = new SatinalmaTalepFaturaBilgiDto();
        result.init(json);
        return result;
    }
}

export interface ISatinalmaTalepFaturaBilgiDto {
    talepNo: string | undefined;
    olusturulmaTarihi: moment.Moment | undefined;
    talepDurum: SatinalmaTalepFaturaBilgiDtoTalepDurum | undefined;
    faturaDonemi: string | undefined;
}

export class ReportObjectDto implements IReportObjectDto {
    id: number | undefined;
    moduleId: number | undefined;
    metabaseDashboardId: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    filters: ReportFilterDto[] | undefined;
    isOpenNewScreen: boolean | undefined;
    isShowPhotoDownloadButton: boolean | undefined;
    photoDownloadDataSource: number | undefined;

    constructor(data?: IReportObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moduleId = _data["moduleId"];
            this.metabaseDashboardId = _data["metabaseDashboardId"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters.push(ReportFilterDto.fromJS(item));
            }
            this.isOpenNewScreen = _data["isOpenNewScreen"];
            this.isShowPhotoDownloadButton = _data["isShowPhotoDownloadButton"];
            this.photoDownloadDataSource = _data["photoDownloadDataSource"];
        }
    }

    static fromJS(data: any): ReportObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moduleId"] = this.moduleId;
        data["metabaseDashboardId"] = this.metabaseDashboardId;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        data["isShowPhotoDownloadButton"] = this.isShowPhotoDownloadButton;
        data["photoDownloadDataSource"] = this.photoDownloadDataSource;
        return data; 
    }

    clone(): ReportObjectDto {
        const json = this.toJSON();
        let result = new ReportObjectDto();
        result.init(json);
        return result;
    }
}

export interface IReportObjectDto {
    id: number | undefined;
    moduleId: number | undefined;
    metabaseDashboardId: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    filters: ReportFilterDto[] | undefined;
    isOpenNewScreen: boolean | undefined;
    isShowPhotoDownloadButton: boolean | undefined;
    photoDownloadDataSource: number | undefined;
}

export class ReportFilterDto implements IReportFilterDto {
    title: string | undefined;
    placeholder: string | undefined;
    type: string | undefined;
    dateRangeControlNames: string[] | undefined;
    isMultiple: boolean | undefined;
    isRequired: boolean | undefined;
    datasource: number | undefined;
    dataSourceConditions: ReportFilterConditionDto[] | undefined;
    paramKey: string | undefined;
    paramValues: string[] | undefined;
    paramValue: string | undefined;
    colSize: number | undefined;
    data: DataItemDto[] | undefined;

    constructor(data?: IReportFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.placeholder = _data["placeholder"];
            this.type = _data["type"];
            if (Array.isArray(_data["dateRangeControlNames"])) {
                this.dateRangeControlNames = [] as any;
                for (let item of _data["dateRangeControlNames"])
                    this.dateRangeControlNames.push(item);
            }
            this.isMultiple = _data["isMultiple"];
            this.isRequired = _data["isRequired"];
            this.datasource = _data["datasource"];
            if (Array.isArray(_data["dataSourceConditions"])) {
                this.dataSourceConditions = [] as any;
                for (let item of _data["dataSourceConditions"])
                    this.dataSourceConditions.push(ReportFilterConditionDto.fromJS(item));
            }
            this.paramKey = _data["paramKey"];
            if (Array.isArray(_data["paramValues"])) {
                this.paramValues = [] as any;
                for (let item of _data["paramValues"])
                    this.paramValues.push(item);
            }
            this.paramValue = _data["paramValue"];
            this.colSize = _data["colSize"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(DataItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["placeholder"] = this.placeholder;
        data["type"] = this.type;
        if (Array.isArray(this.dateRangeControlNames)) {
            data["dateRangeControlNames"] = [];
            for (let item of this.dateRangeControlNames)
                data["dateRangeControlNames"].push(item);
        }
        data["isMultiple"] = this.isMultiple;
        data["isRequired"] = this.isRequired;
        data["datasource"] = this.datasource;
        if (Array.isArray(this.dataSourceConditions)) {
            data["dataSourceConditions"] = [];
            for (let item of this.dataSourceConditions)
                data["dataSourceConditions"].push(item.toJSON());
        }
        data["paramKey"] = this.paramKey;
        if (Array.isArray(this.paramValues)) {
            data["paramValues"] = [];
            for (let item of this.paramValues)
                data["paramValues"].push(item);
        }
        data["paramValue"] = this.paramValue;
        data["colSize"] = this.colSize;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ReportFilterDto {
        const json = this.toJSON();
        let result = new ReportFilterDto();
        result.init(json);
        return result;
    }
}

export interface IReportFilterDto {
    title: string | undefined;
    placeholder: string | undefined;
    type: string | undefined;
    dateRangeControlNames: string[] | undefined;
    isMultiple: boolean | undefined;
    isRequired: boolean | undefined;
    datasource: number | undefined;
    dataSourceConditions: ReportFilterConditionDto[] | undefined;
    paramKey: string | undefined;
    paramValues: string[] | undefined;
    paramValue: string | undefined;
    colSize: number | undefined;
    data: DataItemDto[] | undefined;
}

export class ReportFilterConditionDto implements IReportFilterConditionDto {
    conditionParamName: string | undefined;
    values: any[] | undefined;

    constructor(data?: IReportFilterConditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conditionParamName = _data["conditionParamName"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(item);
            }
        }
    }

    static fromJS(data: any): ReportFilterConditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportFilterConditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conditionParamName"] = this.conditionParamName;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data; 
    }

    clone(): ReportFilterConditionDto {
        const json = this.toJSON();
        let result = new ReportFilterConditionDto();
        result.init(json);
        return result;
    }
}

export interface IReportFilterConditionDto {
    conditionParamName: string | undefined;
    values: any[] | undefined;
}

export class DataItemDto implements IDataItemDto {
    text: string | undefined;
    value: any | undefined;

    constructor(data?: IDataItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DataItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data; 
    }

    clone(): DataItemDto {
        const json = this.toJSON();
        let result = new DataItemDto();
        result.init(json);
        return result;
    }
}

export interface IDataItemDto {
    text: string | undefined;
    value: any | undefined;
}

export class ReportDataSourceDto implements IReportDataSourceDto {
    id: number | undefined;
    sqlQuery: string | undefined;
    dbModule: ReportDataSourceDtoDbModule | undefined;

    constructor(data?: IReportDataSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sqlQuery = _data["sqlQuery"];
            this.dbModule = _data["dbModule"];
        }
    }

    static fromJS(data: any): ReportDataSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDataSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sqlQuery"] = this.sqlQuery;
        data["dbModule"] = this.dbModule;
        return data; 
    }

    clone(): ReportDataSourceDto {
        const json = this.toJSON();
        let result = new ReportDataSourceDto();
        result.init(json);
        return result;
    }
}

export interface IReportDataSourceDto {
    id: number | undefined;
    sqlQuery: string | undefined;
    dbModule: ReportDataSourceDtoDbModule | undefined;
}

export class MetabaseDashboardOutputDto implements IMetabaseDashboardOutputDto {
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;

    constructor(data?: IMetabaseDashboardOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
        }
    }

    static fromJS(data: any): MetabaseDashboardOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseDashboardOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        return data; 
    }

    clone(): MetabaseDashboardOutputDto {
        const json = this.toJSON();
        let result = new MetabaseDashboardOutputDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseDashboardOutputDto {
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;
}

export class WarehouseSelectListDto implements IWarehouseSelectListDto {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    addressId: number | undefined;
    isSelected: boolean | undefined;

    constructor(data?: IWarehouseSelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.addressId = _data["addressId"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): WarehouseSelectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseSelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["addressId"] = this.addressId;
        data["isSelected"] = this.isSelected;
        return data; 
    }

    clone(): WarehouseSelectListDto {
        const json = this.toJSON();
        let result = new WarehouseSelectListDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseSelectListDto {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    addressId: number | undefined;
    isSelected: boolean | undefined;
}

export class MetabaseFilterItemDto implements IMetabaseFilterItemDto {
    text: string | undefined;
    value: string | undefined;

    constructor(data?: IMetabaseFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetabaseFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data; 
    }

    clone(): MetabaseFilterItemDto {
        const json = this.toJSON();
        let result = new MetabaseFilterItemDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseFilterItemDto {
    text: string | undefined;
    value: string | undefined;
}

export class MetabaseTranspopPortalFilterUserBusinessUnitDto implements IMetabaseTranspopPortalFilterUserBusinessUnitDto {
    attributeType: string | undefined;
    productAttributeId: number | undefined;

    constructor(data?: IMetabaseTranspopPortalFilterUserBusinessUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"];
            this.productAttributeId = _data["productAttributeId"];
        }
    }

    static fromJS(data: any): MetabaseTranspopPortalFilterUserBusinessUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseTranspopPortalFilterUserBusinessUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["productAttributeId"] = this.productAttributeId;
        return data; 
    }

    clone(): MetabaseTranspopPortalFilterUserBusinessUnitDto {
        const json = this.toJSON();
        let result = new MetabaseTranspopPortalFilterUserBusinessUnitDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseTranspopPortalFilterUserBusinessUnitDto {
    attributeType: string | undefined;
    productAttributeId: number | undefined;
}

export class MetabaseTranspopPortalFilterBrandDto implements IMetabaseTranspopPortalFilterBrandDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IMetabaseTranspopPortalFilterBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MetabaseTranspopPortalFilterBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseTranspopPortalFilterBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): MetabaseTranspopPortalFilterBrandDto {
        const json = this.toJSON();
        let result = new MetabaseTranspopPortalFilterBrandDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseTranspopPortalFilterBrandDto {
    id: number | undefined;
    name: string | undefined;
}

export class MetabaseTranspopFilterItemDto implements IMetabaseTranspopFilterItemDto {
    text: string | undefined;
    value: string | undefined;

    constructor(data?: IMetabaseTranspopFilterItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): MetabaseTranspopFilterItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseTranspopFilterItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data; 
    }

    clone(): MetabaseTranspopFilterItemDto {
        const json = this.toJSON();
        let result = new MetabaseTranspopFilterItemDto();
        result.init(json);
        return result;
    }
}

export interface IMetabaseTranspopFilterItemDto {
    text: string | undefined;
    value: string | undefined;
}

export class TranspopPortalReportResultDto implements ITranspopPortalReportResultDto {
    hasOverLimit: boolean | undefined;
    overLimitMessage: string | undefined;
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;

    constructor(data?: ITranspopPortalReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasOverLimit = _data["hasOverLimit"];
            this.overLimitMessage = _data["overLimitMessage"];
            this.url = _data["url"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
        }
    }

    static fromJS(data: any): TranspopPortalReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranspopPortalReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasOverLimit"] = this.hasOverLimit;
        data["overLimitMessage"] = this.overLimitMessage;
        data["url"] = this.url;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        return data; 
    }

    clone(): TranspopPortalReportResultDto {
        const json = this.toJSON();
        let result = new TranspopPortalReportResultDto();
        result.init(json);
        return result;
    }
}

export interface ITranspopPortalReportResultDto {
    hasOverLimit: boolean | undefined;
    overLimitMessage: string | undefined;
    url: string | undefined;
    isOpenNewScreen: boolean | undefined;
}

export class TranspopPortalReportParamsFiltersInput implements ITranspopPortalReportParamsFiltersInput {
    warehouseid: string[] | undefined;
    productid: string[] | undefined;
    distributornames: string[] | undefined;
    hasar_durumu: string[] | undefined;
    hareket_tipi: string[] | undefined;
    onay_durumu: string[] | undefined;
    son_hareket_tarihi: string | undefined;
    skt: string | undefined;
    posm: string[] | undefined;
    posm_tipi: string[] | undefined;
    ay: string | undefined;
    posm_magazada_mi: string[] | undefined;
    searchKeyword: string | undefined;
    daterange: string | undefined;
    userid: number | undefined;
    customerid: number | undefined;
    customercode: string | undefined;
    isbirimiid: number | undefined;
    isbirimiids: number[] | undefined;
    markaid: number[] | undefined;
    malzemetipi: string[] | undefined;
    lansman: string[] | undefined;
    koordinator: string[] | undefined;
    kanal: string[] | undefined;
    tarih: string | undefined;
    supervisor: string[] | undefined;
    bolge_yoneticisi: string[] | undefined;
    firma_sorumlusu: string[] | undefined;
    pop_durumu: string[] | undefined;
    islem_tipi: string[] | undefined;

    constructor(data?: ITranspopPortalReportParamsFiltersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["warehouseid"])) {
                this.warehouseid = [] as any;
                for (let item of _data["warehouseid"])
                    this.warehouseid.push(item);
            }
            if (Array.isArray(_data["productid"])) {
                this.productid = [] as any;
                for (let item of _data["productid"])
                    this.productid.push(item);
            }
            if (Array.isArray(_data["distributornames"])) {
                this.distributornames = [] as any;
                for (let item of _data["distributornames"])
                    this.distributornames.push(item);
            }
            if (Array.isArray(_data["hasar_durumu"])) {
                this.hasar_durumu = [] as any;
                for (let item of _data["hasar_durumu"])
                    this.hasar_durumu.push(item);
            }
            if (Array.isArray(_data["hareket_tipi"])) {
                this.hareket_tipi = [] as any;
                for (let item of _data["hareket_tipi"])
                    this.hareket_tipi.push(item);
            }
            if (Array.isArray(_data["onay_durumu"])) {
                this.onay_durumu = [] as any;
                for (let item of _data["onay_durumu"])
                    this.onay_durumu.push(item);
            }
            this.son_hareket_tarihi = _data["son_hareket_tarihi"];
            this.skt = _data["skt"];
            if (Array.isArray(_data["posm"])) {
                this.posm = [] as any;
                for (let item of _data["posm"])
                    this.posm.push(item);
            }
            if (Array.isArray(_data["posm_tipi"])) {
                this.posm_tipi = [] as any;
                for (let item of _data["posm_tipi"])
                    this.posm_tipi.push(item);
            }
            this.ay = _data["ay"];
            if (Array.isArray(_data["posm_magazada_mi"])) {
                this.posm_magazada_mi = [] as any;
                for (let item of _data["posm_magazada_mi"])
                    this.posm_magazada_mi.push(item);
            }
            this.searchKeyword = _data["searchKeyword"];
            this.daterange = _data["daterange"];
            this.userid = _data["userid"];
            this.customerid = _data["customerid"];
            this.customercode = _data["customercode"];
            this.isbirimiid = _data["isbirimiid"];
            if (Array.isArray(_data["isbirimiids"])) {
                this.isbirimiids = [] as any;
                for (let item of _data["isbirimiids"])
                    this.isbirimiids.push(item);
            }
            if (Array.isArray(_data["markaid"])) {
                this.markaid = [] as any;
                for (let item of _data["markaid"])
                    this.markaid.push(item);
            }
            if (Array.isArray(_data["malzemetipi"])) {
                this.malzemetipi = [] as any;
                for (let item of _data["malzemetipi"])
                    this.malzemetipi.push(item);
            }
            if (Array.isArray(_data["lansman"])) {
                this.lansman = [] as any;
                for (let item of _data["lansman"])
                    this.lansman.push(item);
            }
            if (Array.isArray(_data["koordinator"])) {
                this.koordinator = [] as any;
                for (let item of _data["koordinator"])
                    this.koordinator.push(item);
            }
            if (Array.isArray(_data["kanal"])) {
                this.kanal = [] as any;
                for (let item of _data["kanal"])
                    this.kanal.push(item);
            }
            this.tarih = _data["tarih"];
            if (Array.isArray(_data["supervisor"])) {
                this.supervisor = [] as any;
                for (let item of _data["supervisor"])
                    this.supervisor.push(item);
            }
            if (Array.isArray(_data["bolge_yoneticisi"])) {
                this.bolge_yoneticisi = [] as any;
                for (let item of _data["bolge_yoneticisi"])
                    this.bolge_yoneticisi.push(item);
            }
            if (Array.isArray(_data["firma_sorumlusu"])) {
                this.firma_sorumlusu = [] as any;
                for (let item of _data["firma_sorumlusu"])
                    this.firma_sorumlusu.push(item);
            }
            if (Array.isArray(_data["pop_durumu"])) {
                this.pop_durumu = [] as any;
                for (let item of _data["pop_durumu"])
                    this.pop_durumu.push(item);
            }
            if (Array.isArray(_data["islem_tipi"])) {
                this.islem_tipi = [] as any;
                for (let item of _data["islem_tipi"])
                    this.islem_tipi.push(item);
            }
        }
    }

    static fromJS(data: any): TranspopPortalReportParamsFiltersInput {
        data = typeof data === 'object' ? data : {};
        let result = new TranspopPortalReportParamsFiltersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.warehouseid)) {
            data["warehouseid"] = [];
            for (let item of this.warehouseid)
                data["warehouseid"].push(item);
        }
        if (Array.isArray(this.productid)) {
            data["productid"] = [];
            for (let item of this.productid)
                data["productid"].push(item);
        }
        if (Array.isArray(this.distributornames)) {
            data["distributornames"] = [];
            for (let item of this.distributornames)
                data["distributornames"].push(item);
        }
        if (Array.isArray(this.hasar_durumu)) {
            data["hasar_durumu"] = [];
            for (let item of this.hasar_durumu)
                data["hasar_durumu"].push(item);
        }
        if (Array.isArray(this.hareket_tipi)) {
            data["hareket_tipi"] = [];
            for (let item of this.hareket_tipi)
                data["hareket_tipi"].push(item);
        }
        if (Array.isArray(this.onay_durumu)) {
            data["onay_durumu"] = [];
            for (let item of this.onay_durumu)
                data["onay_durumu"].push(item);
        }
        data["son_hareket_tarihi"] = this.son_hareket_tarihi;
        data["skt"] = this.skt;
        if (Array.isArray(this.posm)) {
            data["posm"] = [];
            for (let item of this.posm)
                data["posm"].push(item);
        }
        if (Array.isArray(this.posm_tipi)) {
            data["posm_tipi"] = [];
            for (let item of this.posm_tipi)
                data["posm_tipi"].push(item);
        }
        data["ay"] = this.ay;
        if (Array.isArray(this.posm_magazada_mi)) {
            data["posm_magazada_mi"] = [];
            for (let item of this.posm_magazada_mi)
                data["posm_magazada_mi"].push(item);
        }
        data["searchKeyword"] = this.searchKeyword;
        data["daterange"] = this.daterange;
        data["userid"] = this.userid;
        data["customerid"] = this.customerid;
        data["customercode"] = this.customercode;
        data["isbirimiid"] = this.isbirimiid;
        if (Array.isArray(this.isbirimiids)) {
            data["isbirimiids"] = [];
            for (let item of this.isbirimiids)
                data["isbirimiids"].push(item);
        }
        if (Array.isArray(this.markaid)) {
            data["markaid"] = [];
            for (let item of this.markaid)
                data["markaid"].push(item);
        }
        if (Array.isArray(this.malzemetipi)) {
            data["malzemetipi"] = [];
            for (let item of this.malzemetipi)
                data["malzemetipi"].push(item);
        }
        if (Array.isArray(this.lansman)) {
            data["lansman"] = [];
            for (let item of this.lansman)
                data["lansman"].push(item);
        }
        if (Array.isArray(this.koordinator)) {
            data["koordinator"] = [];
            for (let item of this.koordinator)
                data["koordinator"].push(item);
        }
        if (Array.isArray(this.kanal)) {
            data["kanal"] = [];
            for (let item of this.kanal)
                data["kanal"].push(item);
        }
        data["tarih"] = this.tarih;
        if (Array.isArray(this.supervisor)) {
            data["supervisor"] = [];
            for (let item of this.supervisor)
                data["supervisor"].push(item);
        }
        if (Array.isArray(this.bolge_yoneticisi)) {
            data["bolge_yoneticisi"] = [];
            for (let item of this.bolge_yoneticisi)
                data["bolge_yoneticisi"].push(item);
        }
        if (Array.isArray(this.firma_sorumlusu)) {
            data["firma_sorumlusu"] = [];
            for (let item of this.firma_sorumlusu)
                data["firma_sorumlusu"].push(item);
        }
        if (Array.isArray(this.pop_durumu)) {
            data["pop_durumu"] = [];
            for (let item of this.pop_durumu)
                data["pop_durumu"].push(item);
        }
        if (Array.isArray(this.islem_tipi)) {
            data["islem_tipi"] = [];
            for (let item of this.islem_tipi)
                data["islem_tipi"].push(item);
        }
        return data; 
    }

    clone(): TranspopPortalReportParamsFiltersInput {
        const json = this.toJSON();
        let result = new TranspopPortalReportParamsFiltersInput();
        result.init(json);
        return result;
    }
}

export interface ITranspopPortalReportParamsFiltersInput {
    warehouseid: string[] | undefined;
    productid: string[] | undefined;
    distributornames: string[] | undefined;
    hasar_durumu: string[] | undefined;
    hareket_tipi: string[] | undefined;
    onay_durumu: string[] | undefined;
    son_hareket_tarihi: string | undefined;
    skt: string | undefined;
    posm: string[] | undefined;
    posm_tipi: string[] | undefined;
    ay: string | undefined;
    posm_magazada_mi: string[] | undefined;
    searchKeyword: string | undefined;
    daterange: string | undefined;
    userid: number | undefined;
    customerid: number | undefined;
    customercode: string | undefined;
    isbirimiid: number | undefined;
    isbirimiids: number[] | undefined;
    markaid: number[] | undefined;
    malzemetipi: string[] | undefined;
    lansman: string[] | undefined;
    koordinator: string[] | undefined;
    kanal: string[] | undefined;
    tarih: string | undefined;
    supervisor: string[] | undefined;
    bolge_yoneticisi: string[] | undefined;
    firma_sorumlusu: string[] | undefined;
    pop_durumu: string[] | undefined;
    islem_tipi: string[] | undefined;
}

export class ModuleDto implements IModuleDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: IModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ModuleDto {
        const json = this.toJSON();
        let result = new ModuleDto();
        result.init(json);
        return result;
    }
}

export interface IModuleDto {
    name: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfModuleDto implements IPagedResultDtoOfModuleDto {
    totalCount: number | undefined;
    items: ModuleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfModuleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfModuleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfModuleDto {
    totalCount: number | undefined;
    items: ModuleDto[] | undefined;
}

export class CreateModuleDto implements ICreateModuleDto {
    id: number | undefined;

    constructor(data?: ICreateModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateModuleDto {
        const json = this.toJSON();
        let result = new CreateModuleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateModuleDto {
    id: number | undefined;
}

export class CreateOrderDto implements ICreateOrderDto {
    userId: number | undefined;
    customerId: number | undefined;
    name: string | undefined;
    fromWarehouseId: number;
    fromWarehouseCode: string;
    fromAddressId: number;
    toAddressId: number | undefined;
    products: ProductDto[] | undefined;
    isOrderByVariation: boolean | undefined;
    componentType: CreateOrderDtoComponentType | undefined;
    shipmentType: CreateOrderDtoShipmentType | undefined;
    productDamageStatusType: CreateOrderDtoProductDamageStatusType | undefined;
    newAddressDto: OrderNewAddressDto | undefined;
    receiverName: string | undefined;
    receiverPhone: string | undefined;
    specialCode: string | undefined;
    comment: string | undefined;
    criticalSimilarAddressIdList: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.fromWarehouseId = _data["fromWarehouseId"];
            this.fromWarehouseCode = _data["fromWarehouseCode"];
            this.fromAddressId = _data["fromAddressId"];
            this.toAddressId = _data["toAddressId"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(ProductDto.fromJS(item));
            }
            this.isOrderByVariation = _data["isOrderByVariation"];
            this.componentType = _data["componentType"];
            this.shipmentType = _data["shipmentType"];
            this.productDamageStatusType = _data["productDamageStatusType"];
            this.newAddressDto = _data["newAddressDto"] ? OrderNewAddressDto.fromJS(_data["newAddressDto"]) : <any>undefined;
            this.receiverName = _data["receiverName"];
            this.receiverPhone = _data["receiverPhone"];
            this.specialCode = _data["specialCode"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["criticalSimilarAddressIdList"])) {
                this.criticalSimilarAddressIdList = [] as any;
                for (let item of _data["criticalSimilarAddressIdList"])
                    this.criticalSimilarAddressIdList.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["fromWarehouseId"] = this.fromWarehouseId;
        data["fromWarehouseCode"] = this.fromWarehouseCode;
        data["fromAddressId"] = this.fromAddressId;
        data["toAddressId"] = this.toAddressId;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["isOrderByVariation"] = this.isOrderByVariation;
        data["componentType"] = this.componentType;
        data["shipmentType"] = this.shipmentType;
        data["productDamageStatusType"] = this.productDamageStatusType;
        data["newAddressDto"] = this.newAddressDto ? this.newAddressDto.toJSON() : <any>undefined;
        data["receiverName"] = this.receiverName;
        data["receiverPhone"] = this.receiverPhone;
        data["specialCode"] = this.specialCode;
        data["comment"] = this.comment;
        if (Array.isArray(this.criticalSimilarAddressIdList)) {
            data["criticalSimilarAddressIdList"] = [];
            for (let item of this.criticalSimilarAddressIdList)
                data["criticalSimilarAddressIdList"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateOrderDto {
        const json = this.toJSON();
        let result = new CreateOrderDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderDto {
    userId: number | undefined;
    customerId: number | undefined;
    name: string | undefined;
    fromWarehouseId: number;
    fromWarehouseCode: string;
    fromAddressId: number;
    toAddressId: number | undefined;
    products: ProductDto[] | undefined;
    isOrderByVariation: boolean | undefined;
    componentType: CreateOrderDtoComponentType | undefined;
    shipmentType: CreateOrderDtoShipmentType | undefined;
    productDamageStatusType: CreateOrderDtoProductDamageStatusType | undefined;
    newAddressDto: OrderNewAddressDto | undefined;
    receiverName: string | undefined;
    receiverPhone: string | undefined;
    specialCode: string | undefined;
    comment: string | undefined;
    criticalSimilarAddressIdList: number[] | undefined;
    id: number | undefined;
}

export class ProductDto implements IProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    blokeStok: number | undefined;
    businessUnitName: string | undefined;
    boxQuantity: number | undefined;
    palletQuantity: number | undefined;
    deci: number | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    variationId: number | undefined;
    customerProductCode: string | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    lot: string | undefined;
    orderedQty: number | undefined;
    width: number | undefined;
    depth: number | undefined;
    height: number | undefined;
    weight: number | undefined;
    isInCart: boolean | undefined;
    subVariations: ProductSubVariationsDto[] | undefined;
    id: number | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kod = _data["kod"];
            this.wmsTip = _data["wmsTip"];
            this.marka = _data["marka"];
            this.stok = _data["stok"];
            this.blokeStok = _data["blokeStok"];
            this.businessUnitName = _data["businessUnitName"];
            this.boxQuantity = _data["boxQuantity"];
            this.palletQuantity = _data["palletQuantity"];
            this.deci = _data["deci"];
            this.type1Name = _data["type1Name"];
            this.type2Name = _data["type2Name"];
            this.type3Name = _data["type3Name"];
            this.type4Name = _data["type4Name"];
            this.variationId = _data["variationId"];
            this.customerProductCode = _data["customerProductCode"];
            this.expirationDate = _data["expirationDate"];
            this.barcode = _data["barcode"];
            this.lot = _data["lot"];
            this.orderedQty = _data["orderedQty"];
            this.width = _data["width"];
            this.depth = _data["depth"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.isInCart = _data["isInCart"];
            if (Array.isArray(_data["subVariations"])) {
                this.subVariations = [] as any;
                for (let item of _data["subVariations"])
                    this.subVariations.push(ProductSubVariationsDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kod"] = this.kod;
        data["wmsTip"] = this.wmsTip;
        data["marka"] = this.marka;
        data["stok"] = this.stok;
        data["blokeStok"] = this.blokeStok;
        data["businessUnitName"] = this.businessUnitName;
        data["boxQuantity"] = this.boxQuantity;
        data["palletQuantity"] = this.palletQuantity;
        data["deci"] = this.deci;
        data["type1Name"] = this.type1Name;
        data["type2Name"] = this.type2Name;
        data["type3Name"] = this.type3Name;
        data["type4Name"] = this.type4Name;
        data["variationId"] = this.variationId;
        data["customerProductCode"] = this.customerProductCode;
        data["expirationDate"] = this.expirationDate;
        data["barcode"] = this.barcode;
        data["lot"] = this.lot;
        data["orderedQty"] = this.orderedQty;
        data["width"] = this.width;
        data["depth"] = this.depth;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["isInCart"] = this.isInCart;
        if (Array.isArray(this.subVariations)) {
            data["subVariations"] = [];
            for (let item of this.subVariations)
                data["subVariations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

export interface IProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    blokeStok: number | undefined;
    businessUnitName: string | undefined;
    boxQuantity: number | undefined;
    palletQuantity: number | undefined;
    deci: number | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    variationId: number | undefined;
    customerProductCode: string | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    lot: string | undefined;
    orderedQty: number | undefined;
    width: number | undefined;
    depth: number | undefined;
    height: number | undefined;
    weight: number | undefined;
    isInCart: boolean | undefined;
    subVariations: ProductSubVariationsDto[] | undefined;
    id: number | undefined;
}

export class OrderNewAddressDto implements IOrderNewAddressDto {
    address: AddressDto | undefined;
    readonly isValidAddress: boolean | undefined;

    constructor(data?: IOrderNewAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            (<any>this).isValidAddress = _data["isValidAddress"];
        }
    }

    static fromJS(data: any): OrderNewAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderNewAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["isValidAddress"] = this.isValidAddress;
        return data; 
    }

    clone(): OrderNewAddressDto {
        const json = this.toJSON();
        let result = new OrderNewAddressDto();
        result.init(json);
        return result;
    }
}

export interface IOrderNewAddressDto {
    address: AddressDto | undefined;
    isValidAddress: boolean | undefined;
}

export class ProductSubVariationsDto implements IProductSubVariationsDto {
    variationId: number | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    stockQuantity: number | undefined;

    constructor(data?: IProductSubVariationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.variationId = _data["variationId"];
            this.expirationDate = _data["expirationDate"];
            this.barcode = _data["barcode"];
            this.stockQuantity = _data["stockQuantity"];
        }
    }

    static fromJS(data: any): ProductSubVariationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSubVariationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variationId"] = this.variationId;
        data["expirationDate"] = this.expirationDate;
        data["barcode"] = this.barcode;
        data["stockQuantity"] = this.stockQuantity;
        return data; 
    }

    clone(): ProductSubVariationsDto {
        const json = this.toJSON();
        let result = new ProductSubVariationsDto();
        result.init(json);
        return result;
    }
}

export interface IProductSubVariationsDto {
    variationId: number | undefined;
    expirationDate: string | undefined;
    barcode: string | undefined;
    stockQuantity: number | undefined;
}

export class OrderPriceDto implements IOrderPriceDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productDeci: number | undefined;
    orderQty: number | undefined;
    readonly totalDeci: number | undefined;
    deciShipmentPrice: number | undefined;
    readonly totalPrice: number | undefined;

    constructor(data?: IOrderPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.productDeci = _data["productDeci"];
            this.orderQty = _data["orderQty"];
            (<any>this).totalDeci = _data["totalDeci"];
            this.deciShipmentPrice = _data["deciShipmentPrice"];
            (<any>this).totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): OrderPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["productDeci"] = this.productDeci;
        data["orderQty"] = this.orderQty;
        data["totalDeci"] = this.totalDeci;
        data["deciShipmentPrice"] = this.deciShipmentPrice;
        data["totalPrice"] = this.totalPrice;
        return data; 
    }

    clone(): OrderPriceDto {
        const json = this.toJSON();
        let result = new OrderPriceDto();
        result.init(json);
        return result;
    }
}

export interface IOrderPriceDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productDeci: number | undefined;
    orderQty: number | undefined;
    totalDeci: number | undefined;
    deciShipmentPrice: number | undefined;
    totalPrice: number | undefined;
}

export class OrderStockResultDto implements IOrderStockResultDto {
    isValid: boolean | undefined;
    userFriendlyMessage: string | undefined;
    unStockProducts: OrderProductStockDto[] | undefined;
    orderedProducts: OrderProductStockDto[] | undefined;

    constructor(data?: IOrderStockResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.userFriendlyMessage = _data["userFriendlyMessage"];
            if (Array.isArray(_data["unStockProducts"])) {
                this.unStockProducts = [] as any;
                for (let item of _data["unStockProducts"])
                    this.unStockProducts.push(OrderProductStockDto.fromJS(item));
            }
            if (Array.isArray(_data["orderedProducts"])) {
                this.orderedProducts = [] as any;
                for (let item of _data["orderedProducts"])
                    this.orderedProducts.push(OrderProductStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderStockResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStockResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["userFriendlyMessage"] = this.userFriendlyMessage;
        if (Array.isArray(this.unStockProducts)) {
            data["unStockProducts"] = [];
            for (let item of this.unStockProducts)
                data["unStockProducts"].push(item.toJSON());
        }
        if (Array.isArray(this.orderedProducts)) {
            data["orderedProducts"] = [];
            for (let item of this.orderedProducts)
                data["orderedProducts"].push(item.toJSON());
        }
        return data; 
    }

    clone(): OrderStockResultDto {
        const json = this.toJSON();
        let result = new OrderStockResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderStockResultDto {
    isValid: boolean | undefined;
    userFriendlyMessage: string | undefined;
    unStockProducts: OrderProductStockDto[] | undefined;
    orderedProducts: OrderProductStockDto[] | undefined;
}

export class OrderProductStockDto implements IOrderProductStockDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    productBrandName: string | undefined;
    productBoxQuantity: number | undefined;
    productPalletQuantity: number | undefined;
    warehouseCode: string | undefined;
    warehouseId: number | undefined;
    variationId: number | undefined;
    lot: string | undefined;
    exprirationDate: string | undefined;
    barcode: string | undefined;
    readonly isOrderBySpecialCode: boolean | undefined;
    quantity: number | undefined;
    readonly rawQuantity: number | undefined;
    blockedQuantity: number | undefined;
    dependQuantity: number | undefined;
    centerApprovedQuantity: number | undefined;
    readonly calculatedStockQuantity: number | undefined;
    sortIndex: number | undefined;
    isInstantStockView: boolean | undefined;
    ordererId: number | undefined;
    toAddressId: number | undefined;

    constructor(data?: IOrderProductStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.productBusinessUnitName = _data["productBusinessUnitName"];
            this.productWmsTypeName = _data["productWmsTypeName"];
            this.productBrandName = _data["productBrandName"];
            this.productBoxQuantity = _data["productBoxQuantity"];
            this.productPalletQuantity = _data["productPalletQuantity"];
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseId = _data["warehouseId"];
            this.variationId = _data["variationId"];
            this.lot = _data["lot"];
            this.exprirationDate = _data["exprirationDate"];
            this.barcode = _data["barcode"];
            (<any>this).isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.quantity = _data["quantity"];
            (<any>this).rawQuantity = _data["rawQuantity"];
            this.blockedQuantity = _data["blockedQuantity"];
            this.dependQuantity = _data["dependQuantity"];
            this.centerApprovedQuantity = _data["centerApprovedQuantity"];
            (<any>this).calculatedStockQuantity = _data["calculatedStockQuantity"];
            this.sortIndex = _data["sortIndex"];
            this.isInstantStockView = _data["isInstantStockView"];
            this.ordererId = _data["ordererId"];
            this.toAddressId = _data["toAddressId"];
        }
    }

    static fromJS(data: any): OrderProductStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["productBusinessUnitName"] = this.productBusinessUnitName;
        data["productWmsTypeName"] = this.productWmsTypeName;
        data["productBrandName"] = this.productBrandName;
        data["productBoxQuantity"] = this.productBoxQuantity;
        data["productPalletQuantity"] = this.productPalletQuantity;
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseId"] = this.warehouseId;
        data["variationId"] = this.variationId;
        data["lot"] = this.lot;
        data["exprirationDate"] = this.exprirationDate;
        data["barcode"] = this.barcode;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["quantity"] = this.quantity;
        data["rawQuantity"] = this.rawQuantity;
        data["blockedQuantity"] = this.blockedQuantity;
        data["dependQuantity"] = this.dependQuantity;
        data["centerApprovedQuantity"] = this.centerApprovedQuantity;
        data["calculatedStockQuantity"] = this.calculatedStockQuantity;
        data["sortIndex"] = this.sortIndex;
        data["isInstantStockView"] = this.isInstantStockView;
        data["ordererId"] = this.ordererId;
        data["toAddressId"] = this.toAddressId;
        return data; 
    }

    clone(): OrderProductStockDto {
        const json = this.toJSON();
        let result = new OrderProductStockDto();
        result.init(json);
        return result;
    }
}

export interface IOrderProductStockDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    productBrandName: string | undefined;
    productBoxQuantity: number | undefined;
    productPalletQuantity: number | undefined;
    warehouseCode: string | undefined;
    warehouseId: number | undefined;
    variationId: number | undefined;
    lot: string | undefined;
    exprirationDate: string | undefined;
    barcode: string | undefined;
    isOrderBySpecialCode: boolean | undefined;
    quantity: number | undefined;
    rawQuantity: number | undefined;
    blockedQuantity: number | undefined;
    dependQuantity: number | undefined;
    centerApprovedQuantity: number | undefined;
    calculatedStockQuantity: number | undefined;
    sortIndex: number | undefined;
    isInstantStockView: boolean | undefined;
    ordererId: number | undefined;
    toAddressId: number | undefined;
}

export class OrderProductTaskDto implements IOrderProductTaskDto {
    approverId: number | undefined;
    approverName: string | undefined;
    ordererId: number | undefined;
    ordererName: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    productBrand: string | undefined;
    productDeci: number | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    orderDateTime: moment.Moment | undefined;
    readonly orderDate: string | undefined;
    sourceAddressName: string | undefined;
    toAddressId: number | undefined;
    toAddressName: string | undefined;
    qty: number | undefined;
    approvedQty: number | undefined;
    orderDetailsId: number | undefined;
    variationId: number | undefined;
    expirationDate: string | undefined;
    lot: string | undefined;
    barcode: string | undefined;
    orderApprovalTaskId: number | undefined;
    fromWarehouseId: number | undefined;
    fromWarehouseCode: string | undefined;
    approvedStatusType: number | undefined;
    approvedStatus: OrderProductTaskDtoApprovedStatus | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;
    readonly isCanceledOrder: boolean | undefined;
    isChecked: boolean | undefined;
    approvalUsers: OrderApprovalUserDto[] | undefined;
    approvalUsersHasPersonInCharge: boolean | undefined;
    orderedWarehouseCodes: string[] | undefined;
    instantProductStock: number | undefined;
    hasOrderStockViewAuth: boolean | undefined;
    hasOrderSpecialCodeStockViewAuth: boolean | undefined;
    orderComment: string | undefined;

    constructor(data?: IOrderProductTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approverId = _data["approverId"];
            this.approverName = _data["approverName"];
            this.ordererId = _data["ordererId"];
            this.ordererName = _data["ordererName"];
            this.productId = _data["productId"];
            this.productCode = _data["productCode"];
            this.productName = _data["productName"];
            this.productBrand = _data["productBrand"];
            this.productDeci = _data["productDeci"];
            this.productBusinessUnitName = _data["productBusinessUnitName"];
            this.productWmsTypeName = _data["productWmsTypeName"];
            this.orderDateTime = _data["orderDateTime"] ? moment(_data["orderDateTime"].toString()) : <any>undefined;
            (<any>this).orderDate = _data["orderDate"];
            this.sourceAddressName = _data["sourceAddressName"];
            this.toAddressId = _data["toAddressId"];
            this.toAddressName = _data["toAddressName"];
            this.qty = _data["qty"];
            this.approvedQty = _data["approvedQty"];
            this.orderDetailsId = _data["orderDetailsId"];
            this.variationId = _data["variationId"];
            this.expirationDate = _data["expirationDate"];
            this.lot = _data["lot"];
            this.barcode = _data["barcode"];
            this.orderApprovalTaskId = _data["orderApprovalTaskId"];
            this.fromWarehouseId = _data["fromWarehouseId"];
            this.fromWarehouseCode = _data["fromWarehouseCode"];
            this.approvedStatusType = _data["approvedStatusType"];
            this.approvedStatus = _data["approvedStatus"];
            this.approvalStatusText = _data["approvalStatusText"];
            this.approvalStatusDescText = _data["approvalStatusDescText"];
            (<any>this).isCanceledOrder = _data["isCanceledOrder"];
            this.isChecked = _data["isChecked"];
            if (Array.isArray(_data["approvalUsers"])) {
                this.approvalUsers = [] as any;
                for (let item of _data["approvalUsers"])
                    this.approvalUsers.push(OrderApprovalUserDto.fromJS(item));
            }
            this.approvalUsersHasPersonInCharge = _data["approvalUsersHasPersonInCharge"];
            if (Array.isArray(_data["orderedWarehouseCodes"])) {
                this.orderedWarehouseCodes = [] as any;
                for (let item of _data["orderedWarehouseCodes"])
                    this.orderedWarehouseCodes.push(item);
            }
            this.instantProductStock = _data["instantProductStock"];
            this.hasOrderStockViewAuth = _data["hasOrderStockViewAuth"];
            this.hasOrderSpecialCodeStockViewAuth = _data["hasOrderSpecialCodeStockViewAuth"];
            this.orderComment = _data["orderComment"];
        }
    }

    static fromJS(data: any): OrderProductTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderProductTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approverId"] = this.approverId;
        data["approverName"] = this.approverName;
        data["ordererId"] = this.ordererId;
        data["ordererName"] = this.ordererName;
        data["productId"] = this.productId;
        data["productCode"] = this.productCode;
        data["productName"] = this.productName;
        data["productBrand"] = this.productBrand;
        data["productDeci"] = this.productDeci;
        data["productBusinessUnitName"] = this.productBusinessUnitName;
        data["productWmsTypeName"] = this.productWmsTypeName;
        data["orderDateTime"] = this.orderDateTime ? this.orderDateTime.toISOString() : <any>undefined;
        data["orderDate"] = this.orderDate;
        data["sourceAddressName"] = this.sourceAddressName;
        data["toAddressId"] = this.toAddressId;
        data["toAddressName"] = this.toAddressName;
        data["qty"] = this.qty;
        data["approvedQty"] = this.approvedQty;
        data["orderDetailsId"] = this.orderDetailsId;
        data["variationId"] = this.variationId;
        data["expirationDate"] = this.expirationDate;
        data["lot"] = this.lot;
        data["barcode"] = this.barcode;
        data["orderApprovalTaskId"] = this.orderApprovalTaskId;
        data["fromWarehouseId"] = this.fromWarehouseId;
        data["fromWarehouseCode"] = this.fromWarehouseCode;
        data["approvedStatusType"] = this.approvedStatusType;
        data["approvedStatus"] = this.approvedStatus;
        data["approvalStatusText"] = this.approvalStatusText;
        data["approvalStatusDescText"] = this.approvalStatusDescText;
        data["isCanceledOrder"] = this.isCanceledOrder;
        data["isChecked"] = this.isChecked;
        if (Array.isArray(this.approvalUsers)) {
            data["approvalUsers"] = [];
            for (let item of this.approvalUsers)
                data["approvalUsers"].push(item.toJSON());
        }
        data["approvalUsersHasPersonInCharge"] = this.approvalUsersHasPersonInCharge;
        if (Array.isArray(this.orderedWarehouseCodes)) {
            data["orderedWarehouseCodes"] = [];
            for (let item of this.orderedWarehouseCodes)
                data["orderedWarehouseCodes"].push(item);
        }
        data["instantProductStock"] = this.instantProductStock;
        data["hasOrderStockViewAuth"] = this.hasOrderStockViewAuth;
        data["hasOrderSpecialCodeStockViewAuth"] = this.hasOrderSpecialCodeStockViewAuth;
        data["orderComment"] = this.orderComment;
        return data; 
    }

    clone(): OrderProductTaskDto {
        const json = this.toJSON();
        let result = new OrderProductTaskDto();
        result.init(json);
        return result;
    }
}

export interface IOrderProductTaskDto {
    approverId: number | undefined;
    approverName: string | undefined;
    ordererId: number | undefined;
    ordererName: string | undefined;
    productId: number | undefined;
    productCode: string | undefined;
    productName: string | undefined;
    productBrand: string | undefined;
    productDeci: number | undefined;
    productBusinessUnitName: string | undefined;
    productWmsTypeName: string | undefined;
    orderDateTime: moment.Moment | undefined;
    orderDate: string | undefined;
    sourceAddressName: string | undefined;
    toAddressId: number | undefined;
    toAddressName: string | undefined;
    qty: number | undefined;
    approvedQty: number | undefined;
    orderDetailsId: number | undefined;
    variationId: number | undefined;
    expirationDate: string | undefined;
    lot: string | undefined;
    barcode: string | undefined;
    orderApprovalTaskId: number | undefined;
    fromWarehouseId: number | undefined;
    fromWarehouseCode: string | undefined;
    approvedStatusType: number | undefined;
    approvedStatus: OrderProductTaskDtoApprovedStatus | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;
    isCanceledOrder: boolean | undefined;
    isChecked: boolean | undefined;
    approvalUsers: OrderApprovalUserDto[] | undefined;
    approvalUsersHasPersonInCharge: boolean | undefined;
    orderedWarehouseCodes: string[] | undefined;
    instantProductStock: number | undefined;
    hasOrderStockViewAuth: boolean | undefined;
    hasOrderSpecialCodeStockViewAuth: boolean | undefined;
    orderComment: string | undefined;
}

export class OrderApprovalUserDto implements IOrderApprovalUserDto {
    userId: number | undefined;
    userName: string | undefined;
    approvalStatusType: OrderApprovalUserDtoApprovalStatusType | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;

    constructor(data?: IOrderApprovalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.approvalStatusType = _data["approvalStatusType"];
            this.approvalStatusText = _data["approvalStatusText"];
            this.approvalStatusDescText = _data["approvalStatusDescText"];
        }
    }

    static fromJS(data: any): OrderApprovalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["approvalStatusType"] = this.approvalStatusType;
        data["approvalStatusText"] = this.approvalStatusText;
        data["approvalStatusDescText"] = this.approvalStatusDescText;
        return data; 
    }

    clone(): OrderApprovalUserDto {
        const json = this.toJSON();
        let result = new OrderApprovalUserDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalUserDto {
    userId: number | undefined;
    userName: string | undefined;
    approvalStatusType: OrderApprovalUserDtoApprovalStatusType | undefined;
    approvalStatusText: string | undefined;
    approvalStatusDescText: string | undefined;
}

export class OrderApprovedDto implements IOrderApprovedDto {
    toAddressId: number | undefined;
    quantity: number | undefined;
    orderId: number | undefined;
    orderDetailsId: number | undefined;
    approvedQty: number | undefined;
    productId: number | undefined;
    variationId: number | undefined;
    specialCode: string | undefined;
    readonly isOrderBySpecialCode: boolean | undefined;
    warehouseId: number | undefined;
    warehouseCode: string | undefined;
    isUserStockView: boolean | undefined;
    isUserSpecialCodeStockView: boolean | undefined;
    sortIndex: number | undefined;
    orderedDate: moment.Moment | undefined;
    statusText: string | undefined;
    statusStyleText: string | undefined;
    status: OrderApprovedDtoStatus | undefined;
    orderableTotalQuantity: number | undefined;
    ordererId: number | undefined;
    productWmsTypeName: string | undefined;
    relatedBigSizeProductIds: number[] | undefined;

    constructor(data?: IOrderApprovedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toAddressId = _data["toAddressId"];
            this.quantity = _data["quantity"];
            this.orderId = _data["orderId"];
            this.orderDetailsId = _data["orderDetailsId"];
            this.approvedQty = _data["approvedQty"];
            this.productId = _data["productId"];
            this.variationId = _data["variationId"];
            this.specialCode = _data["specialCode"];
            (<any>this).isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseCode = _data["warehouseCode"];
            this.isUserStockView = _data["isUserStockView"];
            this.isUserSpecialCodeStockView = _data["isUserSpecialCodeStockView"];
            this.sortIndex = _data["sortIndex"];
            this.orderedDate = _data["orderedDate"] ? moment(_data["orderedDate"].toString()) : <any>undefined;
            this.statusText = _data["statusText"];
            this.statusStyleText = _data["statusStyleText"];
            this.status = _data["status"];
            this.orderableTotalQuantity = _data["orderableTotalQuantity"];
            this.ordererId = _data["ordererId"];
            this.productWmsTypeName = _data["productWmsTypeName"];
            if (Array.isArray(_data["relatedBigSizeProductIds"])) {
                this.relatedBigSizeProductIds = [] as any;
                for (let item of _data["relatedBigSizeProductIds"])
                    this.relatedBigSizeProductIds.push(item);
            }
        }
    }

    static fromJS(data: any): OrderApprovedDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toAddressId"] = this.toAddressId;
        data["quantity"] = this.quantity;
        data["orderId"] = this.orderId;
        data["orderDetailsId"] = this.orderDetailsId;
        data["approvedQty"] = this.approvedQty;
        data["productId"] = this.productId;
        data["variationId"] = this.variationId;
        data["specialCode"] = this.specialCode;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["warehouseId"] = this.warehouseId;
        data["warehouseCode"] = this.warehouseCode;
        data["isUserStockView"] = this.isUserStockView;
        data["isUserSpecialCodeStockView"] = this.isUserSpecialCodeStockView;
        data["sortIndex"] = this.sortIndex;
        data["orderedDate"] = this.orderedDate ? this.orderedDate.toISOString() : <any>undefined;
        data["statusText"] = this.statusText;
        data["statusStyleText"] = this.statusStyleText;
        data["status"] = this.status;
        data["orderableTotalQuantity"] = this.orderableTotalQuantity;
        data["ordererId"] = this.ordererId;
        data["productWmsTypeName"] = this.productWmsTypeName;
        if (Array.isArray(this.relatedBigSizeProductIds)) {
            data["relatedBigSizeProductIds"] = [];
            for (let item of this.relatedBigSizeProductIds)
                data["relatedBigSizeProductIds"].push(item);
        }
        return data; 
    }

    clone(): OrderApprovedDto {
        const json = this.toJSON();
        let result = new OrderApprovedDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovedDto {
    toAddressId: number | undefined;
    quantity: number | undefined;
    orderId: number | undefined;
    orderDetailsId: number | undefined;
    approvedQty: number | undefined;
    productId: number | undefined;
    variationId: number | undefined;
    specialCode: string | undefined;
    isOrderBySpecialCode: boolean | undefined;
    warehouseId: number | undefined;
    warehouseCode: string | undefined;
    isUserStockView: boolean | undefined;
    isUserSpecialCodeStockView: boolean | undefined;
    sortIndex: number | undefined;
    orderedDate: moment.Moment | undefined;
    statusText: string | undefined;
    statusStyleText: string | undefined;
    status: OrderApprovedDtoStatus | undefined;
    orderableTotalQuantity: number | undefined;
    ordererId: number | undefined;
    productWmsTypeName: string | undefined;
    relatedBigSizeProductIds: number[] | undefined;
}

export class OrderApprovalTypesDto implements IOrderApprovalTypesDto {
    id: number | undefined;
    name: string | undefined;

    constructor(data?: IOrderApprovalTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): OrderApprovalTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }

    clone(): OrderApprovalTypesDto {
        const json = this.toJSON();
        let result = new OrderApprovalTypesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalTypesDto {
    id: number | undefined;
    name: string | undefined;
}

export class ProductLocationHistoryDto implements IProductLocationHistoryDto {
    date: moment.Moment | undefined;
    readonly formatedDate: string | undefined;
    quantity: number | undefined;
    kaynakAddress: string | undefined;
    durum: string | undefined;

    constructor(data?: IProductLocationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            (<any>this).formatedDate = _data["formatedDate"];
            this.quantity = _data["quantity"];
            this.kaynakAddress = _data["kaynakAddress"];
            this.durum = _data["durum"];
        }
    }

    static fromJS(data: any): ProductLocationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLocationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["formatedDate"] = this.formatedDate;
        data["quantity"] = this.quantity;
        data["kaynakAddress"] = this.kaynakAddress;
        data["durum"] = this.durum;
        return data; 
    }

    clone(): ProductLocationHistoryDto {
        const json = this.toJSON();
        let result = new ProductLocationHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IProductLocationHistoryDto {
    date: moment.Moment | undefined;
    formatedDate: string | undefined;
    quantity: number | undefined;
    kaynakAddress: string | undefined;
    durum: string | undefined;
}

export class ApprovalRulesGroupedTitlesDto implements IApprovalRulesGroupedTitlesDto {
    groupId: number | undefined;
    addressCategoryId: number | undefined;
    addressCategoryName: string | undefined;
    readonly approverText: string | undefined;
    approvers: ApproverDto[] | undefined;

    constructor(data?: IApprovalRulesGroupedTitlesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.addressCategoryId = _data["addressCategoryId"];
            this.addressCategoryName = _data["addressCategoryName"];
            (<any>this).approverText = _data["approverText"];
            if (Array.isArray(_data["approvers"])) {
                this.approvers = [] as any;
                for (let item of _data["approvers"])
                    this.approvers.push(ApproverDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalRulesGroupedTitlesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRulesGroupedTitlesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["addressCategoryId"] = this.addressCategoryId;
        data["addressCategoryName"] = this.addressCategoryName;
        data["approverText"] = this.approverText;
        if (Array.isArray(this.approvers)) {
            data["approvers"] = [];
            for (let item of this.approvers)
                data["approvers"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ApprovalRulesGroupedTitlesDto {
        const json = this.toJSON();
        let result = new ApprovalRulesGroupedTitlesDto();
        result.init(json);
        return result;
    }
}

export interface IApprovalRulesGroupedTitlesDto {
    groupId: number | undefined;
    addressCategoryId: number | undefined;
    addressCategoryName: string | undefined;
    approverText: string | undefined;
    approvers: ApproverDto[] | undefined;
}

export class ApproverDto implements IApproverDto {
    titleId: number | undefined;
    titleName: string | undefined;
    approvalSortOrder: number | undefined;

    constructor(data?: IApproverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.titleName = _data["titleName"];
            this.approvalSortOrder = _data["approvalSortOrder"];
        }
    }

    static fromJS(data: any): ApproverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApproverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["approvalSortOrder"] = this.approvalSortOrder;
        return data; 
    }

    clone(): ApproverDto {
        const json = this.toJSON();
        let result = new ApproverDto();
        result.init(json);
        return result;
    }
}

export interface IApproverDto {
    titleId: number | undefined;
    titleName: string | undefined;
    approvalSortOrder: number | undefined;
}

export class ApprovalRulesCategoryDto implements IApprovalRulesCategoryDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: IApprovalRulesCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApprovalRulesCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRulesCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ApprovalRulesCategoryDto {
        const json = this.toJSON();
        let result = new ApprovalRulesCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IApprovalRulesCategoryDto {
    name: string | undefined;
    id: number | undefined;
}

export class OrderApprovalRulesDto implements IOrderApprovalRulesDto {
    id: number | undefined;

    constructor(data?: IOrderApprovalRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderApprovalRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderApprovalRulesDto {
        const json = this.toJSON();
        let result = new OrderApprovalRulesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalRulesDto {
    id: number | undefined;
}

export class PagedResultDtoOfOrderApprovalRulesDto implements IPagedResultDtoOfOrderApprovalRulesDto {
    totalCount: number | undefined;
    items: OrderApprovalRulesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderApprovalRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderApprovalRulesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderApprovalRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderApprovalRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfOrderApprovalRulesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrderApprovalRulesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrderApprovalRulesDto {
    totalCount: number | undefined;
    items: OrderApprovalRulesDto[] | undefined;
}

export class CreateOrderApprovalRulesDto implements ICreateOrderApprovalRulesDto {
    id: number | undefined;

    constructor(data?: ICreateOrderApprovalRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderApprovalRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderApprovalRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateOrderApprovalRulesDto {
        const json = this.toJSON();
        let result = new CreateOrderApprovalRulesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderApprovalRulesDto {
    id: number | undefined;
}

export class PagedResultDtoOfOrderApprovalTaskRepairDto implements IPagedResultDtoOfOrderApprovalTaskRepairDto {
    totalCount: number | undefined;
    items: OrderApprovalTaskRepairDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderApprovalTaskRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderApprovalTaskRepairDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderApprovalTaskRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderApprovalTaskRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfOrderApprovalTaskRepairDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrderApprovalTaskRepairDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrderApprovalTaskRepairDto {
    totalCount: number | undefined;
    items: OrderApprovalTaskRepairDto[] | undefined;
}

export class OrderApprovalTaskRepairDto implements IOrderApprovalTaskRepairDto {
    addressId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    addressPoiId: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;

    constructor(data?: IOrderApprovalTaskRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.addressName = _data["addressName"];
            this.fullAddress = _data["fullAddress"];
            this.addressPoiId = _data["addressPoiId"];
            this.customerName = _data["customerName"];
            this.titleId = _data["titleId"];
            this.titleName = _data["titleName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderApprovalTaskRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderApprovalTaskRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["addressName"] = this.addressName;
        data["fullAddress"] = this.fullAddress;
        data["addressPoiId"] = this.addressPoiId;
        data["customerName"] = this.customerName;
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderApprovalTaskRepairDto {
        const json = this.toJSON();
        let result = new OrderApprovalTaskRepairDto();
        result.init(json);
        return result;
    }
}

export interface IOrderApprovalTaskRepairDto {
    addressId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    addressPoiId: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;
}

export class CreateOrderApprovalTaskRepairDto implements ICreateOrderApprovalTaskRepairDto {
    id: number | undefined;

    constructor(data?: ICreateOrderApprovalTaskRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderApprovalTaskRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderApprovalTaskRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateOrderApprovalTaskRepairDto {
        const json = this.toJSON();
        let result = new CreateOrderApprovalTaskRepairDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderApprovalTaskRepairDto {
    id: number | undefined;
}

export class CreateOrderCartDto implements ICreateOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateOrderCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.productId = _data["productId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["productId"] = this.productId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateOrderCartDto {
        const json = this.toJSON();
        let result = new CreateOrderCartDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;
}

export class OrderCartDto implements IOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;

    constructor(data?: IOrderCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.productId = _data["productId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrderCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["productId"] = this.productId;
        data["id"] = this.id;
        return data; 
    }

    clone(): OrderCartDto {
        const json = this.toJSON();
        let result = new OrderCartDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCartDto {
    userId: number | undefined;
    productId: number | undefined;
    id: number | undefined;
}

export class CreateOrderCartExceptionDto implements ICreateOrderCartExceptionDto {
    products: ProductDto[] | undefined;
    exceptionMessage: string | undefined;

    constructor(data?: ICreateOrderCartExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(ProductDto.fromJS(item));
            }
            this.exceptionMessage = _data["exceptionMessage"];
        }
    }

    static fromJS(data: any): CreateOrderCartExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderCartExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["exceptionMessage"] = this.exceptionMessage;
        return data; 
    }

    clone(): CreateOrderCartExceptionDto {
        const json = this.toJSON();
        let result = new CreateOrderCartExceptionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderCartExceptionDto {
    products: ProductDto[] | undefined;
    exceptionMessage: string | undefined;
}

export class PagedResultDtoOfOrderCartDto implements IPagedResultDtoOfOrderCartDto {
    totalCount: number | undefined;
    items: OrderCartDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrderCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderCartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrderCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrderCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfOrderCartDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfOrderCartDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfOrderCartDto {
    totalCount: number | undefined;
    items: OrderCartDto[] | undefined;
}

export class PagedResultDtoOfPageDto implements IPagedResultDtoOfPageDto {
    totalCount: number | undefined;
    items: PageDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfPageDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPageDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPageDto {
    totalCount: number | undefined;
    items: PageDto[] | undefined;
}

export class PageDto implements IPageDto {
    name: string | undefined;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    parentId: number | undefined;
    parentName: string | undefined;
    id: number | undefined;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.header = _data["header"];
            this.subHeader = _data["subHeader"];
            this.info = _data["info"];
            this.menuIconUrl = _data["menuIconUrl"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.comment = _data["comment"];
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["header"] = this.header;
        data["subHeader"] = this.subHeader;
        data["info"] = this.info;
        data["menuIconUrl"] = this.menuIconUrl;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["comment"] = this.comment;
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["id"] = this.id;
        return data; 
    }

    clone(): PageDto {
        const json = this.toJSON();
        let result = new PageDto();
        result.init(json);
        return result;
    }
}

export interface IPageDto {
    name: string | undefined;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    parentId: number | undefined;
    parentName: string | undefined;
    id: number | undefined;
}

export class CreatePageDto implements ICreatePageDto {
    name: string;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    parentId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreatePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.header = _data["header"];
            this.subHeader = _data["subHeader"];
            this.info = _data["info"];
            this.menuIconUrl = _data["menuIconUrl"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.comment = _data["comment"];
            this.moduleId = _data["moduleId"];
            this.parentId = _data["parentId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["header"] = this.header;
        data["subHeader"] = this.subHeader;
        data["info"] = this.info;
        data["menuIconUrl"] = this.menuIconUrl;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["comment"] = this.comment;
        data["moduleId"] = this.moduleId;
        data["parentId"] = this.parentId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreatePageDto {
        const json = this.toJSON();
        let result = new CreatePageDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePageDto {
    name: string;
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    moduleId: number | undefined;
    parentId: number | undefined;
    id: number | undefined;
}

export class ExcelPagedResultDtoOfPageExcelDto implements IExcelPagedResultDtoOfPageExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: PageExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfPageExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PageExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfPageExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfPageExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ExcelPagedResultDtoOfPageExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfPageExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfPageExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: PageExcelDto[] | undefined;
}

export class PageExcelDto implements IPageExcelDto {
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: IPageExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.header = _data["header"];
            this.subHeader = _data["subHeader"];
            this.info = _data["info"];
            this.menuIconUrl = _data["menuIconUrl"];
            this.sortOrder = _data["sortOrder"];
            this.isDefault = _data["isDefault"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PageExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["header"] = this.header;
        data["subHeader"] = this.subHeader;
        data["info"] = this.info;
        data["menuIconUrl"] = this.menuIconUrl;
        data["sortOrder"] = this.sortOrder;
        data["isDefault"] = this.isDefault;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data; 
    }

    clone(): PageExcelDto {
        const json = this.toJSON();
        let result = new PageExcelDto();
        result.init(json);
        return result;
    }
}

export interface IPageExcelDto {
    url: string | undefined;
    header: string | undefined;
    subHeader: string | undefined;
    info: string | undefined;
    menuIconUrl: string | undefined;
    sortOrder: number | undefined;
    isDefault: boolean | undefined;
    comment: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfPlanDto implements IPagedResultDtoOfPlanDto {
    totalCount: number | undefined;
    items: PlanDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PlanDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfPlanDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPlanDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPlanDto {
    totalCount: number | undefined;
    items: PlanDto[] | undefined;
}

export class PlanDto implements IPlanDto {
    name: string | undefined;
    description: string | undefined;
    datasetId: number | undefined;
    datasetName: string | undefined;
    relatedRegionCount: number | undefined;
    id: number | undefined;

    constructor(data?: IPlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.datasetId = _data["datasetId"];
            this.datasetName = _data["datasetName"];
            this.relatedRegionCount = _data["relatedRegionCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["datasetId"] = this.datasetId;
        data["datasetName"] = this.datasetName;
        data["relatedRegionCount"] = this.relatedRegionCount;
        data["id"] = this.id;
        return data; 
    }

    clone(): PlanDto {
        const json = this.toJSON();
        let result = new PlanDto();
        result.init(json);
        return result;
    }
}

export interface IPlanDto {
    name: string | undefined;
    description: string | undefined;
    datasetId: number | undefined;
    datasetName: string | undefined;
    relatedRegionCount: number | undefined;
    id: number | undefined;
}

export class CreatePlanDto implements ICreatePlanDto {
    name: string | undefined;
    description: string | undefined;
    datasetId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreatePlanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.datasetId = _data["datasetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePlanDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["datasetId"] = this.datasetId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreatePlanDto {
        const json = this.toJSON();
        let result = new CreatePlanDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlanDto {
    name: string | undefined;
    description: string | undefined;
    datasetId: number | undefined;
    id: number | undefined;
}

export class ListItemDto implements IListItemDto {
    id: any | undefined;
    text: any | undefined;

    constructor(data?: IListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data; 
    }

    clone(): ListItemDto {
        const json = this.toJSON();
        let result = new ListItemDto();
        result.init(json);
        return result;
    }
}

export interface IListItemDto {
    id: any | undefined;
    text: any | undefined;
}

export class CreateLaunchDto implements ICreateLaunchDto {
    name: string;
    firmaId: string | undefined;
    markaId: string;
    baslangicTarihi: moment.Moment;
    butce: number | undefined;
    aciklama: string | undefined;
    id: string | undefined;

    constructor(data?: ICreateLaunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firmaId = _data["firmaId"];
            this.markaId = _data["markaId"];
            this.baslangicTarihi = _data["baslangicTarihi"] ? moment(_data["baslangicTarihi"].toString()) : <any>undefined;
            this.butce = _data["butce"];
            this.aciklama = _data["aciklama"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateLaunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLaunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firmaId"] = this.firmaId;
        data["markaId"] = this.markaId;
        data["baslangicTarihi"] = this.baslangicTarihi ? this.baslangicTarihi.toISOString() : <any>undefined;
        data["butce"] = this.butce;
        data["aciklama"] = this.aciklama;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateLaunchDto {
        const json = this.toJSON();
        let result = new CreateLaunchDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLaunchDto {
    name: string;
    firmaId: string | undefined;
    markaId: string;
    baslangicTarihi: moment.Moment;
    butce: number | undefined;
    aciklama: string | undefined;
    id: string | undefined;
}

export class LaunchSettingsDto implements ILaunchSettingsDto {
    launchId: string | undefined;
    isSahaPosmTaleplerineAcik: boolean | undefined;
    isSpvChipDagitiminaAcik: boolean | undefined;

    constructor(data?: ILaunchSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.launchId = _data["launchId"];
            this.isSahaPosmTaleplerineAcik = _data["isSahaPosmTaleplerineAcik"];
            this.isSpvChipDagitiminaAcik = _data["isSpvChipDagitiminaAcik"];
        }
    }

    static fromJS(data: any): LaunchSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaunchSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["launchId"] = this.launchId;
        data["isSahaPosmTaleplerineAcik"] = this.isSahaPosmTaleplerineAcik;
        data["isSpvChipDagitiminaAcik"] = this.isSpvChipDagitiminaAcik;
        return data; 
    }

    clone(): LaunchSettingsDto {
        const json = this.toJSON();
        let result = new LaunchSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ILaunchSettingsDto {
    launchId: string | undefined;
    isSahaPosmTaleplerineAcik: boolean | undefined;
    isSpvChipDagitiminaAcik: boolean | undefined;
}

export class PagedResultDtoOfLaunchDto implements IPagedResultDtoOfLaunchDto {
    totalCount: number | undefined;
    items: LaunchDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLaunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LaunchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLaunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLaunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfLaunchDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLaunchDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLaunchDto {
    totalCount: number | undefined;
    items: LaunchDto[] | undefined;
}

export class LaunchDto implements ILaunchDto {
    name: string | undefined;
    sistemKodu: string | undefined;
    firmaId: string | undefined;
    firmaAdi: string | undefined;
    markaId: string | undefined;
    marka: string | undefined;
    baslangicTarihi: moment.Moment | undefined;
    butce: number | undefined;
    aciklama: string | undefined;
    posmAdet: number | undefined;
    isSupervisoreChipDagitiminaAcik: boolean | undefined;
    isSahaTaleplerineAcik: boolean | undefined;
    id: string | undefined;

    constructor(data?: ILaunchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sistemKodu = _data["sistemKodu"];
            this.firmaId = _data["firmaId"];
            this.firmaAdi = _data["firmaAdi"];
            this.markaId = _data["markaId"];
            this.marka = _data["marka"];
            this.baslangicTarihi = _data["baslangicTarihi"] ? moment(_data["baslangicTarihi"].toString()) : <any>undefined;
            this.butce = _data["butce"];
            this.aciklama = _data["aciklama"];
            this.posmAdet = _data["posmAdet"];
            this.isSupervisoreChipDagitiminaAcik = _data["isSupervisoreChipDagitiminaAcik"];
            this.isSahaTaleplerineAcik = _data["isSahaTaleplerineAcik"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LaunchDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaunchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sistemKodu"] = this.sistemKodu;
        data["firmaId"] = this.firmaId;
        data["firmaAdi"] = this.firmaAdi;
        data["markaId"] = this.markaId;
        data["marka"] = this.marka;
        data["baslangicTarihi"] = this.baslangicTarihi ? this.baslangicTarihi.toISOString() : <any>undefined;
        data["butce"] = this.butce;
        data["aciklama"] = this.aciklama;
        data["posmAdet"] = this.posmAdet;
        data["isSupervisoreChipDagitiminaAcik"] = this.isSupervisoreChipDagitiminaAcik;
        data["isSahaTaleplerineAcik"] = this.isSahaTaleplerineAcik;
        data["id"] = this.id;
        return data; 
    }

    clone(): LaunchDto {
        const json = this.toJSON();
        let result = new LaunchDto();
        result.init(json);
        return result;
    }
}

export interface ILaunchDto {
    name: string | undefined;
    sistemKodu: string | undefined;
    firmaId: string | undefined;
    firmaAdi: string | undefined;
    markaId: string | undefined;
    marka: string | undefined;
    baslangicTarihi: moment.Moment | undefined;
    butce: number | undefined;
    aciklama: string | undefined;
    posmAdet: number | undefined;
    isSupervisoreChipDagitiminaAcik: boolean | undefined;
    isSahaTaleplerineAcik: boolean | undefined;
    id: string | undefined;
}

export class PosmDto implements IPosmDto {
    name: string | undefined;
    posmKodu: string | undefined;
    markalar: string[] | undefined;
    durum: string | undefined;
    uretimToplamIslemAdimi: number | undefined;
    uretimGuncelIslemAdimNo: number | undefined;
    tasarimToplamIslemAdimi: number | undefined;
    tasarimGuncelIslemAdimNo: number | undefined;
    uretimGuncelFirma: string | undefined;
    uretimGuncelYetkili: string | undefined;
    tasarimGuncelFirma: string | undefined;
    tasarimGuncelYetkili: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    readonly uretimGoreviTamamlanmaDurumu: number | undefined;
    readonly tasarimGoreviTamamlanmaDurumu: number | undefined;
    id: string | undefined;

    constructor(data?: IPosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.posmKodu = _data["posmKodu"];
            if (Array.isArray(_data["markalar"])) {
                this.markalar = [] as any;
                for (let item of _data["markalar"])
                    this.markalar.push(item);
            }
            this.durum = _data["durum"];
            this.uretimToplamIslemAdimi = _data["uretimToplamIslemAdimi"];
            this.uretimGuncelIslemAdimNo = _data["uretimGuncelIslemAdimNo"];
            this.tasarimToplamIslemAdimi = _data["tasarimToplamIslemAdimi"];
            this.tasarimGuncelIslemAdimNo = _data["tasarimGuncelIslemAdimNo"];
            this.uretimGuncelFirma = _data["uretimGuncelFirma"];
            this.uretimGuncelYetkili = _data["uretimGuncelYetkili"];
            this.tasarimGuncelFirma = _data["tasarimGuncelFirma"];
            this.tasarimGuncelYetkili = _data["tasarimGuncelYetkili"];
            this.butcePuani = _data["butcePuani"];
            this.isNumuneKullanimi = _data["isNumuneKullanimi"];
            (<any>this).uretimGoreviTamamlanmaDurumu = _data["uretimGoreviTamamlanmaDurumu"];
            (<any>this).tasarimGoreviTamamlanmaDurumu = _data["tasarimGoreviTamamlanmaDurumu"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["posmKodu"] = this.posmKodu;
        if (Array.isArray(this.markalar)) {
            data["markalar"] = [];
            for (let item of this.markalar)
                data["markalar"].push(item);
        }
        data["durum"] = this.durum;
        data["uretimToplamIslemAdimi"] = this.uretimToplamIslemAdimi;
        data["uretimGuncelIslemAdimNo"] = this.uretimGuncelIslemAdimNo;
        data["tasarimToplamIslemAdimi"] = this.tasarimToplamIslemAdimi;
        data["tasarimGuncelIslemAdimNo"] = this.tasarimGuncelIslemAdimNo;
        data["uretimGuncelFirma"] = this.uretimGuncelFirma;
        data["uretimGuncelYetkili"] = this.uretimGuncelYetkili;
        data["tasarimGuncelFirma"] = this.tasarimGuncelFirma;
        data["tasarimGuncelYetkili"] = this.tasarimGuncelYetkili;
        data["butcePuani"] = this.butcePuani;
        data["isNumuneKullanimi"] = this.isNumuneKullanimi;
        data["uretimGoreviTamamlanmaDurumu"] = this.uretimGoreviTamamlanmaDurumu;
        data["tasarimGoreviTamamlanmaDurumu"] = this.tasarimGoreviTamamlanmaDurumu;
        data["id"] = this.id;
        return data; 
    }

    clone(): PosmDto {
        const json = this.toJSON();
        let result = new PosmDto();
        result.init(json);
        return result;
    }
}

export interface IPosmDto {
    name: string | undefined;
    posmKodu: string | undefined;
    markalar: string[] | undefined;
    durum: string | undefined;
    uretimToplamIslemAdimi: number | undefined;
    uretimGuncelIslemAdimNo: number | undefined;
    tasarimToplamIslemAdimi: number | undefined;
    tasarimGuncelIslemAdimNo: number | undefined;
    uretimGuncelFirma: string | undefined;
    uretimGuncelYetkili: string | undefined;
    tasarimGuncelFirma: string | undefined;
    tasarimGuncelYetkili: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    uretimGoreviTamamlanmaDurumu: number | undefined;
    tasarimGoreviTamamlanmaDurumu: number | undefined;
    id: string | undefined;
}

export class PosmProductionTaskDto implements IPosmProductionTaskDto {
    name: string | undefined;
    posmAdi: string | undefined;
    gorevTipi: PosmProductionTaskDtoGorevTipi | undefined;
    toplamOnayAdimi: number | undefined;
    onayAdimNo: number | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    durum: PosmProductionTaskDtoDurum | undefined;
    gorevBitisTarihi: moment.Moment | undefined;
    tamamlanmaTarihi: moment.Moment | undefined;
    ilgiliFirma: string | undefined;
    sorumluAdSoyad: string | undefined;
    id: string | undefined;

    constructor(data?: IPosmProductionTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.posmAdi = _data["posmAdi"];
            this.gorevTipi = _data["gorevTipi"];
            this.toplamOnayAdimi = _data["toplamOnayAdimi"];
            this.onayAdimNo = _data["onayAdimNo"];
            this.gorevAciklama = _data["gorevAciklama"];
            this.gorevDetayAciklama = _data["gorevDetayAciklama"];
            this.durum = _data["durum"];
            this.gorevBitisTarihi = _data["gorevBitisTarihi"] ? moment(_data["gorevBitisTarihi"].toString()) : <any>undefined;
            this.tamamlanmaTarihi = _data["tamamlanmaTarihi"] ? moment(_data["tamamlanmaTarihi"].toString()) : <any>undefined;
            this.ilgiliFirma = _data["ilgiliFirma"];
            this.sorumluAdSoyad = _data["sorumluAdSoyad"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmProductionTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["posmAdi"] = this.posmAdi;
        data["gorevTipi"] = this.gorevTipi;
        data["toplamOnayAdimi"] = this.toplamOnayAdimi;
        data["onayAdimNo"] = this.onayAdimNo;
        data["gorevAciklama"] = this.gorevAciklama;
        data["gorevDetayAciklama"] = this.gorevDetayAciklama;
        data["durum"] = this.durum;
        data["gorevBitisTarihi"] = this.gorevBitisTarihi ? this.gorevBitisTarihi.toISOString() : <any>undefined;
        data["tamamlanmaTarihi"] = this.tamamlanmaTarihi ? this.tamamlanmaTarihi.toISOString() : <any>undefined;
        data["ilgiliFirma"] = this.ilgiliFirma;
        data["sorumluAdSoyad"] = this.sorumluAdSoyad;
        data["id"] = this.id;
        return data; 
    }

    clone(): PosmProductionTaskDto {
        const json = this.toJSON();
        let result = new PosmProductionTaskDto();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionTaskDto {
    name: string | undefined;
    posmAdi: string | undefined;
    gorevTipi: PosmProductionTaskDtoGorevTipi | undefined;
    toplamOnayAdimi: number | undefined;
    onayAdimNo: number | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    durum: PosmProductionTaskDtoDurum | undefined;
    gorevBitisTarihi: moment.Moment | undefined;
    tamamlanmaTarihi: moment.Moment | undefined;
    ilgiliFirma: string | undefined;
    sorumluAdSoyad: string | undefined;
    id: string | undefined;
}

export class PosmProductionTaskGroupDto implements IPosmProductionTaskGroupDto {
    name: string | undefined;
    lansmanAdi: string | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    sorumluPersonel: string | undefined;
    sorumluFirma: string | undefined;
    gorevSonTarihi: moment.Moment | undefined;
    readonly isSureDoldu: boolean | undefined;
    id: string | undefined;

    constructor(data?: IPosmProductionTaskGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lansmanAdi = _data["lansmanAdi"];
            this.gorevAciklama = _data["gorevAciklama"];
            this.gorevDetayAciklama = _data["gorevDetayAciklama"];
            this.sorumluPersonel = _data["sorumluPersonel"];
            this.sorumluFirma = _data["sorumluFirma"];
            this.gorevSonTarihi = _data["gorevSonTarihi"] ? moment(_data["gorevSonTarihi"].toString()) : <any>undefined;
            (<any>this).isSureDoldu = _data["isSureDoldu"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmProductionTaskGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionTaskGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lansmanAdi"] = this.lansmanAdi;
        data["gorevAciklama"] = this.gorevAciklama;
        data["gorevDetayAciklama"] = this.gorevDetayAciklama;
        data["sorumluPersonel"] = this.sorumluPersonel;
        data["sorumluFirma"] = this.sorumluFirma;
        data["gorevSonTarihi"] = this.gorevSonTarihi ? this.gorevSonTarihi.toISOString() : <any>undefined;
        data["isSureDoldu"] = this.isSureDoldu;
        data["id"] = this.id;
        return data; 
    }

    clone(): PosmProductionTaskGroupDto {
        const json = this.toJSON();
        let result = new PosmProductionTaskGroupDto();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionTaskGroupDto {
    name: string | undefined;
    lansmanAdi: string | undefined;
    gorevAciklama: string | undefined;
    gorevDetayAciklama: string | undefined;
    sorumluPersonel: string | undefined;
    sorumluFirma: string | undefined;
    gorevSonTarihi: moment.Moment | undefined;
    isSureDoldu: boolean | undefined;
    id: string | undefined;
}

export class PosmProductionTaskInput implements IPosmProductionTaskInput {
    id: string | undefined;
    ilgiliFirma: string | undefined;
    sorumluPersonel: string | undefined;
    lansmanAdi: string | undefined;
    marka: string | undefined;
    posmAdi: string | undefined;
    posmTakipKodu: string | undefined;
    akisFormKodu: string | undefined;
    gorevTakipKodu: string | undefined;
    gorevAtanmaTarihi: moment.Moment | undefined;
    gorevBitisTarihi: moment.Moment | undefined;
    gorevinTamamlanmaTarihi: moment.Moment | undefined;
    durum: number | undefined;
    gorevDetayAciklama: string | undefined;
    gorevAciklama: string | undefined;
    revizeAciklamasi: string | undefined;
    revizeTalebiAciklamalari: RevizeTalebiAciklama[] | undefined;
    userData: UserData | undefined;

    constructor(data?: IPosmProductionTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ilgiliFirma = _data["ilgiliFirma"];
            this.sorumluPersonel = _data["sorumluPersonel"];
            this.lansmanAdi = _data["lansmanAdi"];
            this.marka = _data["marka"];
            this.posmAdi = _data["posmAdi"];
            this.posmTakipKodu = _data["posmTakipKodu"];
            this.akisFormKodu = _data["akisFormKodu"];
            this.gorevTakipKodu = _data["gorevTakipKodu"];
            this.gorevAtanmaTarihi = _data["gorevAtanmaTarihi"] ? moment(_data["gorevAtanmaTarihi"].toString()) : <any>undefined;
            this.gorevBitisTarihi = _data["gorevBitisTarihi"] ? moment(_data["gorevBitisTarihi"].toString()) : <any>undefined;
            this.gorevinTamamlanmaTarihi = _data["gorevinTamamlanmaTarihi"] ? moment(_data["gorevinTamamlanmaTarihi"].toString()) : <any>undefined;
            this.durum = _data["durum"];
            this.gorevDetayAciklama = _data["gorevDetayAciklama"];
            this.gorevAciklama = _data["gorevAciklama"];
            this.revizeAciklamasi = _data["revizeAciklamasi"];
            if (Array.isArray(_data["revizeTalebiAciklamalari"])) {
                this.revizeTalebiAciklamalari = [] as any;
                for (let item of _data["revizeTalebiAciklamalari"])
                    this.revizeTalebiAciklamalari.push(RevizeTalebiAciklama.fromJS(item));
            }
            this.userData = _data["userData"] ? UserData.fromJS(_data["userData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PosmProductionTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ilgiliFirma"] = this.ilgiliFirma;
        data["sorumluPersonel"] = this.sorumluPersonel;
        data["lansmanAdi"] = this.lansmanAdi;
        data["marka"] = this.marka;
        data["posmAdi"] = this.posmAdi;
        data["posmTakipKodu"] = this.posmTakipKodu;
        data["akisFormKodu"] = this.akisFormKodu;
        data["gorevTakipKodu"] = this.gorevTakipKodu;
        data["gorevAtanmaTarihi"] = this.gorevAtanmaTarihi ? this.gorevAtanmaTarihi.toISOString() : <any>undefined;
        data["gorevBitisTarihi"] = this.gorevBitisTarihi ? this.gorevBitisTarihi.toISOString() : <any>undefined;
        data["gorevinTamamlanmaTarihi"] = this.gorevinTamamlanmaTarihi ? this.gorevinTamamlanmaTarihi.toISOString() : <any>undefined;
        data["durum"] = this.durum;
        data["gorevDetayAciklama"] = this.gorevDetayAciklama;
        data["gorevAciklama"] = this.gorevAciklama;
        data["revizeAciklamasi"] = this.revizeAciklamasi;
        if (Array.isArray(this.revizeTalebiAciklamalari)) {
            data["revizeTalebiAciklamalari"] = [];
            for (let item of this.revizeTalebiAciklamalari)
                data["revizeTalebiAciklamalari"].push(item.toJSON());
        }
        data["userData"] = this.userData ? this.userData.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PosmProductionTaskInput {
        const json = this.toJSON();
        let result = new PosmProductionTaskInput();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionTaskInput {
    id: string | undefined;
    ilgiliFirma: string | undefined;
    sorumluPersonel: string | undefined;
    lansmanAdi: string | undefined;
    marka: string | undefined;
    posmAdi: string | undefined;
    posmTakipKodu: string | undefined;
    akisFormKodu: string | undefined;
    gorevTakipKodu: string | undefined;
    gorevAtanmaTarihi: moment.Moment | undefined;
    gorevBitisTarihi: moment.Moment | undefined;
    gorevinTamamlanmaTarihi: moment.Moment | undefined;
    durum: number | undefined;
    gorevDetayAciklama: string | undefined;
    gorevAciklama: string | undefined;
    revizeAciklamasi: string | undefined;
    revizeTalebiAciklamalari: RevizeTalebiAciklama[] | undefined;
    userData: UserData | undefined;
}

export class RevizeTalebiAciklama implements IRevizeTalebiAciklama {
    talebiYapanAdSoyad: string | undefined;
    aciklma: string | undefined;

    constructor(data?: IRevizeTalebiAciklama) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.talebiYapanAdSoyad = _data["talebiYapanAdSoyad"];
            this.aciklma = _data["aciklma"];
        }
    }

    static fromJS(data: any): RevizeTalebiAciklama {
        data = typeof data === 'object' ? data : {};
        let result = new RevizeTalebiAciklama();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["talebiYapanAdSoyad"] = this.talebiYapanAdSoyad;
        data["aciklma"] = this.aciklma;
        return data; 
    }

    clone(): RevizeTalebiAciklama {
        const json = this.toJSON();
        let result = new RevizeTalebiAciklama();
        result.init(json);
        return result;
    }
}

export interface IRevizeTalebiAciklama {
    talebiYapanAdSoyad: string | undefined;
    aciklma: string | undefined;
}

export class UserData implements IUserData {
    girilenAciklama: string | undefined;
    uretimMiktari: number | undefined;
    gorselTasarimUrl: string | undefined;
    uretimButcesi: UretimButcesi[] | undefined;
    ureticiPlanlanaTeslim: UreticiTeslimTarih | undefined;
    depoTeslimBilgisi: DepoTeslimBilgi | undefined;
    sahaDagilimPlani: SahaDagilimPlani[] | undefined;

    constructor(data?: IUserData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.girilenAciklama = _data["girilenAciklama"];
            this.uretimMiktari = _data["uretimMiktari"];
            this.gorselTasarimUrl = _data["gorselTasarimUrl"];
            if (Array.isArray(_data["uretimButcesi"])) {
                this.uretimButcesi = [] as any;
                for (let item of _data["uretimButcesi"])
                    this.uretimButcesi.push(UretimButcesi.fromJS(item));
            }
            this.ureticiPlanlanaTeslim = _data["ureticiPlanlanaTeslim"] ? UreticiTeslimTarih.fromJS(_data["ureticiPlanlanaTeslim"]) : <any>undefined;
            this.depoTeslimBilgisi = _data["depoTeslimBilgisi"] ? DepoTeslimBilgi.fromJS(_data["depoTeslimBilgisi"]) : <any>undefined;
            if (Array.isArray(_data["sahaDagilimPlani"])) {
                this.sahaDagilimPlani = [] as any;
                for (let item of _data["sahaDagilimPlani"])
                    this.sahaDagilimPlani.push(SahaDagilimPlani.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserData {
        data = typeof data === 'object' ? data : {};
        let result = new UserData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["girilenAciklama"] = this.girilenAciklama;
        data["uretimMiktari"] = this.uretimMiktari;
        data["gorselTasarimUrl"] = this.gorselTasarimUrl;
        if (Array.isArray(this.uretimButcesi)) {
            data["uretimButcesi"] = [];
            for (let item of this.uretimButcesi)
                data["uretimButcesi"].push(item.toJSON());
        }
        data["ureticiPlanlanaTeslim"] = this.ureticiPlanlanaTeslim ? this.ureticiPlanlanaTeslim.toJSON() : <any>undefined;
        data["depoTeslimBilgisi"] = this.depoTeslimBilgisi ? this.depoTeslimBilgisi.toJSON() : <any>undefined;
        if (Array.isArray(this.sahaDagilimPlani)) {
            data["sahaDagilimPlani"] = [];
            for (let item of this.sahaDagilimPlani)
                data["sahaDagilimPlani"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserData {
        const json = this.toJSON();
        let result = new UserData();
        result.init(json);
        return result;
    }
}

export interface IUserData {
    girilenAciklama: string | undefined;
    uretimMiktari: number | undefined;
    gorselTasarimUrl: string | undefined;
    uretimButcesi: UretimButcesi[] | undefined;
    ureticiPlanlanaTeslim: UreticiTeslimTarih | undefined;
    depoTeslimBilgisi: DepoTeslimBilgi | undefined;
    sahaDagilimPlani: SahaDagilimPlani[] | undefined;
}

export class UretimButcesi implements IUretimButcesi {
    butceAdi: string | undefined;
    tutar: number | undefined;

    constructor(data?: IUretimButcesi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.butceAdi = _data["butceAdi"];
            this.tutar = _data["tutar"];
        }
    }

    static fromJS(data: any): UretimButcesi {
        data = typeof data === 'object' ? data : {};
        let result = new UretimButcesi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["butceAdi"] = this.butceAdi;
        data["tutar"] = this.tutar;
        return data; 
    }

    clone(): UretimButcesi {
        const json = this.toJSON();
        let result = new UretimButcesi();
        result.init(json);
        return result;
    }
}

export interface IUretimButcesi {
    butceAdi: string | undefined;
    tutar: number | undefined;
}

export class UreticiTeslimTarih implements IUreticiTeslimTarih {
    depoTeslim: moment.Moment | undefined;
    numuneTeslim: moment.Moment | undefined;

    constructor(data?: IUreticiTeslimTarih) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depoTeslim = _data["depoTeslim"] ? moment(_data["depoTeslim"].toString()) : <any>undefined;
            this.numuneTeslim = _data["numuneTeslim"] ? moment(_data["numuneTeslim"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UreticiTeslimTarih {
        data = typeof data === 'object' ? data : {};
        let result = new UreticiTeslimTarih();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depoTeslim"] = this.depoTeslim ? this.depoTeslim.toISOString() : <any>undefined;
        data["numuneTeslim"] = this.numuneTeslim ? this.numuneTeslim.toISOString() : <any>undefined;
        return data; 
    }

    clone(): UreticiTeslimTarih {
        const json = this.toJSON();
        let result = new UreticiTeslimTarih();
        result.init(json);
        return result;
    }
}

export interface IUreticiTeslimTarih {
    depoTeslim: moment.Moment | undefined;
    numuneTeslim: moment.Moment | undefined;
}

export class DepoTeslimBilgi implements IDepoTeslimBilgi {
    irsaliyeNo: string | undefined;
    adet: number | undefined;
    teslimTarihi: moment.Moment | undefined;

    constructor(data?: IDepoTeslimBilgi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.irsaliyeNo = _data["irsaliyeNo"];
            this.adet = _data["adet"];
            this.teslimTarihi = _data["teslimTarihi"] ? moment(_data["teslimTarihi"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DepoTeslimBilgi {
        data = typeof data === 'object' ? data : {};
        let result = new DepoTeslimBilgi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["irsaliyeNo"] = this.irsaliyeNo;
        data["adet"] = this.adet;
        data["teslimTarihi"] = this.teslimTarihi ? this.teslimTarihi.toISOString() : <any>undefined;
        return data; 
    }

    clone(): DepoTeslimBilgi {
        const json = this.toJSON();
        let result = new DepoTeslimBilgi();
        result.init(json);
        return result;
    }
}

export interface IDepoTeslimBilgi {
    irsaliyeNo: string | undefined;
    adet: number | undefined;
    teslimTarihi: moment.Moment | undefined;
}

export class SahaDagilimPlani implements ISahaDagilimPlani {
    kanal: string | undefined;
    planlananTeslimTarihi: moment.Moment | undefined;

    constructor(data?: ISahaDagilimPlani) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kanal = _data["kanal"];
            this.planlananTeslimTarihi = _data["planlananTeslimTarihi"] ? moment(_data["planlananTeslimTarihi"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SahaDagilimPlani {
        data = typeof data === 'object' ? data : {};
        let result = new SahaDagilimPlani();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kanal"] = this.kanal;
        data["planlananTeslimTarihi"] = this.planlananTeslimTarihi ? this.planlananTeslimTarihi.toISOString() : <any>undefined;
        return data; 
    }

    clone(): SahaDagilimPlani {
        const json = this.toJSON();
        let result = new SahaDagilimPlani();
        result.init(json);
        return result;
    }
}

export interface ISahaDagilimPlani {
    kanal: string | undefined;
    planlananTeslimTarihi: moment.Moment | undefined;
}

export class CreatePosmDto implements ICreatePosmDto {
    name: string | undefined;
    lansmanId: string | undefined;
    markaId: string | undefined;
    markaDiger1Id: string | undefined;
    markaDiger2Id: string | undefined;
    posmTipId: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    tasarimciFirmaId: string | undefined;
    ureticiFirmaId: string | undefined;
    sahaEkibiFirmaId: string | undefined;
    lojistikFirmaId: string | undefined;
    id: string | undefined;

    constructor(data?: ICreatePosmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.lansmanId = _data["lansmanId"];
            this.markaId = _data["markaId"];
            this.markaDiger1Id = _data["markaDiger1Id"];
            this.markaDiger2Id = _data["markaDiger2Id"];
            this.posmTipId = _data["posmTipId"];
            this.butcePuani = _data["butcePuani"];
            this.isNumuneKullanimi = _data["isNumuneKullanimi"];
            this.tasarimciFirmaId = _data["tasarimciFirmaId"];
            this.ureticiFirmaId = _data["ureticiFirmaId"];
            this.sahaEkibiFirmaId = _data["sahaEkibiFirmaId"];
            this.lojistikFirmaId = _data["lojistikFirmaId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatePosmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePosmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lansmanId"] = this.lansmanId;
        data["markaId"] = this.markaId;
        data["markaDiger1Id"] = this.markaDiger1Id;
        data["markaDiger2Id"] = this.markaDiger2Id;
        data["posmTipId"] = this.posmTipId;
        data["butcePuani"] = this.butcePuani;
        data["isNumuneKullanimi"] = this.isNumuneKullanimi;
        data["tasarimciFirmaId"] = this.tasarimciFirmaId;
        data["ureticiFirmaId"] = this.ureticiFirmaId;
        data["sahaEkibiFirmaId"] = this.sahaEkibiFirmaId;
        data["lojistikFirmaId"] = this.lojistikFirmaId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreatePosmDto {
        const json = this.toJSON();
        let result = new CreatePosmDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePosmDto {
    name: string | undefined;
    lansmanId: string | undefined;
    markaId: string | undefined;
    markaDiger1Id: string | undefined;
    markaDiger2Id: string | undefined;
    posmTipId: string | undefined;
    butcePuani: number | undefined;
    isNumuneKullanimi: boolean | undefined;
    tasarimciFirmaId: string | undefined;
    ureticiFirmaId: string | undefined;
    sahaEkibiFirmaId: string | undefined;
    lojistikFirmaId: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfPosmProductionDemandDto implements IPagedResultDtoOfPosmProductionDemandDto {
    totalCount: number | undefined;
    items: PosmProductionDemandDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPosmProductionDemandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PosmProductionDemandDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPosmProductionDemandDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPosmProductionDemandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfPosmProductionDemandDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPosmProductionDemandDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPosmProductionDemandDto {
    totalCount: number | undefined;
    items: PosmProductionDemandDto[] | undefined;
}

export class PosmProductionDemandDto implements IPosmProductionDemandDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    customerId: number | undefined;
    estimatedProductionDate: moment.Moment | undefined;
    amount: number | undefined;
    supplierAddressId: number | undefined;
    supplierName: string | undefined;
    supplierAddress: string | undefined;
    id: number | undefined;

    constructor(data?: IPosmProductionDemandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.productCode = _data["productCode"];
            this.customerId = _data["customerId"];
            this.estimatedProductionDate = _data["estimatedProductionDate"] ? moment(_data["estimatedProductionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.supplierAddressId = _data["supplierAddressId"];
            this.supplierName = _data["supplierName"];
            this.supplierAddress = _data["supplierAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PosmProductionDemandDto {
        data = typeof data === 'object' ? data : {};
        let result = new PosmProductionDemandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["productCode"] = this.productCode;
        data["customerId"] = this.customerId;
        data["estimatedProductionDate"] = this.estimatedProductionDate ? this.estimatedProductionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["supplierAddressId"] = this.supplierAddressId;
        data["supplierName"] = this.supplierName;
        data["supplierAddress"] = this.supplierAddress;
        data["id"] = this.id;
        return data; 
    }

    clone(): PosmProductionDemandDto {
        const json = this.toJSON();
        let result = new PosmProductionDemandDto();
        result.init(json);
        return result;
    }
}

export interface IPosmProductionDemandDto {
    productId: number | undefined;
    productName: string | undefined;
    productCode: string | undefined;
    customerId: number | undefined;
    estimatedProductionDate: moment.Moment | undefined;
    amount: number | undefined;
    supplierAddressId: number | undefined;
    supplierName: string | undefined;
    supplierAddress: string | undefined;
    id: number | undefined;
}

export class CreatePosmProductionDemandDto implements ICreatePosmProductionDemandDto {
    name: string | undefined;
    productId: number;
    customerId: number | undefined;
    estimatedProductionDate: moment.Moment;
    amount: number;
    supplierAddressId: number;
    comment: string | undefined;

    constructor(data?: ICreatePosmProductionDemandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.productId = _data["productId"];
            this.customerId = _data["customerId"];
            this.estimatedProductionDate = _data["estimatedProductionDate"] ? moment(_data["estimatedProductionDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.supplierAddressId = _data["supplierAddressId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreatePosmProductionDemandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePosmProductionDemandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productId"] = this.productId;
        data["customerId"] = this.customerId;
        data["estimatedProductionDate"] = this.estimatedProductionDate ? this.estimatedProductionDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["supplierAddressId"] = this.supplierAddressId;
        data["comment"] = this.comment;
        return data; 
    }

    clone(): CreatePosmProductionDemandDto {
        const json = this.toJSON();
        let result = new CreatePosmProductionDemandDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePosmProductionDemandDto {
    name: string | undefined;
    productId: number;
    customerId: number | undefined;
    estimatedProductionDate: moment.Moment;
    amount: number;
    supplierAddressId: number;
    comment: string | undefined;
}

export class PopRequestExcelUploadDto implements IPopRequestExcelUploadDto {
    base64: string | undefined;

    constructor(data?: IPopRequestExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): PopRequestExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new PopRequestExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data; 
    }

    clone(): PopRequestExcelUploadDto {
        const json = this.toJSON();
        let result = new PopRequestExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface IPopRequestExcelUploadDto {
    base64: string | undefined;
}

export class UserButceDto implements IUserButceDto {
    userId: string | undefined;
    userButceId: string | undefined;
    userUnvanId: string | undefined;
    name: string | undefined;
    butce: number | undefined;
    kalanButce: number | undefined;
    kullanilanButce: number | undefined;

    constructor(data?: IUserButceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userButceId = _data["userButceId"];
            this.userUnvanId = _data["userUnvanId"];
            this.name = _data["name"];
            this.butce = _data["butce"];
            this.kalanButce = _data["kalanButce"];
            this.kullanilanButce = _data["kullanilanButce"];
        }
    }

    static fromJS(data: any): UserButceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserButceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userButceId"] = this.userButceId;
        data["userUnvanId"] = this.userUnvanId;
        data["name"] = this.name;
        data["butce"] = this.butce;
        data["kalanButce"] = this.kalanButce;
        data["kullanilanButce"] = this.kullanilanButce;
        return data; 
    }

    clone(): UserButceDto {
        const json = this.toJSON();
        let result = new UserButceDto();
        result.init(json);
        return result;
    }
}

export interface IUserButceDto {
    userId: string | undefined;
    userButceId: string | undefined;
    userUnvanId: string | undefined;
    name: string | undefined;
    butce: number | undefined;
    kalanButce: number | undefined;
    kullanilanButce: number | undefined;
}

export class UserAssignButceDto implements IUserAssignButceDto {
    userId: string | undefined;
    userUnvanId: string | undefined;
    userButceId: string | undefined;
    butce: number | undefined;

    constructor(data?: IUserAssignButceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userUnvanId = _data["userUnvanId"];
            this.userButceId = _data["userButceId"];
            this.butce = _data["butce"];
        }
    }

    static fromJS(data: any): UserAssignButceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAssignButceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userUnvanId"] = this.userUnvanId;
        data["userButceId"] = this.userButceId;
        data["butce"] = this.butce;
        return data; 
    }

    clone(): UserAssignButceDto {
        const json = this.toJSON();
        let result = new UserAssignButceDto();
        result.init(json);
        return result;
    }
}

export interface IUserAssignButceDto {
    userId: string | undefined;
    userUnvanId: string | undefined;
    userButceId: string | undefined;
    butce: number | undefined;
}

export class SRProcessTrackingDto implements ISRProcessTrackingDto {
    rowGuid: string | undefined;
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    errorMessage: string | undefined;
    readonly startDateText: string | undefined;
    readonly endDateText: string | undefined;
    readonly hasError: boolean | undefined;
    errorHasFile: boolean | undefined;
    readonly status: SRProcessTrackingDtoStatus | undefined;
    isVisibleShapeButton: boolean | undefined;
    id: number | undefined;

    constructor(data?: ISRProcessTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowGuid = _data["rowGuid"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.errorMessage = _data["errorMessage"];
            (<any>this).startDateText = _data["startDateText"];
            (<any>this).endDateText = _data["endDateText"];
            (<any>this).hasError = _data["hasError"];
            this.errorHasFile = _data["errorHasFile"];
            (<any>this).status = _data["status"];
            this.isVisibleShapeButton = _data["isVisibleShapeButton"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SRProcessTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRProcessTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowGuid"] = this.rowGuid;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["errorMessage"] = this.errorMessage;
        data["startDateText"] = this.startDateText;
        data["endDateText"] = this.endDateText;
        data["hasError"] = this.hasError;
        data["errorHasFile"] = this.errorHasFile;
        data["status"] = this.status;
        data["isVisibleShapeButton"] = this.isVisibleShapeButton;
        data["id"] = this.id;
        return data; 
    }

    clone(): SRProcessTrackingDto {
        const json = this.toJSON();
        let result = new SRProcessTrackingDto();
        result.init(json);
        return result;
    }
}

export interface ISRProcessTrackingDto {
    rowGuid: string | undefined;
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    errorMessage: string | undefined;
    startDateText: string | undefined;
    endDateText: string | undefined;
    hasError: boolean | undefined;
    errorHasFile: boolean | undefined;
    status: SRProcessTrackingDtoStatus | undefined;
    isVisibleShapeButton: boolean | undefined;
    id: number | undefined;
}

export class OptimumBasicRouteShapeDto implements IOptimumBasicRouteShapeDto {
    shapes: Coordinate[] | undefined;
    locations: SRRouteOptimumBasicUploadDto[] | undefined;
    startLocation: Coordinate | undefined;

    constructor(data?: IOptimumBasicRouteShapeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shapes"])) {
                this.shapes = [] as any;
                for (let item of _data["shapes"])
                    this.shapes.push(Coordinate.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(SRRouteOptimumBasicUploadDto.fromJS(item));
            }
            this.startLocation = _data["startLocation"] ? Coordinate.fromJS(_data["startLocation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OptimumBasicRouteShapeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OptimumBasicRouteShapeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shapes)) {
            data["shapes"] = [];
            for (let item of this.shapes)
                data["shapes"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        data["startLocation"] = this.startLocation ? this.startLocation.toJSON() : <any>undefined;
        return data; 
    }

    clone(): OptimumBasicRouteShapeDto {
        const json = this.toJSON();
        let result = new OptimumBasicRouteShapeDto();
        result.init(json);
        return result;
    }
}

export interface IOptimumBasicRouteShapeDto {
    shapes: Coordinate[] | undefined;
    locations: SRRouteOptimumBasicUploadDto[] | undefined;
    startLocation: Coordinate | undefined;
}

export class Coordinate implements ICoordinate {
    latitude: number | undefined;
    longitude: number | undefined;
    elevation: number | undefined;
    readonly valid: boolean | undefined;

    constructor(data?: ICoordinate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.elevation = _data["elevation"];
            (<any>this).valid = _data["valid"];
        }
    }

    static fromJS(data: any): Coordinate {
        data = typeof data === 'object' ? data : {};
        let result = new Coordinate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["elevation"] = this.elevation;
        data["valid"] = this.valid;
        return data; 
    }

    clone(): Coordinate {
        const json = this.toJSON();
        let result = new Coordinate();
        result.init(json);
        return result;
    }
}

export interface ICoordinate {
    latitude: number | undefined;
    longitude: number | undefined;
    elevation: number | undefined;
    valid: boolean | undefined;
}

export class SRRouteOptimumBasicUploadDto implements ISRRouteOptimumBasicUploadDto {
    name: string | undefined;
    rowCount: number | undefined;
    hasExcelCellError: boolean | undefined;
    sortIndex: number | undefined;
    resultIndex: number | undefined;
    isIncludedInProcess: boolean | undefined;
    timeToPrevStop: number | undefined;
    distanceToPrevStop: number | undefined;
    shape: number | undefined;
    lat: number | undefined;
    lng: number | undefined;

    constructor(data?: ISRRouteOptimumBasicUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rowCount = _data["rowCount"];
            this.hasExcelCellError = _data["hasExcelCellError"];
            this.sortIndex = _data["sortIndex"];
            this.resultIndex = _data["resultIndex"];
            this.isIncludedInProcess = _data["isIncludedInProcess"];
            this.timeToPrevStop = _data["timeToPrevStop"];
            this.distanceToPrevStop = _data["distanceToPrevStop"];
            this.shape = _data["shape"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): SRRouteOptimumBasicUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRRouteOptimumBasicUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rowCount"] = this.rowCount;
        data["hasExcelCellError"] = this.hasExcelCellError;
        data["sortIndex"] = this.sortIndex;
        data["resultIndex"] = this.resultIndex;
        data["isIncludedInProcess"] = this.isIncludedInProcess;
        data["timeToPrevStop"] = this.timeToPrevStop;
        data["distanceToPrevStop"] = this.distanceToPrevStop;
        data["shape"] = this.shape;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data; 
    }

    clone(): SRRouteOptimumBasicUploadDto {
        const json = this.toJSON();
        let result = new SRRouteOptimumBasicUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRRouteOptimumBasicUploadDto {
    name: string | undefined;
    rowCount: number | undefined;
    hasExcelCellError: boolean | undefined;
    sortIndex: number | undefined;
    resultIndex: number | undefined;
    isIncludedInProcess: boolean | undefined;
    timeToPrevStop: number | undefined;
    distanceToPrevStop: number | undefined;
    shape: number | undefined;
    lat: number | undefined;
    lng: number | undefined;
}

export class CreateProductDto implements ICreateProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    stok: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kod = _data["kod"];
            this.wmsTip = _data["wmsTip"];
            this.stok = _data["stok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kod"] = this.kod;
        data["wmsTip"] = this.wmsTip;
        data["stok"] = this.stok;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateProductDto {
        const json = this.toJSON();
        let result = new CreateProductDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProductDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    stok: number | undefined;
    id: number | undefined;
}

export class ExcelPagedResultDtoOfProductExcelDto implements IExcelPagedResultDtoOfProductExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: ProductExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfProductExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfProductExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfProductExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ExcelPagedResultDtoOfProductExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfProductExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfProductExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: ProductExcelDto[] | undefined;
}

export class ProductExcelDto implements IProductExcelDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    id: number | undefined;

    constructor(data?: IProductExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.kod = _data["kod"];
            this.wmsTip = _data["wmsTip"];
            this.marka = _data["marka"];
            this.stok = _data["stok"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["kod"] = this.kod;
        data["wmsTip"] = this.wmsTip;
        data["marka"] = this.marka;
        data["stok"] = this.stok;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProductExcelDto {
        const json = this.toJSON();
        let result = new ProductExcelDto();
        result.init(json);
        return result;
    }
}

export interface IProductExcelDto {
    name: string | undefined;
    kod: string | undefined;
    wmsTip: string | undefined;
    marka: string | undefined;
    stok: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfProductDto implements IPagedResultDtoOfProductDto {
    totalCount: number | undefined;
    items: ProductDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfProductDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductDto {
    totalCount: number | undefined;
    items: ProductDto[] | undefined;
}

export class ProductDomainWarehouseInput implements IProductDomainWarehouseInput {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;

    constructor(data?: IProductDomainWarehouseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ProductDomainWarehouseInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDomainWarehouseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data; 
    }

    clone(): ProductDomainWarehouseInput {
        const json = this.toJSON();
        let result = new ProductDomainWarehouseInput();
        result.init(json);
        return result;
    }
}

export interface IProductDomainWarehouseInput {
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
}

export class ProductStockExcelDto implements IProductStockExcelDto {
    readonly photoPath: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;

    constructor(data?: IProductStockExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).photoPath = _data["photoPath"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.businessUnitName = _data["businessUnitName"];
            this.brandName = _data["brandName"];
            this.campaignName = _data["campaignName"];
            this.warehouseName = _data["warehouseName"];
            this.stock = _data["stock"];
            this.blockedStock = _data["blockedStock"];
            this.type = _data["type"];
            this.type1Name = _data["type1Name"];
            this.type2Name = _data["type2Name"];
            this.type3Name = _data["type3Name"];
            this.type4Name = _data["type4Name"];
            this.group1Name = _data["group1Name"];
            this.group2Name = _data["group2Name"];
            this.merkezOnayliStok = _data["merkezOnayliStok"];
            this.onaySureciDevamEdenStok = _data["onaySureciDevamEdenStok"];
        }
    }

    static fromJS(data: any): ProductStockExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStockExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoPath"] = this.photoPath;
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["businessUnitName"] = this.businessUnitName;
        data["brandName"] = this.brandName;
        data["campaignName"] = this.campaignName;
        data["warehouseName"] = this.warehouseName;
        data["stock"] = this.stock;
        data["blockedStock"] = this.blockedStock;
        data["type"] = this.type;
        data["type1Name"] = this.type1Name;
        data["type2Name"] = this.type2Name;
        data["type3Name"] = this.type3Name;
        data["type4Name"] = this.type4Name;
        data["group1Name"] = this.group1Name;
        data["group2Name"] = this.group2Name;
        data["merkezOnayliStok"] = this.merkezOnayliStok;
        data["onaySureciDevamEdenStok"] = this.onaySureciDevamEdenStok;
        return data; 
    }

    clone(): ProductStockExcelDto {
        const json = this.toJSON();
        let result = new ProductStockExcelDto();
        result.init(json);
        return result;
    }
}

export interface IProductStockExcelDto {
    photoPath: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;
}

export class ProductVariationStocksOutputDto implements IProductVariationStocksOutputDto {
    noVariationTotalStock: number | undefined;
    products: ProductDto[] | undefined;

    constructor(data?: IProductVariationStocksOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noVariationTotalStock = _data["noVariationTotalStock"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(ProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductVariationStocksOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductVariationStocksOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noVariationTotalStock"] = this.noVariationTotalStock;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ProductVariationStocksOutputDto {
        const json = this.toJSON();
        let result = new ProductVariationStocksOutputDto();
        result.init(json);
        return result;
    }
}

export interface IProductVariationStocksOutputDto {
    noVariationTotalStock: number | undefined;
    products: ProductDto[] | undefined;
}

export class ProductDetailsDto implements IProductDetailsDto {
    product: ProductDto | undefined;
    warehouseStocks: ProductDetailsWarehouseStockDto[] | undefined;

    constructor(data?: IProductDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? ProductDto.fromJS(_data["product"]) : <any>undefined;
            if (Array.isArray(_data["warehouseStocks"])) {
                this.warehouseStocks = [] as any;
                for (let item of _data["warehouseStocks"])
                    this.warehouseStocks.push(ProductDetailsWarehouseStockDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        if (Array.isArray(this.warehouseStocks)) {
            data["warehouseStocks"] = [];
            for (let item of this.warehouseStocks)
                data["warehouseStocks"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ProductDetailsDto {
        const json = this.toJSON();
        let result = new ProductDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IProductDetailsDto {
    product: ProductDto | undefined;
    warehouseStocks: ProductDetailsWarehouseStockDto[] | undefined;
}

export class ProductDetailsWarehouseStockDto implements IProductDetailsWarehouseStockDto {
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    totalStock: number | undefined;

    constructor(data?: IProductDetailsWarehouseStockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseCode = _data["warehouseCode"];
            this.warehouseName = _data["warehouseName"];
            this.totalStock = _data["totalStock"];
        }
    }

    static fromJS(data: any): ProductDetailsWarehouseStockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDetailsWarehouseStockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseCode"] = this.warehouseCode;
        data["warehouseName"] = this.warehouseName;
        data["totalStock"] = this.totalStock;
        return data; 
    }

    clone(): ProductDetailsWarehouseStockDto {
        const json = this.toJSON();
        let result = new ProductDetailsWarehouseStockDto();
        result.init(json);
        return result;
    }
}

export interface IProductDetailsWarehouseStockDto {
    warehouseCode: string | undefined;
    warehouseName: string | undefined;
    totalStock: number | undefined;
}

export class ProductDomainUserOrderDto implements IProductDomainUserOrderDto {
    qty: number | undefined;
    userId: number | undefined;
    userName: string | undefined;
    productId: number | undefined;

    constructor(data?: IProductDomainUserOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qty = _data["qty"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductDomainUserOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDomainUserOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qty"] = this.qty;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["productId"] = this.productId;
        return data; 
    }

    clone(): ProductDomainUserOrderDto {
        const json = this.toJSON();
        let result = new ProductDomainUserOrderDto();
        result.init(json);
        return result;
    }
}

export interface IProductDomainUserOrderDto {
    qty: number | undefined;
    userId: number | undefined;
    userName: string | undefined;
    productId: number | undefined;
}

export class ProductDomainAddressOrderDto implements IProductDomainAddressOrderDto {
    qty: number | undefined;
    addressId: number | undefined;
    addressName: string | undefined;
    productId: number | undefined;

    constructor(data?: IProductDomainAddressOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qty = _data["qty"];
            this.addressId = _data["addressId"];
            this.addressName = _data["addressName"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductDomainAddressOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDomainAddressOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qty"] = this.qty;
        data["addressId"] = this.addressId;
        data["addressName"] = this.addressName;
        data["productId"] = this.productId;
        return data; 
    }

    clone(): ProductDomainAddressOrderDto {
        const json = this.toJSON();
        let result = new ProductDomainAddressOrderDto();
        result.init(json);
        return result;
    }
}

export interface IProductDomainAddressOrderDto {
    qty: number | undefined;
    addressId: number | undefined;
    addressName: string | undefined;
    productId: number | undefined;
}

export class PagedResultDtoOfProductAttributeDto implements IPagedResultDtoOfProductAttributeDto {
    totalCount: number | undefined;
    items: ProductAttributeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductAttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfProductAttributeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductAttributeDto {
    totalCount: number | undefined;
    items: ProductAttributeDto[] | undefined;
}

export class ProductAttributeDto implements IProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    id: number | undefined;

    constructor(data?: IProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attributeType = _data["attributeType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attributeType"] = this.attributeType;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProductAttributeDto {
        const json = this.toJSON();
        let result = new ProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    id: number | undefined;
}

export class CreateProductAttributeDto implements ICreateProductAttributeDto {
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateProductAttributeDto {
        const json = this.toJSON();
        let result = new CreateProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProductAttributeDto {
    name: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfProductDamageStatusDto implements IPagedResultDtoOfProductDamageStatusDto {
    totalCount: number | undefined;
    items: ProductDamageStatusDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProductDamageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDamageStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProductDamageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProductDamageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfProductDamageStatusDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProductDamageStatusDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProductDamageStatusDto {
    totalCount: number | undefined;
    items: ProductDamageStatusDto[] | undefined;
}

export class ProductDamageStatusDto implements IProductDamageStatusDto {
    name: string | undefined;
    localizationKey: string | undefined;
    id: number | undefined;

    constructor(data?: IProductDamageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.localizationKey = _data["localizationKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProductDamageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDamageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["localizationKey"] = this.localizationKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProductDamageStatusDto {
        const json = this.toJSON();
        let result = new ProductDamageStatusDto();
        result.init(json);
        return result;
    }
}

export interface IProductDamageStatusDto {
    name: string | undefined;
    localizationKey: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfRegionDto implements IPagedResultDtoOfRegionDto {
    totalCount: number | undefined;
    items: RegionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RegionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRegionDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRegionDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRegionDto {
    totalCount: number | undefined;
    items: RegionDto[] | undefined;
}

export class RegionDto implements IRegionDto {
    name: string | undefined;
    boundaryLats: string | undefined;
    boundaryLngs: string | undefined;
    startLat: number | undefined;
    startLng: number | undefined;
    startWork: string | undefined;
    endWork: string | undefined;
    startLaunchBreak: string | undefined;
    endLaunchBreak: string | undefined;
    id: number | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.boundaryLats = _data["boundaryLats"];
            this.boundaryLngs = _data["boundaryLngs"];
            this.startLat = _data["startLat"];
            this.startLng = _data["startLng"];
            this.startWork = _data["startWork"];
            this.endWork = _data["endWork"];
            this.startLaunchBreak = _data["startLaunchBreak"];
            this.endLaunchBreak = _data["endLaunchBreak"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["boundaryLats"] = this.boundaryLats;
        data["boundaryLngs"] = this.boundaryLngs;
        data["startLat"] = this.startLat;
        data["startLng"] = this.startLng;
        data["startWork"] = this.startWork;
        data["endWork"] = this.endWork;
        data["startLaunchBreak"] = this.startLaunchBreak;
        data["endLaunchBreak"] = this.endLaunchBreak;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegionDto {
        const json = this.toJSON();
        let result = new RegionDto();
        result.init(json);
        return result;
    }
}

export interface IRegionDto {
    name: string | undefined;
    boundaryLats: string | undefined;
    boundaryLngs: string | undefined;
    startLat: number | undefined;
    startLng: number | undefined;
    startWork: string | undefined;
    endWork: string | undefined;
    startLaunchBreak: string | undefined;
    endLaunchBreak: string | undefined;
    id: number | undefined;
}

export class CreateRegionDto implements ICreateRegionDto {
    name: string | undefined;
    boundaryLats: string | undefined;
    boundaryLngs: string | undefined;
    startLat: number | undefined;
    startLng: number | undefined;
    startWork: string | undefined;
    endWork: string | undefined;
    startLaunchBreak: string | undefined;
    endLaunchBreak: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.boundaryLats = _data["boundaryLats"];
            this.boundaryLngs = _data["boundaryLngs"];
            this.startLat = _data["startLat"];
            this.startLng = _data["startLng"];
            this.startWork = _data["startWork"];
            this.endWork = _data["endWork"];
            this.startLaunchBreak = _data["startLaunchBreak"];
            this.endLaunchBreak = _data["endLaunchBreak"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["boundaryLats"] = this.boundaryLats;
        data["boundaryLngs"] = this.boundaryLngs;
        data["startLat"] = this.startLat;
        data["startLng"] = this.startLng;
        data["startWork"] = this.startWork;
        data["endWork"] = this.endWork;
        data["startLaunchBreak"] = this.startLaunchBreak;
        data["endLaunchBreak"] = this.endLaunchBreak;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateRegionDto {
        const json = this.toJSON();
        let result = new CreateRegionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRegionDto {
    name: string | undefined;
    boundaryLats: string | undefined;
    boundaryLngs: string | undefined;
    startLat: number | undefined;
    startLng: number | undefined;
    startWork: string | undefined;
    endWork: string | undefined;
    startLaunchBreak: string | undefined;
    endLaunchBreak: string | undefined;
    id: number | undefined;
}

export class UpdateRegionDto implements IUpdateRegionDto {
    name: string | undefined;
    boundaryLats: string | undefined;
    boundaryLngs: string | undefined;
    startLat: number | undefined;
    startLng: number | undefined;
    startWork: string | undefined;
    endWork: string | undefined;
    startLaunchBreak: string | undefined;
    endLaunchBreak: string | undefined;
    id: number | undefined;

    constructor(data?: IUpdateRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.boundaryLats = _data["boundaryLats"];
            this.boundaryLngs = _data["boundaryLngs"];
            this.startLat = _data["startLat"];
            this.startLng = _data["startLng"];
            this.startWork = _data["startWork"];
            this.endWork = _data["endWork"];
            this.startLaunchBreak = _data["startLaunchBreak"];
            this.endLaunchBreak = _data["endLaunchBreak"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["boundaryLats"] = this.boundaryLats;
        data["boundaryLngs"] = this.boundaryLngs;
        data["startLat"] = this.startLat;
        data["startLng"] = this.startLng;
        data["startWork"] = this.startWork;
        data["endWork"] = this.endWork;
        data["startLaunchBreak"] = this.startLaunchBreak;
        data["endLaunchBreak"] = this.endLaunchBreak;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateRegionDto {
        const json = this.toJSON();
        let result = new UpdateRegionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRegionDto {
    name: string | undefined;
    boundaryLats: string | undefined;
    boundaryLngs: string | undefined;
    startLat: number | undefined;
    startLng: number | undefined;
    startWork: string | undefined;
    endWork: string | undefined;
    startLaunchBreak: string | undefined;
    endLaunchBreak: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfReportDto implements IPagedResultDtoOfReportDto {
    totalCount: number | undefined;
    items: ReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfReportDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfReportDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfReportDto {
    totalCount: number | undefined;
    items: ReportDto[] | undefined;
}

export class ReportDto implements IReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    reportSourcesId: number | undefined;
    reportSourcesName: number | undefined;
    dashbordNumber: number | undefined;
    dashbordNumberEN: number | undefined;
    dashbordName: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;

    constructor(data?: IReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.reportSourcesId = _data["reportSourcesId"];
            this.reportSourcesName = _data["reportSourcesName"];
            this.dashbordNumber = _data["dashbordNumber"];
            this.dashbordNumberEN = _data["dashbordNumberEN"];
            this.dashbordName = _data["dashbordName"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.buttonTitle = _data["buttonTitle"];
            this.buttonColor = _data["buttonColor"];
            this.iconURL = _data["iconURL"];
            this.viewName = _data["viewName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["reportSourcesId"] = this.reportSourcesId;
        data["reportSourcesName"] = this.reportSourcesName;
        data["dashbordNumber"] = this.dashbordNumber;
        data["dashbordNumberEN"] = this.dashbordNumberEN;
        data["dashbordName"] = this.dashbordName;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["buttonTitle"] = this.buttonTitle;
        data["buttonColor"] = this.buttonColor;
        data["iconURL"] = this.iconURL;
        data["viewName"] = this.viewName;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReportDto {
        const json = this.toJSON();
        let result = new ReportDto();
        result.init(json);
        return result;
    }
}

export interface IReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    reportSourcesId: number | undefined;
    reportSourcesName: number | undefined;
    dashbordNumber: number | undefined;
    dashbordNumberEN: number | undefined;
    dashbordName: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;
}

export class MetabaseDashboardOutput implements IMetabaseDashboardOutput {
    url: string | undefined;

    constructor(data?: IMetabaseDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MetabaseDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MetabaseDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data; 
    }

    clone(): MetabaseDashboardOutput {
        const json = this.toJSON();
        let result = new MetabaseDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IMetabaseDashboardOutput {
    url: string | undefined;
}

export class CreateReportDto implements ICreateReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    reportSourcesId: number | undefined;
    dashbordNumber: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.moduleId = _data["moduleId"];
            this.reportSourcesId = _data["reportSourcesId"];
            this.dashbordNumber = _data["dashbordNumber"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.buttonTitle = _data["buttonTitle"];
            this.buttonColor = _data["buttonColor"];
            this.iconURL = _data["iconURL"];
            this.viewName = _data["viewName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["moduleId"] = this.moduleId;
        data["reportSourcesId"] = this.reportSourcesId;
        data["dashbordNumber"] = this.dashbordNumber;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["buttonTitle"] = this.buttonTitle;
        data["buttonColor"] = this.buttonColor;
        data["iconURL"] = this.iconURL;
        data["viewName"] = this.viewName;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateReportDto {
        const json = this.toJSON();
        let result = new CreateReportDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReportDto {
    name: string | undefined;
    moduleId: number | undefined;
    reportSourcesId: number | undefined;
    dashbordNumber: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    buttonTitle: string | undefined;
    buttonColor: string | undefined;
    iconURL: string | undefined;
    viewName: string | undefined;
    id: number | undefined;
}

export class SRRouteResolveSingleLocationInputDto implements ISRRouteResolveSingleLocationInputDto {
    startLocation: SRResolveLocationDto | undefined;
    resolvingLocation: SRResolveLocationDto | undefined;

    constructor(data?: ISRRouteResolveSingleLocationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startLocation = _data["startLocation"] ? SRResolveLocationDto.fromJS(_data["startLocation"]) : <any>undefined;
            this.resolvingLocation = _data["resolvingLocation"] ? SRResolveLocationDto.fromJS(_data["resolvingLocation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SRRouteResolveSingleLocationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRRouteResolveSingleLocationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startLocation"] = this.startLocation ? this.startLocation.toJSON() : <any>undefined;
        data["resolvingLocation"] = this.resolvingLocation ? this.resolvingLocation.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SRRouteResolveSingleLocationInputDto {
        const json = this.toJSON();
        let result = new SRRouteResolveSingleLocationInputDto();
        result.init(json);
        return result;
    }
}

export interface ISRRouteResolveSingleLocationInputDto {
    startLocation: SRResolveLocationDto | undefined;
    resolvingLocation: SRResolveLocationDto | undefined;
}

export class SRResolveLocationDto implements ISRResolveLocationDto {
    name: string | undefined;
    resolvedLat: number | undefined;
    resolvedLng: number | undefined;
    hasProcessed: boolean | undefined;
    hasResolveError: boolean | undefined;
    readonly resolveResultMessage: string | undefined;
    lat: number | undefined;
    lng: number | undefined;

    constructor(data?: ISRResolveLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.resolvedLat = _data["resolvedLat"];
            this.resolvedLng = _data["resolvedLng"];
            this.hasProcessed = _data["hasProcessed"];
            this.hasResolveError = _data["hasResolveError"];
            (<any>this).resolveResultMessage = _data["resolveResultMessage"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): SRResolveLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRResolveLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resolvedLat"] = this.resolvedLat;
        data["resolvedLng"] = this.resolvedLng;
        data["hasProcessed"] = this.hasProcessed;
        data["hasResolveError"] = this.hasResolveError;
        data["resolveResultMessage"] = this.resolveResultMessage;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data; 
    }

    clone(): SRResolveLocationDto {
        const json = this.toJSON();
        let result = new SRResolveLocationDto();
        result.init(json);
        return result;
    }
}

export interface ISRResolveLocationDto {
    name: string | undefined;
    resolvedLat: number | undefined;
    resolvedLng: number | undefined;
    hasProcessed: boolean | undefined;
    hasResolveError: boolean | undefined;
    resolveResultMessage: string | undefined;
    lat: number | undefined;
    lng: number | undefined;
}

export class SRRouteResolveExcelUploadDto implements ISRRouteResolveExcelUploadDto {
    name: string | undefined;
    startLocation: SRResolveLocationDto | undefined;
    vehicleType: SRRouteResolveExcelUploadDtoVehicleType | undefined;
    base64: string | undefined;

    constructor(data?: ISRRouteResolveExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startLocation = _data["startLocation"] ? SRResolveLocationDto.fromJS(_data["startLocation"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): SRRouteResolveExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRRouteResolveExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startLocation"] = this.startLocation ? this.startLocation.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["base64"] = this.base64;
        return data; 
    }

    clone(): SRRouteResolveExcelUploadDto {
        const json = this.toJSON();
        let result = new SRRouteResolveExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRRouteResolveExcelUploadDto {
    name: string | undefined;
    startLocation: SRResolveLocationDto | undefined;
    vehicleType: SRRouteResolveExcelUploadDtoVehicleType | undefined;
    base64: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfRoleListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: moment.Moment | undefined;
    id: number | undefined;
}

export class ListResultDtoOfPermissionDto implements IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IListResultDtoOfPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfPermissionDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PagedResultDtoOfRoleDto implements IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;
}

export class SRRouteOptimumBasicExcelUploadDto implements ISRRouteOptimumBasicExcelUploadDto {
    name: string | undefined;
    startLocation: SRResolveLocationDto | undefined;
    vehicleType: SRRouteOptimumBasicExcelUploadDtoVehicleType | undefined;
    base64: string | undefined;

    constructor(data?: ISRRouteOptimumBasicExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startLocation = _data["startLocation"] ? SRResolveLocationDto.fromJS(_data["startLocation"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): SRRouteOptimumBasicExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRRouteOptimumBasicExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startLocation"] = this.startLocation ? this.startLocation.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        data["base64"] = this.base64;
        return data; 
    }

    clone(): SRRouteOptimumBasicExcelUploadDto {
        const json = this.toJSON();
        let result = new SRRouteOptimumBasicExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRRouteOptimumBasicExcelUploadDto {
    name: string | undefined;
    startLocation: SRResolveLocationDto | undefined;
    vehicleType: SRRouteOptimumBasicExcelUploadDtoVehicleType | undefined;
    base64: string | undefined;
}

export class SRRouteOptimumDailyExcelUploadDto implements ISRRouteOptimumDailyExcelUploadDto {
    base64: string | undefined;

    constructor(data?: ISRRouteOptimumDailyExcelUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): SRRouteOptimumDailyExcelUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRRouteOptimumDailyExcelUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data; 
    }

    clone(): SRRouteOptimumDailyExcelUploadDto {
        const json = this.toJSON();
        let result = new SRRouteOptimumDailyExcelUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRRouteOptimumDailyExcelUploadDto {
    base64: string | undefined;
}

export class SRRouteOptimumDailyUploadDto implements ISRRouteOptimumDailyUploadDto {
    name: string | undefined;
    rowCount: number | undefined;
    hasExcelCellError: boolean | undefined;
    sortIndex: number | undefined;
    resultIndex: number | undefined;
    isIncludedInProcess: boolean | undefined;
    lat: number | undefined;
    lng: number | undefined;

    constructor(data?: ISRRouteOptimumDailyUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rowCount = _data["rowCount"];
            this.hasExcelCellError = _data["hasExcelCellError"];
            this.sortIndex = _data["sortIndex"];
            this.resultIndex = _data["resultIndex"];
            this.isIncludedInProcess = _data["isIncludedInProcess"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): SRRouteOptimumDailyUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRRouteOptimumDailyUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rowCount"] = this.rowCount;
        data["hasExcelCellError"] = this.hasExcelCellError;
        data["sortIndex"] = this.sortIndex;
        data["resultIndex"] = this.resultIndex;
        data["isIncludedInProcess"] = this.isIncludedInProcess;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data; 
    }

    clone(): SRRouteOptimumDailyUploadDto {
        const json = this.toJSON();
        let result = new SRRouteOptimumDailyUploadDto();
        result.init(json);
        return result;
    }
}

export interface ISRRouteOptimumDailyUploadDto {
    name: string | undefined;
    rowCount: number | undefined;
    hasExcelCellError: boolean | undefined;
    sortIndex: number | undefined;
    resultIndex: number | undefined;
    isIncludedInProcess: boolean | undefined;
    lat: number | undefined;
    lng: number | undefined;
}

export class SRRouteOptimumDailyFireDto implements ISRRouteOptimumDailyFireDto {
    name: string | undefined;
    startLocation: SRResolveLocationDto | undefined;
    vehicleType: SRRouteOptimumDailyFireDtoVehicleType | undefined;
    days: SRDayInputDto[] | undefined;

    constructor(data?: ISRRouteOptimumDailyFireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startLocation = _data["startLocation"] ? SRResolveLocationDto.fromJS(_data["startLocation"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days.push(SRDayInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SRRouteOptimumDailyFireDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRRouteOptimumDailyFireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startLocation"] = this.startLocation ? this.startLocation.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SRRouteOptimumDailyFireDto {
        const json = this.toJSON();
        let result = new SRRouteOptimumDailyFireDto();
        result.init(json);
        return result;
    }
}

export interface ISRRouteOptimumDailyFireDto {
    name: string | undefined;
    startLocation: SRResolveLocationDto | undefined;
    vehicleType: SRRouteOptimumDailyFireDtoVehicleType | undefined;
    days: SRDayInputDto[] | undefined;
}

export class SRDayInputDto implements ISRDayInputDto {
    id: number | undefined;
    name: string | undefined;
    locations: SRDayLocationInputDto[] | undefined;
    priorityLocations: SRDayLocationInputDto[] | undefined;

    constructor(data?: ISRDayInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations.push(SRDayLocationInputDto.fromJS(item));
            }
            if (Array.isArray(_data["priorityLocations"])) {
                this.priorityLocations = [] as any;
                for (let item of _data["priorityLocations"])
                    this.priorityLocations.push(SRDayLocationInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SRDayInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRDayInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.priorityLocations)) {
            data["priorityLocations"] = [];
            for (let item of this.priorityLocations)
                data["priorityLocations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SRDayInputDto {
        const json = this.toJSON();
        let result = new SRDayInputDto();
        result.init(json);
        return result;
    }
}

export interface ISRDayInputDto {
    id: number | undefined;
    name: string | undefined;
    locations: SRDayLocationInputDto[] | undefined;
    priorityLocations: SRDayLocationInputDto[] | undefined;
}

export class SRDayLocationInputDto implements ISRDayLocationInputDto {
    name: string | undefined;
    priorityIndex: number | undefined;
    sortIndex: number | undefined;
    resultIndex: number | undefined;
    isIncludedInProcess: boolean | undefined;
    lat: number | undefined;
    lng: number | undefined;

    constructor(data?: ISRDayLocationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.priorityIndex = _data["priorityIndex"];
            this.sortIndex = _data["sortIndex"];
            this.resultIndex = _data["resultIndex"];
            this.isIncludedInProcess = _data["isIncludedInProcess"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
        }
    }

    static fromJS(data: any): SRDayLocationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SRDayLocationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["priorityIndex"] = this.priorityIndex;
        data["sortIndex"] = this.sortIndex;
        data["resultIndex"] = this.resultIndex;
        data["isIncludedInProcess"] = this.isIncludedInProcess;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        return data; 
    }

    clone(): SRDayLocationInputDto {
        const json = this.toJSON();
        let result = new SRDayLocationInputDto();
        result.init(json);
        return result;
    }
}

export interface ISRDayLocationInputDto {
    name: string | undefined;
    priorityIndex: number | undefined;
    sortIndex: number | undefined;
    resultIndex: number | undefined;
    isIncludedInProcess: boolean | undefined;
    lat: number | undefined;
    lng: number | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment | undefined;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        this.features[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment | undefined;
    features: { [key: string]: boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    musteriKodu: string | undefined;
    defaultCustomerName: string | undefined;
    defaultCustomerRowGuid: string | undefined;
    isUserApprover: boolean | undefined;
    isUserOrderer: boolean | undefined;
    isUserCanUseCart: boolean | undefined;
    isUserCanViewTotalShipmentPrice: boolean | undefined;
    isUserStockView: boolean | undefined;
    userDefaultPageUrl: string | undefined;
    platomUserId: string | undefined;
    platomProjectId: string | undefined;
    platomIsMerkezPersonel: boolean | undefined;
    appCustomerThemeInfo: ApplicationThemeDto | undefined;
    platomAppInfo: PlatomAppInfoDto | undefined;
    id: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.musteriKodu = _data["musteriKodu"];
            this.defaultCustomerName = _data["defaultCustomerName"];
            this.defaultCustomerRowGuid = _data["defaultCustomerRowGuid"];
            this.isUserApprover = _data["isUserApprover"];
            this.isUserOrderer = _data["isUserOrderer"];
            this.isUserCanUseCart = _data["isUserCanUseCart"];
            this.isUserCanViewTotalShipmentPrice = _data["isUserCanViewTotalShipmentPrice"];
            this.isUserStockView = _data["isUserStockView"];
            this.userDefaultPageUrl = _data["userDefaultPageUrl"];
            this.platomUserId = _data["platomUserId"];
            this.platomProjectId = _data["platomProjectId"];
            this.platomIsMerkezPersonel = _data["platomIsMerkezPersonel"];
            this.appCustomerThemeInfo = _data["appCustomerThemeInfo"] ? ApplicationThemeDto.fromJS(_data["appCustomerThemeInfo"]) : <any>undefined;
            this.platomAppInfo = _data["platomAppInfo"] ? PlatomAppInfoDto.fromJS(_data["platomAppInfo"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["musteriKodu"] = this.musteriKodu;
        data["defaultCustomerName"] = this.defaultCustomerName;
        data["defaultCustomerRowGuid"] = this.defaultCustomerRowGuid;
        data["isUserApprover"] = this.isUserApprover;
        data["isUserOrderer"] = this.isUserOrderer;
        data["isUserCanUseCart"] = this.isUserCanUseCart;
        data["isUserCanViewTotalShipmentPrice"] = this.isUserCanViewTotalShipmentPrice;
        data["isUserStockView"] = this.isUserStockView;
        data["userDefaultPageUrl"] = this.userDefaultPageUrl;
        data["platomUserId"] = this.platomUserId;
        data["platomProjectId"] = this.platomProjectId;
        data["platomIsMerkezPersonel"] = this.platomIsMerkezPersonel;
        data["appCustomerThemeInfo"] = this.appCustomerThemeInfo ? this.appCustomerThemeInfo.toJSON() : <any>undefined;
        data["platomAppInfo"] = this.platomAppInfo ? this.platomAppInfo.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    musteriKodu: string | undefined;
    defaultCustomerName: string | undefined;
    defaultCustomerRowGuid: string | undefined;
    isUserApprover: boolean | undefined;
    isUserOrderer: boolean | undefined;
    isUserCanUseCart: boolean | undefined;
    isUserCanViewTotalShipmentPrice: boolean | undefined;
    isUserStockView: boolean | undefined;
    userDefaultPageUrl: string | undefined;
    platomUserId: string | undefined;
    platomProjectId: string | undefined;
    platomIsMerkezPersonel: boolean | undefined;
    appCustomerThemeInfo: ApplicationThemeDto | undefined;
    platomAppInfo: PlatomAppInfoDto | undefined;
    id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number | undefined;
}

export class ApplicationThemeDto implements IApplicationThemeDto {
    portalLogoPath: string | undefined;
    customerLogoPath: string | undefined;

    constructor(data?: IApplicationThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.portalLogoPath = _data["portalLogoPath"];
            this.customerLogoPath = _data["customerLogoPath"];
        }
    }

    static fromJS(data: any): ApplicationThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalLogoPath"] = this.portalLogoPath;
        data["customerLogoPath"] = this.customerLogoPath;
        return data; 
    }

    clone(): ApplicationThemeDto {
        const json = this.toJSON();
        let result = new ApplicationThemeDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationThemeDto {
    portalLogoPath: string | undefined;
    customerLogoPath: string | undefined;
}

export class PlatomAppInfoDto implements IPlatomAppInfoDto {
    moduleAccess: PlatomAppModuleAccessDto | undefined;

    constructor(data?: IPlatomAppInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleAccess = _data["moduleAccess"] ? PlatomAppModuleAccessDto.fromJS(_data["moduleAccess"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlatomAppInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomAppInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleAccess"] = this.moduleAccess ? this.moduleAccess.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PlatomAppInfoDto {
        const json = this.toJSON();
        let result = new PlatomAppInfoDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomAppInfoDto {
    moduleAccess: PlatomAppModuleAccessDto | undefined;
}

export class PlatomAppModuleAccessDto implements IPlatomAppModuleAccessDto {
    izin: boolean | undefined;
    masraf: boolean | undefined;
    rutGorev: boolean | undefined;
    personelGorev: boolean | undefined;
    serbestForm: boolean | undefined;
    video: boolean | undefined;
    duyuru: boolean | undefined;
    bringMyStand: boolean | undefined;
    ekibim: boolean | undefined;
    magazalarim: boolean | undefined;
    zimmet: boolean | undefined;
    hizliGorevOlustur: boolean | undefined;

    constructor(data?: IPlatomAppModuleAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.izin = _data["izin"];
            this.masraf = _data["masraf"];
            this.rutGorev = _data["rutGorev"];
            this.personelGorev = _data["personelGorev"];
            this.serbestForm = _data["serbestForm"];
            this.video = _data["video"];
            this.duyuru = _data["duyuru"];
            this.bringMyStand = _data["bringMyStand"];
            this.ekibim = _data["ekibim"];
            this.magazalarim = _data["magazalarim"];
            this.zimmet = _data["zimmet"];
            this.hizliGorevOlustur = _data["hizliGorevOlustur"];
        }
    }

    static fromJS(data: any): PlatomAppModuleAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlatomAppModuleAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["izin"] = this.izin;
        data["masraf"] = this.masraf;
        data["rutGorev"] = this.rutGorev;
        data["personelGorev"] = this.personelGorev;
        data["serbestForm"] = this.serbestForm;
        data["video"] = this.video;
        data["duyuru"] = this.duyuru;
        data["bringMyStand"] = this.bringMyStand;
        data["ekibim"] = this.ekibim;
        data["magazalarim"] = this.magazalarim;
        data["zimmet"] = this.zimmet;
        data["hizliGorevOlustur"] = this.hizliGorevOlustur;
        return data; 
    }

    clone(): PlatomAppModuleAccessDto {
        const json = this.toJSON();
        let result = new PlatomAppModuleAccessDto();
        result.init(json);
        return result;
    }
}

export interface IPlatomAppModuleAccessDto {
    izin: boolean | undefined;
    masraf: boolean | undefined;
    rutGorev: boolean | undefined;
    personelGorev: boolean | undefined;
    serbestForm: boolean | undefined;
    video: boolean | undefined;
    duyuru: boolean | undefined;
    bringMyStand: boolean | undefined;
    ekibim: boolean | undefined;
    magazalarim: boolean | undefined;
    zimmet: boolean | undefined;
    hizliGorevOlustur: boolean | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfTenantDto implements IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTenantDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTenantDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;
}

export class ModuleConfigPosmTakipDto implements IModuleConfigPosmTakipDto {
    yeniUretimTalebiMailAlicilari: string[] | undefined;
    teslimatSonAktarimTarihi: moment.Moment | undefined;

    constructor(data?: IModuleConfigPosmTakipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["yeniUretimTalebiMailAlicilari"])) {
                this.yeniUretimTalebiMailAlicilari = [] as any;
                for (let item of _data["yeniUretimTalebiMailAlicilari"])
                    this.yeniUretimTalebiMailAlicilari.push(item);
            }
            this.teslimatSonAktarimTarihi = _data["teslimatSonAktarimTarihi"] ? moment(_data["teslimatSonAktarimTarihi"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ModuleConfigPosmTakipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleConfigPosmTakipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.yeniUretimTalebiMailAlicilari)) {
            data["yeniUretimTalebiMailAlicilari"] = [];
            for (let item of this.yeniUretimTalebiMailAlicilari)
                data["yeniUretimTalebiMailAlicilari"].push(item);
        }
        data["teslimatSonAktarimTarihi"] = this.teslimatSonAktarimTarihi ? this.teslimatSonAktarimTarihi.toISOString() : <any>undefined;
        return data; 
    }

    clone(): ModuleConfigPosmTakipDto {
        const json = this.toJSON();
        let result = new ModuleConfigPosmTakipDto();
        result.init(json);
        return result;
    }
}

export interface IModuleConfigPosmTakipDto {
    yeniUretimTalebiMailAlicilari: string[] | undefined;
    teslimatSonAktarimTarihi: moment.Moment | undefined;
}

export class PredictHeaderModel implements IPredictHeaderModel {
    id: string | undefined;
    project: string | undefined;
    iteration: string | undefined;
    created: moment.Moment | undefined;
    predictions: PredictionModel[] | undefined;

    constructor(data?: IPredictHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.project = _data["project"];
            this.iteration = _data["iteration"];
            this.created = _data["created"] ? moment(_data["created"].toString()) : <any>undefined;
            if (Array.isArray(_data["predictions"])) {
                this.predictions = [] as any;
                for (let item of _data["predictions"])
                    this.predictions.push(PredictionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredictHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new PredictHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["project"] = this.project;
        data["iteration"] = this.iteration;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        if (Array.isArray(this.predictions)) {
            data["predictions"] = [];
            for (let item of this.predictions)
                data["predictions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PredictHeaderModel {
        const json = this.toJSON();
        let result = new PredictHeaderModel();
        result.init(json);
        return result;
    }
}

export interface IPredictHeaderModel {
    id: string | undefined;
    project: string | undefined;
    iteration: string | undefined;
    created: moment.Moment | undefined;
    predictions: PredictionModel[] | undefined;
}

export class PredictionModel implements IPredictionModel {
    probability: number | undefined;
    tagId: string | undefined;
    tagName: string | undefined;
    boundingBox: BoundingBoxModel | undefined;

    constructor(data?: IPredictionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.probability = _data["probability"];
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.boundingBox = _data["boundingBox"] ? BoundingBoxModel.fromJS(_data["boundingBox"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PredictionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["probability"] = this.probability;
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["boundingBox"] = this.boundingBox ? this.boundingBox.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PredictionModel {
        const json = this.toJSON();
        let result = new PredictionModel();
        result.init(json);
        return result;
    }
}

export interface IPredictionModel {
    probability: number | undefined;
    tagId: string | undefined;
    tagName: string | undefined;
    boundingBox: BoundingBoxModel | undefined;
}

export class BoundingBoxModel implements IBoundingBoxModel {
    left: number | undefined;
    top: number | undefined;
    width: number | undefined;
    height: number | undefined;

    constructor(data?: IBoundingBoxModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.left = _data["left"];
            this.top = _data["top"];
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static fromJS(data: any): BoundingBoxModel {
        data = typeof data === 'object' ? data : {};
        let result = new BoundingBoxModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["left"] = this.left;
        data["top"] = this.top;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }

    clone(): BoundingBoxModel {
        const json = this.toJSON();
        let result = new BoundingBoxModel();
        result.init(json);
        return result;
    }
}

export interface IBoundingBoxModel {
    left: number | undefined;
    top: number | undefined;
    width: number | undefined;
    height: number | undefined;
}

export class PagedResultDtoOfTitleDto implements IPagedResultDtoOfTitleDto {
    totalCount: number | undefined;
    items: TitleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTitleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTitleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTitleDto {
    totalCount: number | undefined;
    items: TitleDto[] | undefined;
}

export class TitleDto implements ITitleDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    comment: string | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;

    constructor(data?: ITitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.comment = _data["comment"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["comment"] = this.comment;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data; 
    }

    clone(): TitleDto {
        const json = this.toJSON();
        let result = new TitleDto();
        result.init(json);
        return result;
    }
}

export interface ITitleDto {
    name: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    comment: string | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
}

export class CreateTitleDto implements ICreateTitleDto {
    name: string;
    customerId: number;
    comment: string | undefined;
    id: number | undefined;

    constructor(data?: ICreateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateTitleDto {
        const json = this.toJSON();
        let result = new CreateTitleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTitleDto {
    name: string;
    customerId: number;
    comment: string | undefined;
    id: number | undefined;
}

export class ProductStockPto implements IProductStockPto {
    readonly photoPathSmall: string | undefined;
    readonly photoPathLarge: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;

    constructor(data?: IProductStockPto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).photoPathSmall = _data["photoPathSmall"];
            (<any>this).photoPathLarge = _data["photoPathLarge"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.businessUnitName = _data["businessUnitName"];
            this.brandName = _data["brandName"];
            this.campaignName = _data["campaignName"];
            this.warehouseName = _data["warehouseName"];
            this.stock = _data["stock"];
            this.blockedStock = _data["blockedStock"];
            this.type = _data["type"];
            this.type1Name = _data["type1Name"];
            this.type2Name = _data["type2Name"];
            this.type3Name = _data["type3Name"];
            this.type4Name = _data["type4Name"];
            this.group1Name = _data["group1Name"];
            this.group2Name = _data["group2Name"];
            this.merkezOnayliStok = _data["merkezOnayliStok"];
            this.onaySureciDevamEdenStok = _data["onaySureciDevamEdenStok"];
        }
    }

    static fromJS(data: any): ProductStockPto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStockPto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoPathSmall"] = this.photoPathSmall;
        data["photoPathLarge"] = this.photoPathLarge;
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["businessUnitName"] = this.businessUnitName;
        data["brandName"] = this.brandName;
        data["campaignName"] = this.campaignName;
        data["warehouseName"] = this.warehouseName;
        data["stock"] = this.stock;
        data["blockedStock"] = this.blockedStock;
        data["type"] = this.type;
        data["type1Name"] = this.type1Name;
        data["type2Name"] = this.type2Name;
        data["type3Name"] = this.type3Name;
        data["type4Name"] = this.type4Name;
        data["group1Name"] = this.group1Name;
        data["group2Name"] = this.group2Name;
        data["merkezOnayliStok"] = this.merkezOnayliStok;
        data["onaySureciDevamEdenStok"] = this.onaySureciDevamEdenStok;
        return data; 
    }

    clone(): ProductStockPto {
        const json = this.toJSON();
        let result = new ProductStockPto();
        result.init(json);
        return result;
    }
}

export interface IProductStockPto {
    photoPathSmall: string | undefined;
    photoPathLarge: string | undefined;
    id: number | undefined;
    name: string | undefined;
    code: string | undefined;
    businessUnitName: string | undefined;
    brandName: string | undefined;
    campaignName: string | undefined;
    warehouseName: string | undefined;
    stock: number | undefined;
    blockedStock: number | undefined;
    type: string | undefined;
    type1Name: string | undefined;
    type2Name: string | undefined;
    type3Name: string | undefined;
    type4Name: string | undefined;
    group1Name: string | undefined;
    group2Name: string | undefined;
    merkezOnayliStok: number | undefined;
    onaySureciDevamEdenStok: number | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data; 
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data; 
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
}

export class TransportBidInfoDto implements ITransportBidInfoDto {
    name: string | undefined;
    yuklemeTarihi: moment.Moment | undefined;
    aracCinsi: string | undefined;
    yuklemeYeri: string | undefined;
    bosaltmaYeri: string | undefined;
    tonajCinsi: string | undefined;
    tonajBirim: string | undefined;
    kapasite: string | undefined;
    aciklama: string | undefined;
    ilgiliFirma: string | undefined;
    ilgiliFirmaYetkili: string | undefined;
    ihaleDurum: TransportBidInfoDtoIhaleDurum | undefined;
    id: string | undefined;

    constructor(data?: ITransportBidInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.yuklemeTarihi = _data["yuklemeTarihi"] ? moment(_data["yuklemeTarihi"].toString()) : <any>undefined;
            this.aracCinsi = _data["aracCinsi"];
            this.yuklemeYeri = _data["yuklemeYeri"];
            this.bosaltmaYeri = _data["bosaltmaYeri"];
            this.tonajCinsi = _data["tonajCinsi"];
            this.tonajBirim = _data["tonajBirim"];
            this.kapasite = _data["kapasite"];
            this.aciklama = _data["aciklama"];
            this.ilgiliFirma = _data["ilgiliFirma"];
            this.ilgiliFirmaYetkili = _data["ilgiliFirmaYetkili"];
            this.ihaleDurum = _data["ihaleDurum"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TransportBidInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportBidInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["yuklemeTarihi"] = this.yuklemeTarihi ? this.yuklemeTarihi.toISOString() : <any>undefined;
        data["aracCinsi"] = this.aracCinsi;
        data["yuklemeYeri"] = this.yuklemeYeri;
        data["bosaltmaYeri"] = this.bosaltmaYeri;
        data["tonajCinsi"] = this.tonajCinsi;
        data["tonajBirim"] = this.tonajBirim;
        data["kapasite"] = this.kapasite;
        data["aciklama"] = this.aciklama;
        data["ilgiliFirma"] = this.ilgiliFirma;
        data["ilgiliFirmaYetkili"] = this.ilgiliFirmaYetkili;
        data["ihaleDurum"] = this.ihaleDurum;
        data["id"] = this.id;
        return data; 
    }

    clone(): TransportBidInfoDto {
        const json = this.toJSON();
        let result = new TransportBidInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITransportBidInfoDto {
    name: string | undefined;
    yuklemeTarihi: moment.Moment | undefined;
    aracCinsi: string | undefined;
    yuklemeYeri: string | undefined;
    bosaltmaYeri: string | undefined;
    tonajCinsi: string | undefined;
    tonajBirim: string | undefined;
    kapasite: string | undefined;
    aciklama: string | undefined;
    ilgiliFirma: string | undefined;
    ilgiliFirmaYetkili: string | undefined;
    ihaleDurum: TransportBidInfoDtoIhaleDurum | undefined;
    id: string | undefined;
}

export class UpdateTransportBidDto implements IUpdateTransportBidDto {
    name: string | undefined;
    teklifDurum: UpdateTransportBidDtoTeklifDurum | undefined;
    teklifTutari: number | undefined;
    teklifZamani: moment.Moment | undefined;
    soforCepTelefon: string | undefined;
    soforAdSoyad: string | undefined;
    aracPlakasi: string | undefined;
    id: string | undefined;

    constructor(data?: IUpdateTransportBidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.teklifDurum = _data["teklifDurum"];
            this.teklifTutari = _data["teklifTutari"];
            this.teklifZamani = _data["teklifZamani"] ? moment(_data["teklifZamani"].toString()) : <any>undefined;
            this.soforCepTelefon = _data["soforCepTelefon"];
            this.soforAdSoyad = _data["soforAdSoyad"];
            this.aracPlakasi = _data["aracPlakasi"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTransportBidDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransportBidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["teklifDurum"] = this.teklifDurum;
        data["teklifTutari"] = this.teklifTutari;
        data["teklifZamani"] = this.teklifZamani ? this.teklifZamani.toISOString() : <any>undefined;
        data["soforCepTelefon"] = this.soforCepTelefon;
        data["soforAdSoyad"] = this.soforAdSoyad;
        data["aracPlakasi"] = this.aracPlakasi;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateTransportBidDto {
        const json = this.toJSON();
        let result = new UpdateTransportBidDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTransportBidDto {
    name: string | undefined;
    teklifDurum: UpdateTransportBidDtoTeklifDurum | undefined;
    teklifTutari: number | undefined;
    teklifZamani: moment.Moment | undefined;
    soforCepTelefon: string | undefined;
    soforAdSoyad: string | undefined;
    aracPlakasi: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfUserDto implements IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;
}

export class UserDto implements IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    roleNames: string[] | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    customers: UserCustomerInfoDto[] | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.platomUserId = _data["platomUserId"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers.push(UserCustomerInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedPages"])) {
                this.assignedPages = [] as any;
                for (let item of _data["assignedPages"])
                    this.assignedPages.push(UserSelectedPagesDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedModuleIds"])) {
                this.assignedModuleIds = [] as any;
                for (let item of _data["assignedModuleIds"])
                    this.assignedModuleIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["platomUserId"] = this.platomUserId;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedPages)) {
            data["assignedPages"] = [];
            for (let item of this.assignedPages)
                data["assignedPages"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedModuleIds)) {
            data["assignedModuleIds"] = [];
            for (let item of this.assignedModuleIds)
                data["assignedModuleIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment | undefined;
    roleNames: string[] | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    customers: UserCustomerInfoDto[] | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;
    id: number | undefined;
}

export class UserCustomerInfoDto implements IUserCustomerInfoDto {
    customerId: number | undefined;
    customerName: string | undefined;
    isDefault: boolean | undefined;

    constructor(data?: IUserCustomerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UserCustomerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["isDefault"] = this.isDefault;
        return data; 
    }

    clone(): UserCustomerInfoDto {
        const json = this.toJSON();
        let result = new UserCustomerInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserCustomerInfoDto {
    customerId: number | undefined;
    customerName: string | undefined;
    isDefault: boolean | undefined;
}

export class UserSelectedPagesDto implements IUserSelectedPagesDto {
    pageId: number | undefined;
    isDefault: boolean | undefined;

    constructor(data?: IUserSelectedPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UserSelectedPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectedPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        data["isDefault"] = this.isDefault;
        return data; 
    }

    clone(): UserSelectedPagesDto {
        const json = this.toJSON();
        let result = new UserSelectedPagesDto();
        result.init(json);
        return result;
    }
}

export interface IUserSelectedPagesDto {
    pageId: number | undefined;
    isDefault: boolean | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    roleNames: string[] | undefined;
    password: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
            this.phoneNumber = _data["phoneNumber"];
            this.platomUserId = _data["platomUserId"];
            if (Array.isArray(_data["assignedPages"])) {
                this.assignedPages = [] as any;
                for (let item of _data["assignedPages"])
                    this.assignedPages.push(UserSelectedPagesDto.fromJS(item));
            }
            if (Array.isArray(_data["assignedModuleIds"])) {
                this.assignedModuleIds = [] as any;
                for (let item of _data["assignedModuleIds"])
                    this.assignedModuleIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["phoneNumber"] = this.phoneNumber;
        data["platomUserId"] = this.platomUserId;
        if (Array.isArray(this.assignedPages)) {
            data["assignedPages"] = [];
            for (let item of this.assignedPages)
                data["assignedPages"].push(item.toJSON());
        }
        if (Array.isArray(this.assignedModuleIds)) {
            data["assignedModuleIds"] = [];
            for (let item of this.assignedModuleIds)
                data["assignedModuleIds"].push(item);
        }
        return data; 
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean | undefined;
    roleNames: string[] | undefined;
    password: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    assignedModuleIds: number[] | undefined;
}

export class ListResultDtoOfRoleDto implements IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class CloneUserDto implements ICloneUserDto {
    clonedUserId: number | undefined;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;

    constructor(data?: ICloneUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clonedUserId = _data["clonedUserId"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.platomUserId = _data["platomUserId"];
        }
    }

    static fromJS(data: any): CloneUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloneUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clonedUserId"] = this.clonedUserId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["platomUserId"] = this.platomUserId;
        return data; 
    }

    clone(): CloneUserDto {
        const json = this.toJSON();
        let result = new CloneUserDto();
        result.init(json);
        return result;
    }
}

export interface ICloneUserDto {
    clonedUserId: number | undefined;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    platomUserId: string | undefined;
}

export class LastLoggedUsersDto implements ILastLoggedUsersDto {
    userId: number | undefined;
    userName: string | undefined;
    userSurname: string | undefined;
    customerName: string | undefined;
    firstLogDate: moment.Moment | undefined;
    lastLogDate: moment.Moment | undefined;
    browserInfo: string | undefined;
    status: boolean | undefined;

    constructor(data?: ILastLoggedUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userSurname = _data["userSurname"];
            this.customerName = _data["customerName"];
            this.firstLogDate = _data["firstLogDate"] ? moment(_data["firstLogDate"].toString()) : <any>undefined;
            this.lastLogDate = _data["lastLogDate"] ? moment(_data["lastLogDate"].toString()) : <any>undefined;
            this.browserInfo = _data["browserInfo"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LastLoggedUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastLoggedUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userSurname"] = this.userSurname;
        data["customerName"] = this.customerName;
        data["firstLogDate"] = this.firstLogDate ? this.firstLogDate.toISOString() : <any>undefined;
        data["lastLogDate"] = this.lastLogDate ? this.lastLogDate.toISOString() : <any>undefined;
        data["browserInfo"] = this.browserInfo;
        data["status"] = this.status;
        return data; 
    }

    clone(): LastLoggedUsersDto {
        const json = this.toJSON();
        let result = new LastLoggedUsersDto();
        result.init(json);
        return result;
    }
}

export interface ILastLoggedUsersDto {
    userId: number | undefined;
    userName: string | undefined;
    userSurname: string | undefined;
    customerName: string | undefined;
    firstLogDate: moment.Moment | undefined;
    lastLogDate: moment.Moment | undefined;
    browserInfo: string | undefined;
    status: boolean | undefined;
}

export class UserActionDto implements IUserActionDto {
    orderDetailsId: number | undefined;
    talepTarihi: moment.Moment | undefined;
    urunId: number | undefined;
    urunKodu: string | undefined;
    urunAdi: string | undefined;
    talepMiktari: number | undefined;
    cikisDepoKodu: string | undefined;
    cikisDepoAdi: string | undefined;
    hedefAdresId: number | undefined;
    hedefAdresAdi: string | undefined;
    onayDurumId: number | undefined;
    onayDurum: string | undefined;
    onayciUserId: number | undefined;
    isNext: boolean | undefined;
    onayciUser: string | undefined;
    talepDetay: number | undefined;
    talepDetayDurum: string | undefined;

    constructor(data?: IUserActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderDetailsId = _data["orderDetailsId"];
            this.talepTarihi = _data["talepTarihi"] ? moment(_data["talepTarihi"].toString()) : <any>undefined;
            this.urunId = _data["urunId"];
            this.urunKodu = _data["urunKodu"];
            this.urunAdi = _data["urunAdi"];
            this.talepMiktari = _data["talepMiktari"];
            this.cikisDepoKodu = _data["cikisDepoKodu"];
            this.cikisDepoAdi = _data["cikisDepoAdi"];
            this.hedefAdresId = _data["hedefAdresId"];
            this.hedefAdresAdi = _data["hedefAdresAdi"];
            this.onayDurumId = _data["onayDurumId"];
            this.onayDurum = _data["onayDurum"];
            this.onayciUserId = _data["onayciUserId"];
            this.isNext = _data["isNext"];
            this.onayciUser = _data["onayciUser"];
            this.talepDetay = _data["talepDetay"];
            this.talepDetayDurum = _data["talepDetayDurum"];
        }
    }

    static fromJS(data: any): UserActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderDetailsId"] = this.orderDetailsId;
        data["talepTarihi"] = this.talepTarihi ? this.talepTarihi.toISOString() : <any>undefined;
        data["urunId"] = this.urunId;
        data["urunKodu"] = this.urunKodu;
        data["urunAdi"] = this.urunAdi;
        data["talepMiktari"] = this.talepMiktari;
        data["cikisDepoKodu"] = this.cikisDepoKodu;
        data["cikisDepoAdi"] = this.cikisDepoAdi;
        data["hedefAdresId"] = this.hedefAdresId;
        data["hedefAdresAdi"] = this.hedefAdresAdi;
        data["onayDurumId"] = this.onayDurumId;
        data["onayDurum"] = this.onayDurum;
        data["onayciUserId"] = this.onayciUserId;
        data["isNext"] = this.isNext;
        data["onayciUser"] = this.onayciUser;
        data["talepDetay"] = this.talepDetay;
        data["talepDetayDurum"] = this.talepDetayDurum;
        return data; 
    }

    clone(): UserActionDto {
        const json = this.toJSON();
        let result = new UserActionDto();
        result.init(json);
        return result;
    }
}

export interface IUserActionDto {
    orderDetailsId: number | undefined;
    talepTarihi: moment.Moment | undefined;
    urunId: number | undefined;
    urunKodu: string | undefined;
    urunAdi: string | undefined;
    talepMiktari: number | undefined;
    cikisDepoKodu: string | undefined;
    cikisDepoAdi: string | undefined;
    hedefAdresId: number | undefined;
    hedefAdresAdi: string | undefined;
    onayDurumId: number | undefined;
    onayDurum: string | undefined;
    onayciUserId: number | undefined;
    isNext: boolean | undefined;
    onayciUser: string | undefined;
    talepDetay: number | undefined;
    talepDetayDurum: string | undefined;
}

export class UserLastLoginDto implements IUserLastLoginDto {
    id: number | undefined;
    userId: number | undefined;
    browserInfo: string | undefined;
    executionTime: moment.Moment | undefined;
    executionDuration: number | undefined;
    methodName: string | undefined;
    parameters: string | undefined;

    constructor(data?: IUserLastLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.browserInfo = _data["browserInfo"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
        }
    }

    static fromJS(data: any): UserLastLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLastLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["browserInfo"] = this.browserInfo;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        return data; 
    }

    clone(): UserLastLoginDto {
        const json = this.toJSON();
        let result = new UserLastLoginDto();
        result.init(json);
        return result;
    }
}

export interface IUserLastLoginDto {
    id: number | undefined;
    userId: number | undefined;
    browserInfo: string | undefined;
    executionTime: moment.Moment | undefined;
    executionDuration: number | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
}

export class PagedResultDtoOfUserAddressDto implements IPagedResultDtoOfUserAddressDto {
    totalCount: number | undefined;
    items: UserAddressDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserAddressDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserAddressDto {
    totalCount: number | undefined;
    items: UserAddressDto[] | undefined;
}

export class UserAddressDto implements IUserAddressDto {
    name: string | undefined;
    addressId: number | undefined;
    addressPoiId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    categoryName: string | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;

    constructor(data?: IUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.addressId = _data["addressId"];
            this.addressPoiId = _data["addressPoiId"];
            this.addressName = _data["addressName"];
            this.fullAddress = _data["fullAddress"];
            this.categoryName = _data["categoryName"];
            this.cityName = _data["cityName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.authorizationDescription = _data["authorizationDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["addressId"] = this.addressId;
        data["addressPoiId"] = this.addressPoiId;
        data["addressName"] = this.addressName;
        data["fullAddress"] = this.fullAddress;
        data["categoryName"] = this.categoryName;
        data["cityName"] = this.cityName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["authorizationDescription"] = this.authorizationDescription;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserAddressDto {
        const json = this.toJSON();
        let result = new UserAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUserAddressDto {
    name: string | undefined;
    addressId: number | undefined;
    addressPoiId: number | undefined;
    addressName: string | undefined;
    fullAddress: string | undefined;
    categoryName: string | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;
}

export class UserAddressCitiesAndCategoriesDto implements IUserAddressCitiesAndCategoriesDto {
    cities: SelectListItemDto[] | undefined;
    categoryNames: string[] | undefined;

    constructor(data?: IUserAddressCitiesAndCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(SelectListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["categoryNames"])) {
                this.categoryNames = [] as any;
                for (let item of _data["categoryNames"])
                    this.categoryNames.push(item);
            }
        }
    }

    static fromJS(data: any): UserAddressCitiesAndCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddressCitiesAndCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryNames)) {
            data["categoryNames"] = [];
            for (let item of this.categoryNames)
                data["categoryNames"].push(item);
        }
        return data; 
    }

    clone(): UserAddressCitiesAndCategoriesDto {
        const json = this.toJSON();
        let result = new UserAddressCitiesAndCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IUserAddressCitiesAndCategoriesDto {
    cities: SelectListItemDto[] | undefined;
    categoryNames: string[] | undefined;
}

export class CreateUserAddressDto implements ICreateUserAddressDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    addressIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["addressIds"])) {
                this.addressIds = [] as any;
                for (let item of _data["addressIds"])
                    this.addressIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.addressIds)) {
            data["addressIds"] = [];
            for (let item of this.addressIds)
                data["addressIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserAddressDto {
        const json = this.toJSON();
        let result = new CreateUserAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserAddressDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    addressIds: number[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserAuthorizationDto implements IPagedResultDtoOfUserAuthorizationDto {
    totalCount: number | undefined;
    items: UserAuthorizationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserAuthorizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserAuthorizationDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserAuthorizationDto {
    totalCount: number | undefined;
    items: UserAuthorizationDto[] | undefined;
}

export class UserAuthorizationDto implements IUserAuthorizationDto {
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;

    constructor(data?: IUserAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.authorizationDescription = _data["authorizationDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["authorizationDescription"] = this.authorizationDescription;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserAuthorizationDto {
        const json = this.toJSON();
        let result = new UserAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IUserAuthorizationDto {
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    id: number | undefined;
}

export class CreateUserAuthorizationDto implements ICreateUserAuthorizationDto {
    userId: number | undefined;
    authorizationIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["authorizationIds"])) {
                this.authorizationIds = [] as any;
                for (let item of _data["authorizationIds"])
                    this.authorizationIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.authorizationIds)) {
            data["authorizationIds"] = [];
            for (let item of this.authorizationIds)
                data["authorizationIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserAuthorizationDto {
        const json = this.toJSON();
        let result = new CreateUserAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserAuthorizationDto {
    userId: number | undefined;
    authorizationIds: number[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserCitiesDto implements IPagedResultDtoOfUserCitiesDto {
    totalCount: number | undefined;
    items: UserCitiesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCitiesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserCitiesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserCitiesDto {
    totalCount: number | undefined;
    items: UserCitiesDto[] | undefined;
}

export class UserCitiesDto implements IUserCitiesDto {
    cityId: number | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    hasCategory: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.hasCategory = _data["hasCategory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["hasCategory"] = this.hasCategory;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserCitiesDto {
        const json = this.toJSON();
        let result = new UserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface IUserCitiesDto {
    cityId: number | undefined;
    cityName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    hasCategory: boolean | undefined;
    id: number | undefined;
}

export class UpdateUserCitiesDto implements IUpdateUserCitiesDto {
    authorizationId: number | undefined;
    assignedCategories: number[] | undefined;
    id: number | undefined;

    constructor(data?: IUpdateUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["assignedCategories"])) {
                this.assignedCategories = [] as any;
                for (let item of _data["assignedCategories"])
                    this.assignedCategories.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateUserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.assignedCategories)) {
            data["assignedCategories"] = [];
            for (let item of this.assignedCategories)
                data["assignedCategories"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateUserCitiesDto {
        const json = this.toJSON();
        let result = new UpdateUserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCitiesDto {
    authorizationId: number | undefined;
    assignedCategories: number[] | undefined;
    id: number | undefined;
}

export class CreateUserCitiesDto implements ICreateUserCitiesDto {
    userId: number | undefined;
    authorizationId: number | undefined;
    cityIds: number[] | undefined;
    categoryIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserCitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["cityIds"])) {
                this.cityIds = [] as any;
                for (let item of _data["cityIds"])
                    this.cityIds.push(item);
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserCitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.cityIds)) {
            data["cityIds"] = [];
            for (let item of this.cityIds)
                data["cityIds"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserCitiesDto {
        const json = this.toJSON();
        let result = new CreateUserCitiesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCitiesDto {
    userId: number | undefined;
    authorizationId: number | undefined;
    cityIds: number[] | undefined;
    categoryIds: number[] | undefined;
    id: number | undefined;
}

export class UserCityCategoryDto implements IUserCityCategoryDto {
    categoryId: number | undefined;
    categoryName: string | undefined;
    isAssigned: boolean | undefined;

    constructor(data?: IUserCityCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.isAssigned = _data["isAssigned"];
        }
    }

    static fromJS(data: any): UserCityCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCityCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["isAssigned"] = this.isAssigned;
        return data; 
    }

    clone(): UserCityCategoryDto {
        const json = this.toJSON();
        let result = new UserCityCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IUserCityCategoryDto {
    categoryId: number | undefined;
    categoryName: string | undefined;
    isAssigned: boolean | undefined;
}

export class UserCitiesCategoriesDto implements IUserCitiesCategoriesDto {
    name: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;

    constructor(data?: IUserCitiesCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserCitiesCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCitiesCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserCitiesCategoriesDto {
        const json = this.toJSON();
        let result = new UserCitiesCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IUserCitiesCategoriesDto {
    name: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    categoryId: number | undefined;
    categoryName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserCitiesCategoriesDto implements IPagedResultDtoOfUserCitiesCategoriesDto {
    totalCount: number | undefined;
    items: UserCitiesCategoriesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserCitiesCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCitiesCategoriesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserCitiesCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserCitiesCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserCitiesCategoriesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserCitiesCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserCitiesCategoriesDto {
    totalCount: number | undefined;
    items: UserCitiesCategoriesDto[] | undefined;
}

export class CreateUserCitiesCategoriesDto implements ICreateUserCitiesCategoriesDto {
    id: number | undefined;

    constructor(data?: ICreateUserCitiesCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserCitiesCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCitiesCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserCitiesCategoriesDto {
        const json = this.toJSON();
        let result = new CreateUserCitiesCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCitiesCategoriesDto {
    id: number | undefined;
}

export class PagedResultDtoOfUserCustomerDto implements IPagedResultDtoOfUserCustomerDto {
    totalCount: number | undefined;
    items: UserCustomerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCustomerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserCustomerDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserCustomerDto {
    totalCount: number | undefined;
    items: UserCustomerDto[] | undefined;
}

export class UserCustomerDto implements IUserCustomerDto {
    name: string | undefined;
    customerId: number | undefined;
    customerGuid: string | undefined;
    customerCode: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    orderApprovalTypeName: string | undefined;
    isDefault: boolean | undefined;
    customerThemeId: number | undefined;
    customerThemePortalLogoPath: string | undefined;
    customerThemeCustomerLogoPath: string | undefined;
    id: number | undefined;

    constructor(data?: IUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.customerId = _data["customerId"];
            this.customerGuid = _data["customerGuid"];
            this.customerCode = _data["customerCode"];
            this.customerName = _data["customerName"];
            this.titleId = _data["titleId"];
            this.titleName = _data["titleName"];
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.orderApprovalTypeId = _data["orderApprovalTypeId"];
            this.orderApprovalTypeName = _data["orderApprovalTypeName"];
            this.isDefault = _data["isDefault"];
            this.customerThemeId = _data["customerThemeId"];
            this.customerThemePortalLogoPath = _data["customerThemePortalLogoPath"];
            this.customerThemeCustomerLogoPath = _data["customerThemeCustomerLogoPath"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["customerId"] = this.customerId;
        data["customerGuid"] = this.customerGuid;
        data["customerCode"] = this.customerCode;
        data["customerName"] = this.customerName;
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["orderApprovalTypeId"] = this.orderApprovalTypeId;
        data["orderApprovalTypeName"] = this.orderApprovalTypeName;
        data["isDefault"] = this.isDefault;
        data["customerThemeId"] = this.customerThemeId;
        data["customerThemePortalLogoPath"] = this.customerThemePortalLogoPath;
        data["customerThemeCustomerLogoPath"] = this.customerThemeCustomerLogoPath;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserCustomerDto {
        const json = this.toJSON();
        let result = new UserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUserCustomerDto {
    name: string | undefined;
    customerId: number | undefined;
    customerGuid: string | undefined;
    customerCode: string | undefined;
    customerName: string | undefined;
    titleId: number | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    orderApprovalTypeName: string | undefined;
    isDefault: boolean | undefined;
    customerThemeId: number | undefined;
    customerThemePortalLogoPath: string | undefined;
    customerThemeCustomerLogoPath: string | undefined;
    id: number | undefined;
}

export class CreateUserCustomerDto implements ICreateUserCustomerDto {
    name: string | undefined;
    userId: number | undefined;
    assignedList: UserCustomerAssignDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["assignedList"])) {
                this.assignedList = [] as any;
                for (let item of _data["assignedList"])
                    this.assignedList.push(UserCustomerAssignDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        if (Array.isArray(this.assignedList)) {
            data["assignedList"] = [];
            for (let item of this.assignedList)
                data["assignedList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserCustomerDto {
        const json = this.toJSON();
        let result = new CreateUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCustomerDto {
    name: string | undefined;
    userId: number | undefined;
    assignedList: UserCustomerAssignDto[] | undefined;
    id: number | undefined;
}

export class UserCustomerAssignDto implements IUserCustomerAssignDto {
    customerId: number | undefined;
    titleIds: number[] | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    customerThemesId: number | undefined;

    constructor(data?: IUserCustomerAssignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["titleIds"])) {
                this.titleIds = [] as any;
                for (let item of _data["titleIds"])
                    this.titleIds.push(item);
            }
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.orderApprovalTypeId = _data["orderApprovalTypeId"];
            this.customerThemesId = _data["customerThemesId"];
        }
    }

    static fromJS(data: any): UserCustomerAssignDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCustomerAssignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        if (Array.isArray(this.titleIds)) {
            data["titleIds"] = [];
            for (let item of this.titleIds)
                data["titleIds"].push(item);
        }
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["orderApprovalTypeId"] = this.orderApprovalTypeId;
        data["customerThemesId"] = this.customerThemesId;
        return data; 
    }

    clone(): UserCustomerAssignDto {
        const json = this.toJSON();
        let result = new UserCustomerAssignDto();
        result.init(json);
        return result;
    }
}

export interface IUserCustomerAssignDto {
    customerId: number | undefined;
    titleIds: number[] | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    customerThemesId: number | undefined;
}

export class UpdateUserCustomerDto implements IUpdateUserCustomerDto {
    userId: number | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    isDefaultFired: boolean | undefined;
    customerThemeId: number | undefined;
    id: number | undefined;

    constructor(data?: IUpdateUserCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.orderApprovalTypeId = _data["orderApprovalTypeId"];
            this.isDefaultFired = _data["isDefaultFired"];
            this.customerThemeId = _data["customerThemeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateUserCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["orderApprovalTypeId"] = this.orderApprovalTypeId;
        data["isDefaultFired"] = this.isDefaultFired;
        data["customerThemeId"] = this.customerThemeId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateUserCustomerDto {
        const json = this.toJSON();
        let result = new UpdateUserCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCustomerDto {
    userId: number | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    orderApprovalTypeId: number | undefined;
    isDefaultFired: boolean | undefined;
    customerThemeId: number | undefined;
    id: number | undefined;
}

export class OrderFormAuthorizationDto implements IOrderFormAuthorizationDto {
    formId: number | undefined;
    formName: string | undefined;
    formDescription: string | undefined;
    isChecked: boolean | undefined;
    readonly selectedShipmentTypesIds: number[] | undefined;
    shipmentTypes: OrderFormAuthorizationShipmentTypesDto[] | undefined;
    warehouses: OrderFormAuthorizationWarehousesDto[] | undefined;
    readonly selectedWarehousesIds: number[] | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;

    constructor(data?: IOrderFormAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formName = _data["formName"];
            this.formDescription = _data["formDescription"];
            this.isChecked = _data["isChecked"];
            if (Array.isArray(_data["selectedShipmentTypesIds"])) {
                (<any>this).selectedShipmentTypesIds = [] as any;
                for (let item of _data["selectedShipmentTypesIds"])
                    (<any>this).selectedShipmentTypesIds.push(item);
            }
            if (Array.isArray(_data["shipmentTypes"])) {
                this.shipmentTypes = [] as any;
                for (let item of _data["shipmentTypes"])
                    this.shipmentTypes.push(OrderFormAuthorizationShipmentTypesDto.fromJS(item));
            }
            if (Array.isArray(_data["warehouses"])) {
                this.warehouses = [] as any;
                for (let item of _data["warehouses"])
                    this.warehouses.push(OrderFormAuthorizationWarehousesDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedWarehousesIds"])) {
                (<any>this).selectedWarehousesIds = [] as any;
                for (let item of _data["selectedWarehousesIds"])
                    (<any>this).selectedWarehousesIds.push(item);
            }
            this.isOrderDamagedProduct = _data["isOrderDamagedProduct"];
            this.isOrderByExpirationDate = _data["isOrderByExpirationDate"];
            this.isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.isOrderByBusinessUnit = _data["isOrderByBusinessUnit"];
        }
    }

    static fromJS(data: any): OrderFormAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formName"] = this.formName;
        data["formDescription"] = this.formDescription;
        data["isChecked"] = this.isChecked;
        if (Array.isArray(this.selectedShipmentTypesIds)) {
            data["selectedShipmentTypesIds"] = [];
            for (let item of this.selectedShipmentTypesIds)
                data["selectedShipmentTypesIds"].push(item);
        }
        if (Array.isArray(this.shipmentTypes)) {
            data["shipmentTypes"] = [];
            for (let item of this.shipmentTypes)
                data["shipmentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.warehouses)) {
            data["warehouses"] = [];
            for (let item of this.warehouses)
                data["warehouses"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedWarehousesIds)) {
            data["selectedWarehousesIds"] = [];
            for (let item of this.selectedWarehousesIds)
                data["selectedWarehousesIds"].push(item);
        }
        data["isOrderDamagedProduct"] = this.isOrderDamagedProduct;
        data["isOrderByExpirationDate"] = this.isOrderByExpirationDate;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["isOrderByBusinessUnit"] = this.isOrderByBusinessUnit;
        return data; 
    }

    clone(): OrderFormAuthorizationDto {
        const json = this.toJSON();
        let result = new OrderFormAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFormAuthorizationDto {
    formId: number | undefined;
    formName: string | undefined;
    formDescription: string | undefined;
    isChecked: boolean | undefined;
    selectedShipmentTypesIds: number[] | undefined;
    shipmentTypes: OrderFormAuthorizationShipmentTypesDto[] | undefined;
    warehouses: OrderFormAuthorizationWarehousesDto[] | undefined;
    selectedWarehousesIds: number[] | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
}

export class OrderFormAuthorizationShipmentTypesDto implements IOrderFormAuthorizationShipmentTypesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    shipmentTypeId: number | undefined;
    shipmentTypeName: string | undefined;

    constructor(data?: IOrderFormAuthorizationShipmentTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChecked = _data["isChecked"];
            this.isDisabled = _data["isDisabled"];
            this.shipmentTypeId = _data["shipmentTypeId"];
            this.shipmentTypeName = _data["shipmentTypeName"];
        }
    }

    static fromJS(data: any): OrderFormAuthorizationShipmentTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormAuthorizationShipmentTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChecked"] = this.isChecked;
        data["isDisabled"] = this.isDisabled;
        data["shipmentTypeId"] = this.shipmentTypeId;
        data["shipmentTypeName"] = this.shipmentTypeName;
        return data; 
    }

    clone(): OrderFormAuthorizationShipmentTypesDto {
        const json = this.toJSON();
        let result = new OrderFormAuthorizationShipmentTypesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFormAuthorizationShipmentTypesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    shipmentTypeId: number | undefined;
    shipmentTypeName: string | undefined;
}

export class OrderFormAuthorizationWarehousesDto implements IOrderFormAuthorizationWarehousesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerIds: number[] | undefined;

    constructor(data?: IOrderFormAuthorizationWarehousesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChecked = _data["isChecked"];
            this.isDisabled = _data["isDisabled"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds.push(item);
            }
        }
    }

    static fromJS(data: any): OrderFormAuthorizationWarehousesDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderFormAuthorizationWarehousesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChecked"] = this.isChecked;
        data["isDisabled"] = this.isDisabled;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        return data; 
    }

    clone(): OrderFormAuthorizationWarehousesDto {
        const json = this.toJSON();
        let result = new OrderFormAuthorizationWarehousesDto();
        result.init(json);
        return result;
    }
}

export interface IOrderFormAuthorizationWarehousesDto {
    isChecked: boolean | undefined;
    isDisabled: boolean | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerIds: number[] | undefined;
}

export class CreateUserFormsDto implements ICreateUserFormsDto {
    userCustomerId: number | undefined;
    selectedOrderForms: UserFormsAssignedDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCustomerId = _data["userCustomerId"];
            if (Array.isArray(_data["selectedOrderForms"])) {
                this.selectedOrderForms = [] as any;
                for (let item of _data["selectedOrderForms"])
                    this.selectedOrderForms.push(UserFormsAssignedDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCustomerId"] = this.userCustomerId;
        if (Array.isArray(this.selectedOrderForms)) {
            data["selectedOrderForms"] = [];
            for (let item of this.selectedOrderForms)
                data["selectedOrderForms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserFormsDto {
        const json = this.toJSON();
        let result = new CreateUserFormsDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserFormsDto {
    userCustomerId: number | undefined;
    selectedOrderForms: UserFormsAssignedDto[] | undefined;
    id: number | undefined;
}

export class UserFormsAssignedDto implements IUserFormsAssignedDto {
    formId: number | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
    shipmenTypeIds: number[] | undefined;
    warehouseIds: number[] | undefined;

    constructor(data?: IUserFormsAssignedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.isOrderDamagedProduct = _data["isOrderDamagedProduct"];
            this.isOrderByExpirationDate = _data["isOrderByExpirationDate"];
            this.isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.isOrderByBusinessUnit = _data["isOrderByBusinessUnit"];
            if (Array.isArray(_data["shipmenTypeIds"])) {
                this.shipmenTypeIds = [] as any;
                for (let item of _data["shipmenTypeIds"])
                    this.shipmenTypeIds.push(item);
            }
            if (Array.isArray(_data["warehouseIds"])) {
                this.warehouseIds = [] as any;
                for (let item of _data["warehouseIds"])
                    this.warehouseIds.push(item);
            }
        }
    }

    static fromJS(data: any): UserFormsAssignedDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormsAssignedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["isOrderDamagedProduct"] = this.isOrderDamagedProduct;
        data["isOrderByExpirationDate"] = this.isOrderByExpirationDate;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["isOrderByBusinessUnit"] = this.isOrderByBusinessUnit;
        if (Array.isArray(this.shipmenTypeIds)) {
            data["shipmenTypeIds"] = [];
            for (let item of this.shipmenTypeIds)
                data["shipmenTypeIds"].push(item);
        }
        if (Array.isArray(this.warehouseIds)) {
            data["warehouseIds"] = [];
            for (let item of this.warehouseIds)
                data["warehouseIds"].push(item);
        }
        return data; 
    }

    clone(): UserFormsAssignedDto {
        const json = this.toJSON();
        let result = new UserFormsAssignedDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormsAssignedDto {
    formId: number | undefined;
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
    shipmenTypeIds: number[] | undefined;
    warehouseIds: number[] | undefined;
}

export class ShipmentTypeDto implements IShipmentTypeDto {
    name: string | undefined;
    isDefault: boolean | undefined;
    localizationKey: string | undefined;
    id: number | undefined;

    constructor(data?: IShipmentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.localizationKey = _data["localizationKey"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ShipmentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShipmentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["localizationKey"] = this.localizationKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): ShipmentTypeDto {
        const json = this.toJSON();
        let result = new ShipmentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IShipmentTypeDto {
    name: string | undefined;
    isDefault: boolean | undefined;
    localizationKey: string | undefined;
    id: number | undefined;
}

export class OrderCardDto implements IOrderCardDto {
    id: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    buttonTitle: string | undefined;
    icon: string | undefined;
    isVisible: boolean | undefined;
    relatedFormIds: number[] | undefined;

    constructor(data?: IOrderCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.description = _data["description"];
            this.buttonTitle = _data["buttonTitle"];
            this.icon = _data["icon"];
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["relatedFormIds"])) {
                this.relatedFormIds = [] as any;
                for (let item of _data["relatedFormIds"])
                    this.relatedFormIds.push(item);
            }
        }
    }

    static fromJS(data: any): OrderCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["description"] = this.description;
        data["buttonTitle"] = this.buttonTitle;
        data["icon"] = this.icon;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.relatedFormIds)) {
            data["relatedFormIds"] = [];
            for (let item of this.relatedFormIds)
                data["relatedFormIds"].push(item);
        }
        return data; 
    }

    clone(): OrderCardDto {
        const json = this.toJSON();
        let result = new OrderCardDto();
        result.init(json);
        return result;
    }
}

export interface IOrderCardDto {
    id: number | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    buttonTitle: string | undefined;
    icon: string | undefined;
    isVisible: boolean | undefined;
    relatedFormIds: number[] | undefined;
}

export class UserFormOrderFormTypeDto implements IUserFormOrderFormTypeDto {
    id: number | undefined;
    name: string | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    buttonTitle: string | undefined;
    readonly formComponentName: string | undefined;

    constructor(data?: IUserFormOrderFormTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.subTitle = _data["subTitle"];
            this.description = _data["description"];
            this.icon = _data["icon"];
            this.buttonTitle = _data["buttonTitle"];
            (<any>this).formComponentName = _data["formComponentName"];
        }
    }

    static fromJS(data: any): UserFormOrderFormTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormOrderFormTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title;
        data["subTitle"] = this.subTitle;
        data["description"] = this.description;
        data["icon"] = this.icon;
        data["buttonTitle"] = this.buttonTitle;
        data["formComponentName"] = this.formComponentName;
        return data; 
    }

    clone(): UserFormOrderFormTypeDto {
        const json = this.toJSON();
        let result = new UserFormOrderFormTypeDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormOrderFormTypeDto {
    id: number | undefined;
    name: string | undefined;
    title: string | undefined;
    subTitle: string | undefined;
    description: string | undefined;
    icon: string | undefined;
    buttonTitle: string | undefined;
    formComponentName: string | undefined;
}

export class UserFormOrderFormTypeAuthDto implements IUserFormOrderFormTypeAuthDto {
    userHasAuth: boolean | undefined;
    form: UserFormOrderFormTypeDto | undefined;

    constructor(data?: IUserFormOrderFormTypeAuthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userHasAuth = _data["userHasAuth"];
            this.form = _data["form"] ? UserFormOrderFormTypeDto.fromJS(_data["form"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserFormOrderFormTypeAuthDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormOrderFormTypeAuthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userHasAuth"] = this.userHasAuth;
        data["form"] = this.form ? this.form.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UserFormOrderFormTypeAuthDto {
        const json = this.toJSON();
        let result = new UserFormOrderFormTypeAuthDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormOrderFormTypeAuthDto {
    userHasAuth: boolean | undefined;
    form: UserFormOrderFormTypeDto | undefined;
}

export class UserFormsDto implements IUserFormsDto {
    id: number | undefined;

    constructor(data?: IUserFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): UserFormsDto {
        const json = this.toJSON();
        let result = new UserFormsDto();
        result.init(json);
        return result;
    }
}

export interface IUserFormsDto {
    id: number | undefined;
}

export class PagedResultDtoOfUserFormsDto implements IPagedResultDtoOfUserFormsDto {
    totalCount: number | undefined;
    items: UserFormsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserFormsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserFormsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserFormsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserFormsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserFormsDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserFormsDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserFormsDto {
    totalCount: number | undefined;
    items: UserFormsDto[] | undefined;
}

export class PagedResultDtoOfUserManagementSummaryDto implements IPagedResultDtoOfUserManagementSummaryDto {
    totalCount: number | undefined;
    items: UserManagementSummaryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserManagementSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserManagementSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserManagementSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserManagementSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserManagementSummaryDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserManagementSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserManagementSummaryDto {
    totalCount: number | undefined;
    items: UserManagementSummaryDto[] | undefined;
}

export class UserManagementSummaryDto implements IUserManagementSummaryDto {
    sectionName: string | undefined;
    content: string | undefined;
    id: number | undefined;

    constructor(data?: IUserManagementSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionName = _data["sectionName"];
            this.content = _data["content"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserManagementSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserManagementSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionName"] = this.sectionName;
        data["content"] = this.content;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserManagementSummaryDto {
        const json = this.toJSON();
        let result = new UserManagementSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IUserManagementSummaryDto {
    sectionName: string | undefined;
    content: string | undefined;
    id: number | undefined;
}

export class CreateUserManagementSummaryDto implements ICreateUserManagementSummaryDto {

    constructor(data?: ICreateUserManagementSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateUserManagementSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserManagementSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): CreateUserManagementSummaryDto {
        const json = this.toJSON();
        let result = new CreateUserManagementSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserManagementSummaryDto {
}

export class PagedResultDtoOfUserModuleDto implements IPagedResultDtoOfUserModuleDto {
    totalCount: number | undefined;
    items: UserModuleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserModuleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserModuleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserModuleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserModuleDto {
    totalCount: number | undefined;
    items: UserModuleDto[] | undefined;
}

export class UserModuleDto implements IUserModuleDto {
    userId: number | undefined;
    userName: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.isChecked = _data["isChecked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["isChecked"] = this.isChecked;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserModuleDto {
        const json = this.toJSON();
        let result = new UserModuleDto();
        result.init(json);
        return result;
    }
}

export interface IUserModuleDto {
    userId: number | undefined;
    userName: string | undefined;
    moduleId: number | undefined;
    moduleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;
}

export class CreateUserModuleDto implements ICreateUserModuleDto {
    id: number | undefined;

    constructor(data?: ICreateUserModuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserModuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserModuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserModuleDto {
        const json = this.toJSON();
        let result = new CreateUserModuleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserModuleDto {
    id: number | undefined;
}

export class ModulePageDto implements IModulePageDto {
    moduleId: number | undefined;
    moduleName: string | undefined;
    pageAuthorizations: PageAuthorizationDto[] | undefined;

    constructor(data?: IModulePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            if (Array.isArray(_data["pageAuthorizations"])) {
                this.pageAuthorizations = [] as any;
                for (let item of _data["pageAuthorizations"])
                    this.pageAuthorizations.push(PageAuthorizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModulePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModulePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        if (Array.isArray(this.pageAuthorizations)) {
            data["pageAuthorizations"] = [];
            for (let item of this.pageAuthorizations)
                data["pageAuthorizations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ModulePageDto {
        const json = this.toJSON();
        let result = new ModulePageDto();
        result.init(json);
        return result;
    }
}

export interface IModulePageDto {
    moduleId: number | undefined;
    moduleName: string | undefined;
    pageAuthorizations: PageAuthorizationDto[] | undefined;
}

export class PageAuthorizationDto implements IPageAuthorizationDto {
    pageId: number | undefined;
    pageName: string | undefined;
    pageUrl: string | undefined;
    pageLocalizationKey: string | undefined;
    isChecked: boolean | undefined;
    isDefault: boolean | undefined;
    isDisable: boolean | undefined;
    readonly isAuthorizeWithoutSubPage: boolean | undefined;
    readonly subPageAuthorizationIds: number[] | undefined;
    subPageAuthorizations: PageAuthorizationDto[] | undefined;

    constructor(data?: IPageAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
            this.pageName = _data["pageName"];
            this.pageUrl = _data["pageUrl"];
            this.pageLocalizationKey = _data["pageLocalizationKey"];
            this.isChecked = _data["isChecked"];
            this.isDefault = _data["isDefault"];
            this.isDisable = _data["isDisable"];
            (<any>this).isAuthorizeWithoutSubPage = _data["isAuthorizeWithoutSubPage"];
            if (Array.isArray(_data["subPageAuthorizationIds"])) {
                (<any>this).subPageAuthorizationIds = [] as any;
                for (let item of _data["subPageAuthorizationIds"])
                    (<any>this).subPageAuthorizationIds.push(item);
            }
            if (Array.isArray(_data["subPageAuthorizations"])) {
                this.subPageAuthorizations = [] as any;
                for (let item of _data["subPageAuthorizations"])
                    this.subPageAuthorizations.push(PageAuthorizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PageAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        data["pageName"] = this.pageName;
        data["pageUrl"] = this.pageUrl;
        data["pageLocalizationKey"] = this.pageLocalizationKey;
        data["isChecked"] = this.isChecked;
        data["isDefault"] = this.isDefault;
        data["isDisable"] = this.isDisable;
        data["isAuthorizeWithoutSubPage"] = this.isAuthorizeWithoutSubPage;
        if (Array.isArray(this.subPageAuthorizationIds)) {
            data["subPageAuthorizationIds"] = [];
            for (let item of this.subPageAuthorizationIds)
                data["subPageAuthorizationIds"].push(item);
        }
        if (Array.isArray(this.subPageAuthorizations)) {
            data["subPageAuthorizations"] = [];
            for (let item of this.subPageAuthorizations)
                data["subPageAuthorizations"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PageAuthorizationDto {
        const json = this.toJSON();
        let result = new PageAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IPageAuthorizationDto {
    pageId: number | undefined;
    pageName: string | undefined;
    pageUrl: string | undefined;
    pageLocalizationKey: string | undefined;
    isChecked: boolean | undefined;
    isDefault: boolean | undefined;
    isDisable: boolean | undefined;
    isAuthorizeWithoutSubPage: boolean | undefined;
    subPageAuthorizationIds: number[] | undefined;
    subPageAuthorizations: PageAuthorizationDto[] | undefined;
}

export class UserPagesDto implements IUserPagesDto {
    id: number | undefined;

    constructor(data?: IUserPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): UserPagesDto {
        const json = this.toJSON();
        let result = new UserPagesDto();
        result.init(json);
        return result;
    }
}

export interface IUserPagesDto {
    id: number | undefined;
}

export class PagedResultDtoOfUserPagesDto implements IPagedResultDtoOfUserPagesDto {
    totalCount: number | undefined;
    items: UserPagesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserPagesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserPagesDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserPagesDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserPagesDto {
    totalCount: number | undefined;
    items: UserPagesDto[] | undefined;
}

export class CreateUserPagesDto implements ICreateUserPagesDto {
    userId: number | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserPagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["assignedPages"])) {
                this.assignedPages = [] as any;
                for (let item of _data["assignedPages"])
                    this.assignedPages.push(UserSelectedPagesDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserPagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserPagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.assignedPages)) {
            data["assignedPages"] = [];
            for (let item of this.assignedPages)
                data["assignedPages"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserPagesDto {
        const json = this.toJSON();
        let result = new CreateUserPagesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserPagesDto {
    userId: number | undefined;
    assignedPages: UserSelectedPagesDto[] | undefined;
    id: number | undefined;
}

export class PagedUserPermissionAddressDto implements IPagedUserPermissionAddressDto {
    searchTerm: string | undefined;
    addresses: UserPermissionAddressDto[] | undefined;

    constructor(data?: IPagedUserPermissionAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses.push(UserPermissionAddressDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedUserPermissionAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedUserPermissionAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedUserPermissionAddressDto {
        const json = this.toJSON();
        let result = new PagedUserPermissionAddressDto();
        result.init(json);
        return result;
    }
}

export interface IPagedUserPermissionAddressDto {
    searchTerm: string | undefined;
    addresses: UserPermissionAddressDto[] | undefined;
}

export class UserPermissionAddressDto implements IUserPermissionAddressDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    isSelected: boolean | undefined;

    constructor(data?: IUserPermissionAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullAddress = _data["fullAddress"];
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): UserPermissionAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullAddress"] = this.fullAddress;
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["isSelected"] = this.isSelected;
        return data; 
    }

    clone(): UserPermissionAddressDto {
        const json = this.toJSON();
        let result = new UserPermissionAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionAddressDto {
    id: number | undefined;
    name: string | undefined;
    fullAddress: string | undefined;
    cityId: number | undefined;
    cityName: string | undefined;
    districtId: number | undefined;
    districtName: string | undefined;
    isSelected: boolean | undefined;
}

export class ToRequestCityDto implements IToRequestCityDto {
    cityId: number | undefined;
    cityName: string | undefined;

    constructor(data?: IToRequestCityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.cityName = _data["cityName"];
        }
    }

    static fromJS(data: any): ToRequestCityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToRequestCityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["cityName"] = this.cityName;
        return data; 
    }

    clone(): ToRequestCityDto {
        const json = this.toJSON();
        let result = new ToRequestCityDto();
        result.init(json);
        return result;
    }
}

export interface IToRequestCityDto {
    cityId: number | undefined;
    cityName: string | undefined;
}

export class UserPermissionCityDistrictDto implements IUserPermissionCityDistrictDto {
    cities: ToRequestCityDto[] | undefined;
    districts: ToRequestDistrictDto[] | undefined;

    constructor(data?: IUserPermissionCityDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities.push(ToRequestCityDto.fromJS(item));
            }
            if (Array.isArray(_data["districts"])) {
                this.districts = [] as any;
                for (let item of _data["districts"])
                    this.districts.push(ToRequestDistrictDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPermissionCityDistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionCityDistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            for (let item of this.districts)
                data["districts"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserPermissionCityDistrictDto {
        const json = this.toJSON();
        let result = new UserPermissionCityDistrictDto();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionCityDistrictDto {
    cities: ToRequestCityDto[] | undefined;
    districts: ToRequestDistrictDto[] | undefined;
}

export class ToRequestDistrictDto implements IToRequestDistrictDto {
    districtId: number | undefined;
    districtName: string | undefined;
    cityId: number | undefined;

    constructor(data?: IToRequestDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtId = _data["districtId"];
            this.districtName = _data["districtName"];
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): ToRequestDistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new ToRequestDistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtId"] = this.districtId;
        data["districtName"] = this.districtName;
        data["cityId"] = this.cityId;
        return data; 
    }

    clone(): ToRequestDistrictDto {
        const json = this.toJSON();
        let result = new ToRequestDistrictDto();
        result.init(json);
        return result;
    }
}

export interface IToRequestDistrictDto {
    districtId: number | undefined;
    districtName: string | undefined;
    cityId: number | undefined;
}

export class UserPermissionFormAuthorizationDto implements IUserPermissionFormAuthorizationDto {
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;

    constructor(data?: IUserPermissionFormAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isOrderDamagedProduct = _data["isOrderDamagedProduct"];
            this.isOrderByExpirationDate = _data["isOrderByExpirationDate"];
            this.isOrderBySpecialCode = _data["isOrderBySpecialCode"];
            this.isOrderByBusinessUnit = _data["isOrderByBusinessUnit"];
        }
    }

    static fromJS(data: any): UserPermissionFormAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionFormAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isOrderDamagedProduct"] = this.isOrderDamagedProduct;
        data["isOrderByExpirationDate"] = this.isOrderByExpirationDate;
        data["isOrderBySpecialCode"] = this.isOrderBySpecialCode;
        data["isOrderByBusinessUnit"] = this.isOrderByBusinessUnit;
        return data; 
    }

    clone(): UserPermissionFormAuthorizationDto {
        const json = this.toJSON();
        let result = new UserPermissionFormAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionFormAuthorizationDto {
    isOrderDamagedProduct: boolean | undefined;
    isOrderByExpirationDate: boolean | undefined;
    isOrderBySpecialCode: boolean | undefined;
    isOrderByBusinessUnit: boolean | undefined;
}

export class UserOtherSettingsDto implements IUserOtherSettingsDto {
    userCustomerId: number | undefined;
    customerName: string | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    isOnlyWmsProducts: boolean | undefined;
    isSpecialCodeStockView: boolean | undefined;
    isRequestListStockView: boolean | undefined;
    isShowPalletQuantity: boolean | undefined;
    isShowTotalShipmentPrice: boolean | undefined;

    constructor(data?: IUserOtherSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCustomerId = _data["userCustomerId"];
            this.customerName = _data["customerName"];
            this.titleName = _data["titleName"];
            this.isStockView = _data["isStockView"];
            this.isProductLocationOrderHistoryView = _data["isProductLocationOrderHistoryView"];
            this.isOnlyWmsProducts = _data["isOnlyWmsProducts"];
            this.isSpecialCodeStockView = _data["isSpecialCodeStockView"];
            this.isRequestListStockView = _data["isRequestListStockView"];
            this.isShowPalletQuantity = _data["isShowPalletQuantity"];
            this.isShowTotalShipmentPrice = _data["isShowTotalShipmentPrice"];
        }
    }

    static fromJS(data: any): UserOtherSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOtherSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCustomerId"] = this.userCustomerId;
        data["customerName"] = this.customerName;
        data["titleName"] = this.titleName;
        data["isStockView"] = this.isStockView;
        data["isProductLocationOrderHistoryView"] = this.isProductLocationOrderHistoryView;
        data["isOnlyWmsProducts"] = this.isOnlyWmsProducts;
        data["isSpecialCodeStockView"] = this.isSpecialCodeStockView;
        data["isRequestListStockView"] = this.isRequestListStockView;
        data["isShowPalletQuantity"] = this.isShowPalletQuantity;
        data["isShowTotalShipmentPrice"] = this.isShowTotalShipmentPrice;
        return data; 
    }

    clone(): UserOtherSettingsDto {
        const json = this.toJSON();
        let result = new UserOtherSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IUserOtherSettingsDto {
    userCustomerId: number | undefined;
    customerName: string | undefined;
    titleName: string | undefined;
    isStockView: boolean | undefined;
    isProductLocationOrderHistoryView: boolean | undefined;
    isOnlyWmsProducts: boolean | undefined;
    isSpecialCodeStockView: boolean | undefined;
    isRequestListStockView: boolean | undefined;
    isShowPalletQuantity: boolean | undefined;
    isShowTotalShipmentPrice: boolean | undefined;
}

export class PagedResultDtoOfUserProductAttributeDto implements IPagedResultDtoOfUserProductAttributeDto {
    totalCount: number | undefined;
    items: UserProductAttributeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserProductAttributeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserProductAttributeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserProductAttributeDto {
    totalCount: number | undefined;
    items: UserProductAttributeDto[] | undefined;
}

export class UserProductAttributeDto implements IUserProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    customerName: string | undefined;
    productAttributeId: number | undefined;
    id: number | undefined;

    constructor(data?: IUserProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attributeType = _data["attributeType"];
            this.customerName = _data["customerName"];
            this.productAttributeId = _data["productAttributeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attributeType"] = this.attributeType;
        data["customerName"] = this.customerName;
        data["productAttributeId"] = this.productAttributeId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserProductAttributeDto {
        const json = this.toJSON();
        let result = new UserProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface IUserProductAttributeDto {
    name: string | undefined;
    attributeType: string | undefined;
    customerName: string | undefined;
    productAttributeId: number | undefined;
    id: number | undefined;
}

export class CreateUserProductAttributeDto implements ICreateUserProductAttributeDto {
    name: string | undefined;
    userId: number | undefined;
    productAttributeIds: number[] | undefined;
    authorizationId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserProductAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["productAttributeIds"])) {
                this.productAttributeIds = [] as any;
                for (let item of _data["productAttributeIds"])
                    this.productAttributeIds.push(item);
            }
            this.authorizationId = _data["authorizationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserProductAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserProductAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        if (Array.isArray(this.productAttributeIds)) {
            data["productAttributeIds"] = [];
            for (let item of this.productAttributeIds)
                data["productAttributeIds"].push(item);
        }
        data["authorizationId"] = this.authorizationId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserProductAttributeDto {
        const json = this.toJSON();
        let result = new CreateUserProductAttributeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserProductAttributeDto {
    name: string | undefined;
    userId: number | undefined;
    productAttributeIds: number[] | undefined;
    authorizationId: number | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserReportDto implements IPagedResultDtoOfUserReportDto {
    totalCount: number | undefined;
    items: UserReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserReportDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserReportDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserReportDto {
    totalCount: number | undefined;
    items: UserReportDto[] | undefined;
}

export class UserReportDto implements IUserReportDto {
    reportId: number | undefined;
    reportName: string | undefined;
    reportTitle: string | undefined;
    reportSubTitle: string | undefined;
    reportDescription: string | undefined;
    reportButtonTitle: string | undefined;
    reportButtonColor: string | undefined;
    reportIconUrl: string | undefined;
    sortIndex: number | undefined;
    moduleId: number | undefined;
    dashboardNumber: number | undefined;
    dashboardNumberEN: number | undefined;
    isOpenNewScreen: boolean | undefined;
    isDynamicDesign: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportName = _data["reportName"];
            this.reportTitle = _data["reportTitle"];
            this.reportSubTitle = _data["reportSubTitle"];
            this.reportDescription = _data["reportDescription"];
            this.reportButtonTitle = _data["reportButtonTitle"];
            this.reportButtonColor = _data["reportButtonColor"];
            this.reportIconUrl = _data["reportIconUrl"];
            this.sortIndex = _data["sortIndex"];
            this.moduleId = _data["moduleId"];
            this.dashboardNumber = _data["dashboardNumber"];
            this.dashboardNumberEN = _data["dashboardNumberEN"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
            this.isDynamicDesign = _data["isDynamicDesign"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportName"] = this.reportName;
        data["reportTitle"] = this.reportTitle;
        data["reportSubTitle"] = this.reportSubTitle;
        data["reportDescription"] = this.reportDescription;
        data["reportButtonTitle"] = this.reportButtonTitle;
        data["reportButtonColor"] = this.reportButtonColor;
        data["reportIconUrl"] = this.reportIconUrl;
        data["sortIndex"] = this.sortIndex;
        data["moduleId"] = this.moduleId;
        data["dashboardNumber"] = this.dashboardNumber;
        data["dashboardNumberEN"] = this.dashboardNumberEN;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        data["isDynamicDesign"] = this.isDynamicDesign;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserReportDto {
        const json = this.toJSON();
        let result = new UserReportDto();
        result.init(json);
        return result;
    }
}

export interface IUserReportDto {
    reportId: number | undefined;
    reportName: string | undefined;
    reportTitle: string | undefined;
    reportSubTitle: string | undefined;
    reportDescription: string | undefined;
    reportButtonTitle: string | undefined;
    reportButtonColor: string | undefined;
    reportIconUrl: string | undefined;
    sortIndex: number | undefined;
    moduleId: number | undefined;
    dashboardNumber: number | undefined;
    dashboardNumberEN: number | undefined;
    isOpenNewScreen: boolean | undefined;
    isDynamicDesign: boolean | undefined;
    id: number | undefined;
}

export class CreateUserReportDto implements ICreateUserReportDto {
    name: string | undefined;
    userId: number | undefined;
    reportIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserReportDto {
        const json = this.toJSON();
        let result = new CreateUserReportDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserReportDto {
    name: string | undefined;
    userId: number | undefined;
    reportIds: number[] | undefined;
    id: number | undefined;
}

export class UserReportOpenNewScreenDto implements IUserReportOpenNewScreenDto {
    userReportId: number;
    isOpenNewScreen: boolean;

    constructor(data?: IUserReportOpenNewScreenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userReportId = _data["userReportId"];
            this.isOpenNewScreen = _data["isOpenNewScreen"];
        }
    }

    static fromJS(data: any): UserReportOpenNewScreenDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportOpenNewScreenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userReportId"] = this.userReportId;
        data["isOpenNewScreen"] = this.isOpenNewScreen;
        return data; 
    }

    clone(): UserReportOpenNewScreenDto {
        const json = this.toJSON();
        let result = new UserReportOpenNewScreenDto();
        result.init(json);
        return result;
    }
}

export interface IUserReportOpenNewScreenDto {
    userReportId: number;
    isOpenNewScreen: boolean;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.isChecked = _data["isChecked"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["isChecked"] = this.isChecked;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserRoleDto {
        const json = this.toJSON();
        let result = new UserRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUserRoleDto {
    roleId: number | undefined;
    roleName: string | undefined;
    isChecked: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserRoleDto implements IPagedResultDtoOfUserRoleDto {
    totalCount: number | undefined;
    items: UserRoleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserRoleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserRoleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserRoleDto {
    totalCount: number | undefined;
    items: UserRoleDto[] | undefined;
}

export class CreateUserRoleDto implements ICreateUserRoleDto {
    id: number | undefined;

    constructor(data?: ICreateUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserRoleDto {
        const json = this.toJSON();
        let result = new CreateUserRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserRoleDto {
    id: number | undefined;
}

export class PagedResultDtoOfUserRouteStartLocationDto implements IPagedResultDtoOfUserRouteStartLocationDto {
    totalCount: number | undefined;
    items: UserRouteStartLocationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserRouteStartLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserRouteStartLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserRouteStartLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserRouteStartLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserRouteStartLocationDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserRouteStartLocationDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserRouteStartLocationDto {
    totalCount: number | undefined;
    items: UserRouteStartLocationDto[] | undefined;
}

export class UserRouteStartLocationDto implements IUserRouteStartLocationDto {
    userId: number | undefined;
    locationName: string | undefined;
    lat: number | undefined;
    lng: number | undefined;
    id: number | undefined;

    constructor(data?: IUserRouteStartLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.locationName = _data["locationName"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserRouteStartLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRouteStartLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["locationName"] = this.locationName;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserRouteStartLocationDto {
        const json = this.toJSON();
        let result = new UserRouteStartLocationDto();
        result.init(json);
        return result;
    }
}

export interface IUserRouteStartLocationDto {
    userId: number | undefined;
    locationName: string | undefined;
    lat: number | undefined;
    lng: number | undefined;
    id: number | undefined;
}

export class CreateUserRouteStartLocationDto implements ICreateUserRouteStartLocationDto {
    userId: number;
    locationName: string;
    lat: number;
    lng: number;
    id: number | undefined;

    constructor(data?: ICreateUserRouteStartLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.locationName = _data["locationName"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserRouteStartLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRouteStartLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["locationName"] = this.locationName;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserRouteStartLocationDto {
        const json = this.toJSON();
        let result = new CreateUserRouteStartLocationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserRouteStartLocationDto {
    userId: number;
    locationName: string;
    lat: number;
    lng: number;
    id: number | undefined;
}

export class CustomerWarehouseDto implements ICustomerWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    warehousePermissions: WarehousePermissionDto[] | undefined;
    isAuthorized: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICustomerWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            if (Array.isArray(_data["warehousePermissions"])) {
                this.warehousePermissions = [] as any;
                for (let item of _data["warehousePermissions"])
                    this.warehousePermissions.push(WarehousePermissionDto.fromJS(item));
            }
            this.isAuthorized = _data["isAuthorized"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CustomerWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        if (Array.isArray(this.warehousePermissions)) {
            data["warehousePermissions"] = [];
            for (let item of this.warehousePermissions)
                data["warehousePermissions"].push(item.toJSON());
        }
        data["isAuthorized"] = this.isAuthorized;
        data["id"] = this.id;
        return data; 
    }

    clone(): CustomerWarehouseDto {
        const json = this.toJSON();
        let result = new CustomerWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    warehousePermissions: WarehousePermissionDto[] | undefined;
    isAuthorized: boolean | undefined;
    id: number | undefined;
}

export class WarehousePermissionDto implements IWarehousePermissionDto {
    name: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    isSelected: boolean | undefined;
    id: number | undefined;

    constructor(data?: IWarehousePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userFriendlyName = _data["userFriendlyName"];
            this.userFriendlyDescription = _data["userFriendlyDescription"];
            this.isSelected = _data["isSelected"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehousePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehousePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userFriendlyName"] = this.userFriendlyName;
        data["userFriendlyDescription"] = this.userFriendlyDescription;
        data["isSelected"] = this.isSelected;
        data["id"] = this.id;
        return data; 
    }

    clone(): WarehousePermissionDto {
        const json = this.toJSON();
        let result = new WarehousePermissionDto();
        result.init(json);
        return result;
    }
}

export interface IWarehousePermissionDto {
    name: string | undefined;
    userFriendlyName: string | undefined;
    userFriendlyDescription: string | undefined;
    isSelected: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserWarehouseDto implements IPagedResultDtoOfUserWarehouseDto {
    totalCount: number | undefined;
    items: UserWarehouseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserWarehouseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserWarehouseDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserWarehouseDto {
    totalCount: number | undefined;
    items: UserWarehouseDto[] | undefined;
}

export class UserWarehouseDto implements IUserWarehouseDto {
    name: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    customerNamesText: string | undefined;
    id: number | undefined;

    constructor(data?: IUserWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.authorizationId = _data["authorizationId"];
            this.authorizationName = _data["authorizationName"];
            this.authorizationDescription = _data["authorizationDescription"];
            this.customerNamesText = _data["customerNamesText"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["authorizationId"] = this.authorizationId;
        data["authorizationName"] = this.authorizationName;
        data["authorizationDescription"] = this.authorizationDescription;
        data["customerNamesText"] = this.customerNamesText;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserWarehouseDto {
        const json = this.toJSON();
        let result = new UserWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IUserWarehouseDto {
    name: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    authorizationId: number | undefined;
    authorizationName: string | undefined;
    authorizationDescription: string | undefined;
    customerNamesText: string | undefined;
    id: number | undefined;
}

export class CreateUserWarehouseDto implements ICreateUserWarehouseDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    warehouseIds: number[] | undefined;
    id: number | undefined;

    constructor(data?: ICreateUserWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userId = _data["userId"];
            this.authorizationId = _data["authorizationId"];
            if (Array.isArray(_data["warehouseIds"])) {
                this.warehouseIds = [] as any;
                for (let item of _data["warehouseIds"])
                    this.warehouseIds.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateUserWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userId"] = this.userId;
        data["authorizationId"] = this.authorizationId;
        if (Array.isArray(this.warehouseIds)) {
            data["warehouseIds"] = [];
            for (let item of this.warehouseIds)
                data["warehouseIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateUserWarehouseDto {
        const json = this.toJSON();
        let result = new CreateUserWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserWarehouseDto {
    name: string | undefined;
    userId: number | undefined;
    authorizationId: number | undefined;
    warehouseIds: number[] | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfWarehouseDto implements IPagedResultDtoOfWarehouseDto {
    totalCount: number | undefined;
    items: WarehouseDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfWarehouseDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWarehouseDto {
    totalCount: number | undefined;
    items: WarehouseDto[] | undefined;
}

export class WarehouseDto implements IWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    remoteWarehouseName: string | undefined;
    readonly customerWarehousesText: string | undefined;
    customerWarehouses: WarehouseCustomerDto[] | undefined;
    id: number | undefined;

    constructor(data?: IWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.remoteWarehouseId = _data["remoteWarehouseId"];
            this.remoteWarehouseName = _data["remoteWarehouseName"];
            (<any>this).customerWarehousesText = _data["customerWarehousesText"];
            if (Array.isArray(_data["customerWarehouses"])) {
                this.customerWarehouses = [] as any;
                for (let item of _data["customerWarehouses"])
                    this.customerWarehouses.push(WarehouseCustomerDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["remoteWarehouseId"] = this.remoteWarehouseId;
        data["remoteWarehouseName"] = this.remoteWarehouseName;
        data["customerWarehousesText"] = this.customerWarehousesText;
        if (Array.isArray(this.customerWarehouses)) {
            data["customerWarehouses"] = [];
            for (let item of this.customerWarehouses)
                data["customerWarehouses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): WarehouseDto {
        const json = this.toJSON();
        let result = new WarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    remoteWarehouseName: string | undefined;
    customerWarehousesText: string | undefined;
    customerWarehouses: WarehouseCustomerDto[] | undefined;
    id: number | undefined;
}

export class WarehouseCustomerDto implements IWarehouseCustomerDto {
    customerId: number | undefined;
    customerName: string | undefined;

    constructor(data?: IWarehouseCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
        }
    }

    static fromJS(data: any): WarehouseCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        return data; 
    }

    clone(): WarehouseCustomerDto {
        const json = this.toJSON();
        let result = new WarehouseCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseCustomerDto {
    customerId: number | undefined;
    customerName: string | undefined;
}

export class DependWarehouseDto implements IDependWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;

    constructor(data?: IDependWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DependWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data; 
    }

    clone(): DependWarehouseDto {
        const json = this.toJSON();
        let result = new DependWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IDependWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    id: number | undefined;
}

export class UpdateWarehouseDto implements IUpdateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    customerId: number | undefined;
    ownerId: number | undefined;
    id: number | undefined;

    constructor(data?: IUpdateWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.remoteWarehouseId = _data["remoteWarehouseId"];
            this.customerId = _data["customerId"];
            this.ownerId = _data["ownerId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["remoteWarehouseId"] = this.remoteWarehouseId;
        data["customerId"] = this.customerId;
        data["ownerId"] = this.ownerId;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateWarehouseDto {
        const json = this.toJSON();
        let result = new UpdateWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    remoteWarehouseId: number | undefined;
    customerId: number | undefined;
    ownerId: number | undefined;
    id: number | undefined;
}

export class CreateWarehouseDto implements ICreateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    comment: string | undefined;
    isRemote: boolean | undefined;
    addressId: number | undefined;
    dependWarehouseId: number | undefined;
    id: number | undefined;

    constructor(data?: ICreateWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.comment = _data["comment"];
            this.isRemote = _data["isRemote"];
            this.addressId = _data["addressId"];
            this.dependWarehouseId = _data["dependWarehouseId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["comment"] = this.comment;
        data["isRemote"] = this.isRemote;
        data["addressId"] = this.addressId;
        data["dependWarehouseId"] = this.dependWarehouseId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateWarehouseDto {
        const json = this.toJSON();
        let result = new CreateWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWarehouseDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    comment: string | undefined;
    isRemote: boolean | undefined;
    addressId: number | undefined;
    dependWarehouseId: number | undefined;
    id: number | undefined;
}

export class ExcelPagedResultDtoOfWarehouseExcelDto implements IExcelPagedResultDtoOfWarehouseExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: WarehouseExcelDto[] | undefined;

    constructor(data?: IExcelPagedResultDtoOfWarehouseExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns.push(ExcelColumn.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseExcelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExcelPagedResultDtoOfWarehouseExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelPagedResultDtoOfWarehouseExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ExcelPagedResultDtoOfWarehouseExcelDto {
        const json = this.toJSON();
        let result = new ExcelPagedResultDtoOfWarehouseExcelDto();
        result.init(json);
        return result;
    }
}

export interface IExcelPagedResultDtoOfWarehouseExcelDto {
    columns: ExcelColumn[] | undefined;
    totalCount: number | undefined;
    items: WarehouseExcelDto[] | undefined;
}

export class WarehouseExcelDto implements IWarehouseExcelDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    comment: string | undefined;
    isDefault: boolean | undefined;
    isDepended: boolean | undefined;
    id: number | undefined;

    constructor(data?: IWarehouseExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.ownerId = _data["ownerId"];
            this.customerId = _data["customerId"];
            this.comment = _data["comment"];
            this.isDefault = _data["isDefault"];
            this.isDepended = _data["isDepended"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["type"] = this.type;
        data["ownerId"] = this.ownerId;
        data["customerId"] = this.customerId;
        data["comment"] = this.comment;
        data["isDefault"] = this.isDefault;
        data["isDepended"] = this.isDepended;
        data["id"] = this.id;
        return data; 
    }

    clone(): WarehouseExcelDto {
        const json = this.toJSON();
        let result = new WarehouseExcelDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseExcelDto {
    name: string | undefined;
    code: string | undefined;
    type: string | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    comment: string | undefined;
    isDefault: boolean | undefined;
    isDepended: boolean | undefined;
    id: number | undefined;
}

export class WarehouseOwnerUserDto implements IWarehouseOwnerUserDto {
    userId: number | undefined;
    userName: string | undefined;
    isOwner: boolean | undefined;

    constructor(data?: IWarehouseOwnerUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.isOwner = _data["isOwner"];
        }
    }

    static fromJS(data: any): WarehouseOwnerUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOwnerUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["isOwner"] = this.isOwner;
        return data; 
    }

    clone(): WarehouseOwnerUserDto {
        const json = this.toJSON();
        let result = new WarehouseOwnerUserDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseOwnerUserDto {
    userId: number | undefined;
    userName: string | undefined;
    isOwner: boolean | undefined;
}

export class PagedResultDtoOfWarehouseOwnerDto implements IPagedResultDtoOfWarehouseOwnerDto {
    totalCount: number | undefined;
    items: WarehouseOwnerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WarehouseOwnerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfWarehouseOwnerDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfWarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfWarehouseOwnerDto {
    totalCount: number | undefined;
    items: WarehouseOwnerDto[] | undefined;
}

export class WarehouseOwnerDto implements IWarehouseOwnerDto {
    ownerId: number | undefined;
    ownerName: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    isOwner: boolean | undefined;
    id: number | undefined;

    constructor(data?: IWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"];
            this.ownerName = _data["ownerName"];
            this.warehouseId = _data["warehouseId"];
            this.warehouseName = _data["warehouseName"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.isOwner = _data["isOwner"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId;
        data["ownerName"] = this.ownerName;
        data["warehouseId"] = this.warehouseId;
        data["warehouseName"] = this.warehouseName;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["isOwner"] = this.isOwner;
        data["id"] = this.id;
        return data; 
    }

    clone(): WarehouseOwnerDto {
        const json = this.toJSON();
        let result = new WarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface IWarehouseOwnerDto {
    ownerId: number | undefined;
    ownerName: string | undefined;
    warehouseId: number | undefined;
    warehouseName: string | undefined;
    customerId: number | undefined;
    customerName: string | undefined;
    isOwner: boolean | undefined;
    id: number | undefined;
}

export class CreateWarehouseOwnerDto implements ICreateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;

    constructor(data?: ICreateWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.ownerId = _data["ownerId"];
            this.customerId = _data["customerId"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["ownerId"] = this.ownerId;
        data["customerId"] = this.customerId;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateWarehouseOwnerDto {
        const json = this.toJSON();
        let result = new CreateWarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isDefault: boolean | undefined;
    id: number | undefined;
}

export class UpdateWarehouseOwnerDto implements IUpdateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUpdateWarehouseOwnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.warehouseId = _data["warehouseId"];
            this.ownerId = _data["ownerId"];
            this.customerId = _data["customerId"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateWarehouseOwnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseOwnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["warehouseId"] = this.warehouseId;
        data["ownerId"] = this.ownerId;
        data["customerId"] = this.customerId;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateWarehouseOwnerDto {
        const json = this.toJSON();
        let result = new UpdateWarehouseOwnerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWarehouseOwnerDto {
    warehouseId: number | undefined;
    ownerId: number | undefined;
    customerId: number | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
}

export enum Table {
    City = <any>"City",
    Address = <any>"Address",
    Warehouse = <any>"Warehouse",
    ProductAttribute = <any>"ProductAttribute",
}

export enum CategoryType {
    Undefined = <any>"Undefined",
    Address_Category = <any>"Address_Category",
    Order_ApprovalStatus = <any>"Order_ApprovalStatus",
    Order_ShipmentType = <any>"Order_ShipmentType",
    Order_Source = <any>"Order_Source",
    Order_Type = <any>"Order_Type",
    Order_SendType = <any>"Order_SendType",
    Warehouse_Category = <any>"Warehouse_Category",
}

export enum TaskType {
    Uretim_Gorevi = <any>"Uretim_Gorevi",
    Tasarim_Gorevi = <any>"Tasarim_Gorevi",
}

export enum UserUnvanType {
    Koordinator = <any>"Koordinator",
    Spv = <any>"Spv",
}

export enum DamageStatusType {
    Damage = <any>"Damage",
    UnDamage = <any>"UnDamage",
    Destruction = <any>"Destruction",
}

export enum DamageStatusType2 {
    Damage = <any>"Damage",
    UnDamage = <any>"UnDamage",
    Destruction = <any>"Destruction",
}

export enum ComponentType {
    None = <any>"None",
    ToRequestWarehouse = <any>"ToRequestWarehouse",
    ToRequestDistributor = <any>"ToRequestDistributor",
    ToRequestSalesStaticLocation = <any>"ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = <any>"FromReceiveMobileWarehouse",
    FromReceiveWarehouse = <any>"FromReceiveWarehouse",
    AddAddressToPersonCategory = <any>"AddAddressToPersonCategory",
    Transfer = <any>"Transfer",
}

export enum DamageStatusType3 {
    Damage = <any>"Damage",
    UnDamage = <any>"UnDamage",
    Destruction = <any>"Destruction",
}

export enum ComponentType2 {
    None = <any>"None",
    ToRequestWarehouse = <any>"ToRequestWarehouse",
    ToRequestDistributor = <any>"ToRequestDistributor",
    ToRequestSalesStaticLocation = <any>"ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = <any>"FromReceiveMobileWarehouse",
    FromReceiveWarehouse = <any>"FromReceiveWarehouse",
    AddAddressToPersonCategory = <any>"AddAddressToPersonCategory",
    Transfer = <any>"Transfer",
}

export enum ComponentType3 {
    None = <any>"None",
    ToRequestWarehouse = <any>"ToRequestWarehouse",
    ToRequestDistributor = <any>"ToRequestDistributor",
    ToRequestSalesStaticLocation = <any>"ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = <any>"FromReceiveMobileWarehouse",
    FromReceiveWarehouse = <any>"FromReceiveWarehouse",
    AddAddressToPersonCategory = <any>"AddAddressToPersonCategory",
    Transfer = <any>"Transfer",
}

export enum IsTenantAvailableOutputState {
    Available = <any>"Available",
    InActive = <any>"InActive",
    NotFound = <any>"NotFound",
}

export enum ResetPasswordRequestInputModule {
    Transpop_Web_Portal = <any>"Transpop_Web_Portal",
    Platom_Portal = <any>"Platom_Portal",
}

export enum CreateMasrafDtoMasrafTipi {
    Normal_Masraf = <any>"Normal_Masraf",
    Is_Avansi = <any>"Is_Avansi",
}

export enum MasrafKalemDtoKdvOrani {
    _0 = <any>"_0",
    _1 = <any>"_1",
    _8 = <any>"_8",
    _18 = <any>"_18",
}

export enum CreateSatinalmaTalepDtoSatinalmaTipi {
    Diger = <any>"Diger",
    Arac_Bakim_Onarim = <any>"Arac_Bakim_Onarim",
}

export enum CreateSatinalmaTalepDtoParaBirimi {
    TL = <any>"TL",
    USD = <any>"USD",
    EUR = <any>"EUR",
}

export enum CreateSatinalmaTalepDtoVade {
    Vade_Yok = <any>"Vade_Yok",
    _30_Gun = <any>"_30_Gun",
    _60_Gun = <any>"_60_Gun",
    _90_Gun = <any>"_90_Gun",
    _120_Gun = <any>"_120_Gun",
}

export enum SatinalmaTalepFaturaBilgiDtoTalepDurum {
    Acik = <any>"Acik",
    Kapatildi = <any>"Kapatildi",
    Muhasebelesti = <any>"Muhasebelesti",
    Talep_Geri_Gonderildi = <any>"Talep_Geri_Gonderildi",
    Iptal_Edildi = <any>"Iptal_Edildi",
}

export enum ReportDataSourceDtoDbModule {
    Platom = <any>"Platom",
    PlatomDwh = <any>"PlatomDwh",
    Transpop = <any>"Transpop",
    WmsNestle = <any>"WmsNestle",
    WmsFerrero = <any>"WmsFerrero",
    WmsPladis = <any>"WmsPladis",
    WmsPg = <any>"WmsPg",
    WmsUnilever = <any>"WmsUnilever",
    WmsGsk = <any>"WmsGsk",
    LogoBordro = <any>"LogoBordro",
    LogoTiger = <any>"LogoTiger",
    Corcial = <any>"Corcial",
}

export enum CreateOrderDtoComponentType {
    None = <any>"None",
    ToRequestWarehouse = <any>"ToRequestWarehouse",
    ToRequestDistributor = <any>"ToRequestDistributor",
    ToRequestSalesStaticLocation = <any>"ToRequestSalesStaticLocation",
    FromReceiveMobileWarehouse = <any>"FromReceiveMobileWarehouse",
    FromReceiveWarehouse = <any>"FromReceiveWarehouse",
    AddAddressToPersonCategory = <any>"AddAddressToPersonCategory",
    Transfer = <any>"Transfer",
}

export enum CreateOrderDtoShipmentType {
    FromWarehouse = <any>"FromWarehouse",
    Cargo = <any>"Cargo",
    Ship = <any>"Ship",
}

export enum CreateOrderDtoProductDamageStatusType {
    Damage = <any>"Damage",
    UnDamage = <any>"UnDamage",
    Destruction = <any>"Destruction",
}

export enum OrderProductTaskDtoApprovedStatus {
    Emtpy = <any>"Emtpy",
    WaitingForApproval = <any>"WaitingForApproval",
    Waiting = <any>"Waiting",
    Approved = <any>"Approved",
    Reject = <any>"Reject",
    Canceled = <any>"Canceled",
    OverStock_Reject = <any>"OverStock_Reject",
    Sent_To_Hangfire = <any>"Sent_To_Hangfire",
    CAP_WarehouseApproved = <any>"CAP_WarehouseApproved",
    CAP_CenterApproved = <any>"CAP_CenterApproved",
    CAP_Waiting = <any>"CAP_Waiting",
    CAP_RegionApproved = <any>"CAP_RegionApproved",
    CAP_Canceled_OverStock = <any>"CAP_Canceled_OverStock",
    CAP_InTransferLocation = <any>"CAP_InTransferLocation",
    CAP_InTransfer = <any>"CAP_InTransfer",
    CAP_ToPrepare = <any>"CAP_ToPrepare",
    CAP_Prepared = <any>"CAP_Prepared",
    CAP_Preparing = <any>"CAP_Preparing",
    CAP_ToReturn = <any>"CAP_ToReturn",
    CAP_AcceptanceOfGoods = <any>"CAP_AcceptanceOfGoods",
    CAP_Approved = <any>"CAP_Approved",
    CAP_RaftanIndirildi = <any>"CAP_RaftanIndirildi",
    CAP_RaftanIndiriliyor = <any>"CAP_RaftanIndiriliyor",
    CAP_OnShipment = <any>"CAP_OnShipment",
    CAP_OrderCancellation = <any>"CAP_OrderCancellation",
    CAP_Completed = <any>"CAP_Completed",
    CAP_OrderNotReceived = <any>"CAP_OrderNotReceived",
    CAP_OrderHasBeenTaken = <any>"CAP_OrderHasBeenTaken",
    CAP_OrderTaking = <any>"CAP_OrderTaking",
    CAP_Delivered = <any>"CAP_Delivered",
    CAP_NotDelivered = <any>"CAP_NotDelivered",
    CAP_Collected = <any>"CAP_Collected",
    CAP_Cancelled = <any>"CAP_Cancelled",
}

export enum OrderApprovalUserDtoApprovalStatusType {
    Emtpy = <any>"Emtpy",
    WaitingForApproval = <any>"WaitingForApproval",
    Waiting = <any>"Waiting",
    Approved = <any>"Approved",
    Reject = <any>"Reject",
    Canceled = <any>"Canceled",
    OverStock_Reject = <any>"OverStock_Reject",
    Sent_To_Hangfire = <any>"Sent_To_Hangfire",
    CAP_WarehouseApproved = <any>"CAP_WarehouseApproved",
    CAP_CenterApproved = <any>"CAP_CenterApproved",
    CAP_Waiting = <any>"CAP_Waiting",
    CAP_RegionApproved = <any>"CAP_RegionApproved",
    CAP_Canceled_OverStock = <any>"CAP_Canceled_OverStock",
    CAP_InTransferLocation = <any>"CAP_InTransferLocation",
    CAP_InTransfer = <any>"CAP_InTransfer",
    CAP_ToPrepare = <any>"CAP_ToPrepare",
    CAP_Prepared = <any>"CAP_Prepared",
    CAP_Preparing = <any>"CAP_Preparing",
    CAP_ToReturn = <any>"CAP_ToReturn",
    CAP_AcceptanceOfGoods = <any>"CAP_AcceptanceOfGoods",
    CAP_Approved = <any>"CAP_Approved",
    CAP_RaftanIndirildi = <any>"CAP_RaftanIndirildi",
    CAP_RaftanIndiriliyor = <any>"CAP_RaftanIndiriliyor",
    CAP_OnShipment = <any>"CAP_OnShipment",
    CAP_OrderCancellation = <any>"CAP_OrderCancellation",
    CAP_Completed = <any>"CAP_Completed",
    CAP_OrderNotReceived = <any>"CAP_OrderNotReceived",
    CAP_OrderHasBeenTaken = <any>"CAP_OrderHasBeenTaken",
    CAP_OrderTaking = <any>"CAP_OrderTaking",
    CAP_Delivered = <any>"CAP_Delivered",
    CAP_NotDelivered = <any>"CAP_NotDelivered",
    CAP_Collected = <any>"CAP_Collected",
    CAP_Cancelled = <any>"CAP_Cancelled",
}

export enum OrderApprovedDtoStatus {
    None = <any>"None",
    Approved_P = <any>"Approved_P",
    NoStock_NT = <any>"NoStock_NT",
    NoRelatedBigSizeProduct_NT = <any>"NoRelatedBigSizeProduct_NT",
}

export enum PosmProductionTaskDtoGorevTipi {
    Uretim_Gorevi = <any>"Uretim_Gorevi",
    Tasarim_Gorevi = <any>"Tasarim_Gorevi",
}

export enum PosmProductionTaskDtoDurum {
    Bekliyor = <any>"Bekliyor",
    Devam_Ediyor = <any>"Devam_Ediyor",
    Revize_Bekleniyor = <any>"Revize_Bekleniyor",
    Tamamlandi = <any>"Tamamlandi",
}

export enum SRProcessTrackingDtoStatus {
    Completed = <any>"Completed",
    NotCompleted = <any>"NotCompleted",
    HasError = <any>"HasError",
}

export enum SRRouteResolveExcelUploadDtoVehicleType {
    Car = <any>"Car",
    Truck = <any>"Truck",
    Van = <any>"Van",
    Pedestrian = <any>"Pedestrian",
}

export enum SRRouteOptimumBasicExcelUploadDtoVehicleType {
    Car = <any>"Car",
    Truck = <any>"Truck",
    Van = <any>"Van",
    Pedestrian = <any>"Pedestrian",
}

export enum SRRouteOptimumDailyFireDtoVehicleType {
    Car = <any>"Car",
    Truck = <any>"Truck",
    Van = <any>"Van",
    Pedestrian = <any>"Pedestrian",
}

export enum TransportBidInfoDtoIhaleDurum {
    Acik = <any>"Acik",
    Teklif_Vermesi_Bekleniyor = <any>"Teklif_Vermesi_Bekleniyor",
    Teklif_Girisi_Yapildi = <any>"Teklif_Girisi_Yapildi",
    Ilgilenmiyor = <any>"Ilgilenmiyor",
    Teklif_Onaylandi = <any>"Teklif_Onaylandi",
}

export enum UpdateTransportBidDtoTeklifDurum {
    Acik = <any>"Acik",
    Teklif_Vermesi_Bekleniyor = <any>"Teklif_Vermesi_Bekleniyor",
    Teklif_Girisi_Yapildi = <any>"Teklif_Girisi_Yapildi",
    Ilgilenmiyor = <any>"Ilgilenmiyor",
    Teklif_Onaylandi = <any>"Teklif_Onaylandi",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}